import React, { useEffect, useRef, useState } from 'react';
import { FormGroup, Label, ModalBody, ModalFooter, Spinner, ModalHeader, Input, Modal, Button, Table } from 'reactstrap';
import moment from 'moment';
import { useSelector } from "react-redux";
import { Col, Row, Button as Btn, Modal as Mdl } from 'reactstrap';
import { insert, selectValues, sendEmailToNotify, sendFormEmail, printStandardEmail, update, validarCNPJ, validarCPF } from '../../../utils/fc';
import Select from '../../Template/Input/Select';
import oikosApi from '../../../services/oikos';
import powerAppsApi from '../../../services/powerapps';
import qs from 'qs';
import { notifyError, notifySuccess, notifyWarning } from '../../../utils/notify';
import { resolveContratacaoEmailDestino, buildContratacaoHashFiles, getAnexosParaPdf, fetchCompraCotacaoById, resolveCompraCotacaoDataForHash, mergeCandidatoContext, fetchContrFornRecordForEmail, fetchContratadoRecord } from './contrFornEmailUtils';
import { buildContrFornMinutaData } from './contrFornMinutaData';
import { buildMinutaContratoPdfDoc } from './buildMinutaContratoPdf';
import { Box, IconButton, TextareaAutosize, Tooltip, Typography } from '@mui/material';
import { Add, Delete, Edit, InfoOutlined, MonetizationOn, PostAdd, Refresh } from '@material-ui/icons';
import currencyFormatter from '../../../utils/currencyFormatter';
import MaskedInput from '../../Template/Input/MaskedInput';
import DatePicker from 'react-datepicker'
import ModalFormAddFornecedor from "../ModalFormAddFornecedor/ModalFormAddFornecedor";
import ModalFormEditFornecedor from "../ModalFormEditFornecedor/ModalFormEditFornecedor";
import AddFiles from '../../Template/Files/AddFilesNoForm';
import MaterialReactTable from 'material-react-table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import {linkOikosLabPaginas, linkOikosLabVM, linkProducaoPaginas, linkProducaoVM} from '../../../utils/linksOikos/link'
import ModalConfirmacao from '../ModalConfirmacao/ModalConfirmacao';
import {
  preloadStandaloneOrcItem,
  submitStandaloneContrForn,
} from './standaloneContrFornSubmit';
import {
  buildContrFornDocumentosObrigatoriosPayload,
  buildContrFornExtendedFieldsPayload,
  buildContrFornExtendedFieldsPdfRows,
  buildContrFornStandardExtraPdfRows,
  formatDocumentosObrigatoriosLabels,
  getContrFornDocumentosObrigatoriosIds,
  parseMultiSelectIds,
  resolveDocumentosObrigatoriosOptionsForMinuta,
  fetchDocumentosObrigatoriosTpDocumentoOptions,
  CONTR_FORN_ATENDER_TERCEIROS_OPTIONS,
  CONTR_FORN_BENEFICIOS_OPTIONS,
  CONTR_FORN_COMPROVACAO_COBRANCA_OPTIONS,
  CONTR_FORN_COMPROVACAO_EXECUCAO_OPTIONS,
  CONTR_FORN_CONTINUIDADE_OPTIONS,
  CONTR_FORN_CONTRATO_ADITIVO_ANTERIOR_OPTIONS,
  CONTR_FORN_DATA_PAGAMENTO_OPTIONS,
  CONTR_FORN_MODELO_COBRANCA_OPTIONS,
  CONTR_FORN_PRESENCA_RECORRENTE_OPTIONS,
  CONTR_FORN_REEMBOLSO_DESPESAS_OPTIONS,
  CONTR_FORN_UTILIZAR_EQUIPE_PREPOSTOS_OPTIONS,
  getEmptyContrFornExtendedFields,
  isEquipeOrcItemById,
  parseContrFornBeneficios,
} from './contrFornExtendedFields';
import {
  buildContrFornPrefillFromInfo,
  buildSupplierValidationContrFornUpdateData,
  fetchCompraCotacaoWithInfo,
  getPropostaValorFromInfo,
  parseCompraCotacaoInfo,
  upsertFornecedorFromCompraCotacaoInfo,
} from './contrFornCompraCotacaoInfo';
import ContrFornValidationStepCadastro from './ContrFornValidationStepCadastro';
import ContrFornValidationEntregaveis from './ContrFornValidationEntregaveis';
import ContrFornValidationMinutaPreview from './ContrFornValidationMinutaPreview';
import {
  buildResumoOrcamentoPorAno,
  getAnoVigenteDateRange,
  isVigenciaDatasInvalidas,
} from '../../Template/Doc/orcResumoOrcamentarioUtils';
import { MEIO_PGTO } from '../../../pages/MeusFornecedores/contratosTabHelpers';
import {
  ensureMinutaDocumentoVincToContrForn,
  findMinutaFornecedorDocFromInfo,
  isTpMinutaFornecedor,
  mergeMinutaFornecedorDocIntoHashIds,
  TP_DOCUMENTO_MINUTA_CONTRATO,
} from './contrFornMinutaRules';
import {
  formatPgtoPrazoDiasDisplay,
  hasEntregavelDtPrev,
  hydrateEntregaveisFromParcelas,
  isEntregaveisSumComplete,
  isPrazoDiasInformado,
  normalizeEntregavelAgendamentoFields,
  persistPgtoPrazoDias,
  renumberEntregaveis,
  validarEntregaveisParaSubmit,
} from './contrFornEntregaveisUtils';
import { COMPRA_STATUS_ABERTO, COMPRA_STATUS_INFO_ENVIADA, PEDIDO_COMPRA_STATUS_CONTRATADO, isPedidoCompraComContrato } from '../../Template/Doc/compraCotacaoTableUtils';
import ConsoleButton from '../../TestPhaseComponent/ConsoleButton';
import {
  EMAIL_TEXT_ENVIAR_FORNECEDOR,
  EMAIL_TEXT_REENVIAR_FORNECEDOR,
  buildPedidoCompraEmailContextHtml,
} from '../ModalFormDisparoEmails/pedidoCompraEmailTexts';
import {
  carregarMensagemTemplatePublicada,
  renderizarCorpoMensagemTemplate,
} from '../../../utils/mensagemTemplate';

import {
  CONTR_FORN_STATUS_ATIVO,
  CONTR_FORN_STATUS_EM_APROVACAO,
  CONTR_FORN_STATUS_EM_ASSINATURA,
  buildCriarContratoDiretoCompraCotacaoInfo,
  needsContrFornApproval,
} from './contrFornApprovalRules';
import { buildFormContratacaoFornecedorLinkByContrFornId } from './sendContratacaoFornecedorEmailByContrFornId';

const MENSAGEM_TEMPLATE_HAND_SOLICITACAO_ORC_ITEM = 'solicitacao_criacao_orc_item';
const EMAIL_SOLICITACAO_ORC_ITEM = 'juliano.moreira@ecossis.com.br';

const getLoggedUserDisplayName = (authUser) => String(
  authUser?.pf_nomeExibicao
  || authUser?.pf_nome
  || authUser?.displayName
  || authUser?.name
  || `${authUser?.givenName || ''} ${authUser?.surname || ''}`.trim()
  || '',
).trim();

const ORC_ITEM_VLR_ANUAL_FIELD = "(SELECT vw_orcDotAnual.somaOrcDotAno FROM vw_orcDotAnual WHERE vw_orcDotAnual.orcItem_id = viewRubr_OrcItem.orcItem_id AND vw_orcDotAnual.ano = YEAR(CURDATE()) LIMIT 1)";

const formatOrcItemSelectLabel = (item) => {
  const baseLabel = String(item?.label || '').trim();
  if (!baseLabel) return '';
  const vlr = Number(item?.vlrAnual);
  const valorFormatado = currencyFormatter.format(Number.isFinite(vlr) ? vlr : 0);
  return `${baseLabel} - ${valorFormatado}`;
};

const ModalFormContrForn = ( props ) => {

  const isControlled = props.isOpen != null
  const hideTipoContrato = Boolean(props.hideTipoContrato)
  const hideTipoContratado = Boolean(props.hideTipoContratado)
  const hideContratado = Boolean(props.hideContratado)
  const hideContratoValorFixoOpcao = Boolean(props.hideContratoValorFixoOpcao)
  const hideContratoDiaFixoPagamentoOpcao = Boolean(props.hideContratoDiaFixoPagamentoOpcao)
  const hideContratoRenovacaoAutomaticaOpcao = Boolean(props.hideContratoRenovacaoAutomaticaOpcao)
  const hideContratoNfUnicaOpcao = Boolean(props.hideContratoNfUnicaOpcao)
  const hideContratoMaoObraLocalOpcao = Boolean(props.hideContratoMaoObraLocalOpcao)
  const hideObservacao = Boolean(props.hideObservacao)
  const hideDocumentoContrato = Boolean(props.hideDocumentoContrato)
  const hideContratoObjeto = Boolean(props.hideContratoObjeto)
  const hideContratoDetalhamento = Boolean(props.hideContratoDetalhamento)
  const showContratante = Boolean(props.showContratante)
  const hideParcelasOrcamentoTable = Boolean(props.hideParcelasOrcamentoTable)
  const hideParcelasTable = Boolean(props.hideParcelasTable)

  const isCentroDeCustoObrigatorio = () => !props.centroDeCustoDisabled
  const isOrcItemObrigatorio = () => !props.orcItemDisabled

  const [isModalOpen, setIsModalOpen] = useState(false);
  const modalIsOpen = isControlled ? props.isOpen : isModalOpen;
  const [isEditValorModalOpen, setIsEditValorModalOpen] = useState(false);
  const [selPfsFornecedor, setSelPfsFornecedor] = React.useState([]);
  const [selPjsFornecedor, setSelPjsFornecedor] = React.useState([]);
  const [selContratantes, setSelContratantes] = React.useState([]);
  const [selPfs, setSelPfs] = React.useState([]);
  const [selPjs, setSelPjs] = React.useState([]);
  const [selStatus, setSelStatus] = React.useState([]);
  const [selTipoContrato, setSelTipoContrato] = React.useState([]);
  const [selOrcItems, setSelOrcItems] = React.useState([]);
  const [selProjetos, setSelProjetos] = React.useState([]);
  const [isFetchingProjectLoading, setIsFetchingProjectLoading] = React.useState(false);
  const [selTiposDeMinuta, setSelTiposDeMinuta] = React.useState([]);
  const [selMinutaMod, setSelMinutaMod] = React.useState([]);
  const [selPixTp, setSelPixTp] = React.useState([]);
  const [selCartoesCredito, setSelCartoesCredito] = React.useState([]);
  const [selMeioPgto, setSelMeioPgto] = React.useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingSubmit, setLoadingSumbit] = useState(false);
  const [listaDotacoes, setListaDotacoes] = useState([]);
  const [listaParcelas, setListaParcelas] = React.useState([]);
  const [entregavelDraftParcela, setEntregavelDraftParcela] = React.useState(null);
  const [listaParcelasPersistidas, setListaParcelasPersistidas] = React.useState([]);
  const [parcelasMensaisFixas, setParcelasMensaisFixas] = React.useState(false);
  const [parcelasExcluidasIds, setParcelasExcluidasIds] = React.useState([]);
  const [bdrosOrcItem, setBdrosOrcItem] = React.useState([]);
  const [isAvisoSemBdroOpen, setIsAvisoSemBdroOpen] = React.useState(false);
  const [isAvisoSaldoMensalOpen, setIsAvisoSaldoMensalOpen] = React.useState(false);
  const [isAvisoNfVaziaOpen, setIsAvisoNfVaziaOpen] = React.useState(false);
  const submitOptionsRef = useRef({});
  const getBasePedidoCompraData = () => {
    const base = props.pedidoCompraData || {};
    return {
      ...base,
      // No fluxo Equipe a linha pai é vaga: orcItem_id vem da vaga, não necessariamente do pedidoCompra
      orcItem_id: base.orcItem_id
        || props.compraCotacaoData?.orcItem_id
        || null,
    };
  };
  const getBaseCompraCotacaoData = () => ({
    ...(props.compraCotacaoData || {}),
    orcItem_id: props.compraCotacaoData?.orcItem_id
      || props.pedidoCompraData?.orcItem_id
      || null,
  });
  const getInitialDocumentosObrigatorios = () => parseMultiSelectIds(
    props.contrFornData?.contrForn_documentosObrigatorios
    ?? props.contrFornData?.contrFornDocumentosObrigatorios
    ?? props.pedidoCompraData?.vaga_documentosObrigatorios
    ?? props.pedidoCompraData?.vagaDocumentosObrigatorios,
  );

  const getInitialBeneficios = () => parseContrFornBeneficios(
    props.contrFornData?.contrForn_beneficios
    ?? props.pedidoCompraData?.vaga_beneficios
    ?? props.pedidoCompraData?.vagaBeneficios,
  );

  const getEmptyContrFornData = () => ({
    contrForn_dtPgtoFixa: 0,
    orcItem_id: Number(
      props.compraCotacaoData?.orcItem_id
      || props.pedidoCompraData?.orcItem_id,
    ) || null,
    contrForn_vlrGlobal: props.compraCotacaoData?.compraCotacao_vlr ?? props.compraCotacaoData?.candidato_valorSalario ?? props.pedidoCompraData?.pedidoCompra_vlrLimite ?? props.pedidoCompraData?.vaga_salarioMaximo ?? 0,
    contrForn_dtVigIni: props.pedidoCompraData?.pedidoCompra_dtVigIni || props.pedidoCompraData?.vaga_dtVigIni || null,
    contrForn_dtVigFim: props.pedidoCompraData?.pedidoCompra_dtVigFim || props.pedidoCompraData?.vaga_dtVigFim || null,
    contrForn_contratante: 1,
    contrForn_documentosObrigatorios: getInitialDocumentosObrigatorios(),
    contrForn_beneficios: getInitialBeneficios(),
  });
  const [pedidoCompraData, setPedidoCompraData] = React.useState(getBasePedidoCompraData);
  const [contrFornData, setContrFornData] = React.useState(getEmptyContrFornData);
  const [compraCotacaoData, setCompraCotacaoData] = React.useState(getBaseCompraCotacaoData);
  const [requiresCompraCotacaoEmailInput, setRequiresCompraCotacaoEmailInput] = React.useState(false);
  const [indexToEdit, setIndexToEdit] = React.useState(null);
  const [selCentroDeCusto, setSelCentroDeCusto] = React.useState([]);
  const { user } = useSelector(state => state.auth);
  const [page, setPage] = React.useState(1);
  const [filesContrForn, setFilesContrForn] = React.useState([]);
  const [sourceDocuments, setSourceDocuments] = React.useState([]);
  const [isLoadingSourceDocuments, setIsLoadingSourceDocuments] = React.useState(false);
  const [nfUnicaFilesContrForn, setNfUnicaFilesContrForn] = React.useState([]);
  const [nfCompraFilesContrForn, setNfCompraFilesContrForn] = React.useState([]);
  const [propostaComercialFilesContrForn, setPropostaComercialFilesContrForn] = React.useState([]);
  const [valorCadaParcelaCotacaoRapida, setValorCadaParcelaCotacaoRapida] = React.useState('');
  const [pageContrFornForm, setPageContrFornForm] = React.useState(1);
  const [validationStep, setValidationStep] = React.useState(1);
  const [validationChecks, setValidationChecks] = React.useState({ 2: false });
  const [step1ValidationAnswer, setStep1ValidationAnswer] = React.useState(null);
  const [step1RejectionJustification, setStep1RejectionJustification] = React.useState('');
  const [supplierParte, setSupplierParte] = React.useState(null);
  const [isUpsertingSupplierParte, setIsUpsertingSupplierParte] = React.useState(false);
  const [parsedCompraCotacaoInfo, setParsedCompraCotacaoInfo] = React.useState(null);
  const [isSupplierValidationFlowActive, setIsSupplierValidationFlowActive] = React.useState(false);
  const [valoresLimites, setValoresLimites] = React.useState([]);
  const [selFornecedores, setSelFornecedores] = React.useState([]);
  const [documentosObrigatoriosOptions, setDocumentosObrigatoriosOptions] = React.useState([]);
  const [isSolicitarOrcItemOpen, setIsSolicitarOrcItemOpen] = React.useState(false);
  const [mensagemSolicitacaoOrcItem, setMensagemSolicitacaoOrcItem] = React.useState('');
  const [sendingSolicitacaoOrcItem, setSendingSolicitacaoOrcItem] = React.useState(false);
  const [isCopyingFormLink, setIsCopyingFormLink] = React.useState(false);
  const [isRefreshingOrcDots, setIsRefreshingOrcDots] = React.useState(false);
  const userPodeDigitarDiaVencimento = user?.perm_id === 1;
  const diasVencimentoPadraoOptions = React.useMemo(() => [{label: '10', value: 10},{label: '20', value: 20}], []);
  const trimContrFornDesc = (fallback = '') => (
    typeof contrFornData.contrForn_desc === 'string' ? contrFornData.contrForn_desc : fallback
  );

  const showEquipeContrFornFields = React.useMemo(
    () => isEquipeOrcItemById(selOrcItems, contrFornData.orcItem_id),
    [selOrcItems, contrFornData.orcItem_id],
  );

  const isFormularioSemContrato = React.useMemo(() => {
    const pedido = props.pedidoCompraData || pedidoCompraData || {};
    const pedidoCompraId = Number(pedido.pedidoCompra_id) || 0;
    if (!pedidoCompraId) return false;
    return !isPedidoCompraComContrato(pedido);
  }, [
    props.pedidoCompraData?.pedidoCompra_id,
    props.pedidoCompraData?.pedidoCompra_comContrato,
    pedidoCompraData?.pedidoCompra_id,
    pedidoCompraData?.pedidoCompra_comContrato,
  ]);

  const isMeioPagamentoPix = isFormularioSemContrato
    && Number(contrFornData.meioPgto_id) === MEIO_PGTO.PIX;

  const isMeioPagamentoCartaoCredito = isFormularioSemContrato
    && Number(contrFornData.meioPgto_id) === MEIO_PGTO.CARTAO;

  const handleOpenSolicitarOrcItem = () => {
    setMensagemSolicitacaoOrcItem('');
    setIsSolicitarOrcItemOpen(true);
  };

  const handleCloseSolicitarOrcItem = () => {
    if (sendingSolicitacaoOrcItem) return;
    setIsSolicitarOrcItemOpen(false);
  };

  const handleEnviarSolicitacaoOrcItem = async () => {
    const nomeSolicitante = getLoggedUserDisplayName(user);
    const mensagem = String(mensagemSolicitacaoOrcItem || '').trim();

    if (!nomeSolicitante) {
      notifyError('Não foi possível identificar o usuário logado.');
      return;
    }
    if (!mensagem) {
      notifyError('Informe a mensagem da solicitação.');
      return;
    }

    try {
      setSendingSolicitacaoOrcItem(true);
      const { versao, variaveis } = await carregarMensagemTemplatePublicada(
        MENSAGEM_TEMPLATE_HAND_SOLICITACAO_ORC_ITEM,
      );
      const html = renderizarCorpoMensagemTemplate({
        corpoHtml: versao.mensagemTemplateVersao_corpoHtml,
        variaveis,
        contexto: {
          solicitacao: {
            nome_solicitante: nomeSolicitante,
            mensagem,
          },
        },
      });
      const enviado = await sendEmailToNotify(
        EMAIL_SOLICITACAO_ORC_ITEM,
        versao.mensagemTemplateVersao_assunto,
        printStandardEmail(html),
        '',
      );
      if (!enviado) throw new Error('Falha ao enviar a solicitação.');
      notifySuccess('Solicitação enviada com sucesso.');
      setMensagemSolicitacaoOrcItem('');
      setIsSolicitarOrcItemOpen(false);
    } catch (error) {
      console.error('Erro ao enviar solicitação de item orçamentário:', error);
      notifyError(error?.message || 'Não foi possível enviar a solicitação.');
    } finally {
      setSendingSolicitacaoOrcItem(false);
    }
  };

  const isSupplierInfoValidationMode = React.useMemo(
    () => Boolean(props.supplierInfoValidationMode) || isSupplierValidationFlowActive,
    [props.supplierInfoValidationMode, isSupplierValidationFlowActive],
  );

  const isAguardandoInfoFornecedor = React.useMemo(() => {
    if (isSupplierInfoValidationMode) return false;
    if (!Number(contrFornData?.contrForn_id)) return false;
    if (Number(contrFornData?.contrFornStatus_id) !== 1) return false;
    const pedido = props.pedidoCompraData || pedidoCompraData || {};
    if (!isPedidoCompraComContrato(pedido)) return false;
    const compraStatus = Number(
      compraCotacaoData?.compraStatus_id ?? props.compraCotacaoData?.compraStatus_id,
    );
    return compraStatus !== COMPRA_STATUS_INFO_ENVIADA;
  }, [
    isSupplierInfoValidationMode,
    contrFornData?.contrForn_id,
    contrFornData?.contrFornStatus_id,
    props.pedidoCompraData,
    pedidoCompraData,
    compraCotacaoData?.compraStatus_id,
    props.compraCotacaoData?.compraStatus_id,
  ]);

  const isValidationContractStep = isSupplierInfoValidationMode && validationStep === 2;

  const isMinutaFornecedor = React.useMemo(
    () => {
      const tpMinutaId = Number(
        contrFornData.tpMinuta_id
        ?? props.contrFornData?.tpMinuta_id
        ?? compraCotacaoData?.tpMinuta_id
        ?? props.compraCotacaoData?.tpMinuta_id,
      ) || 0;
      const tpMinutaNome = String(
        contrFornData.tpMinuta_nome
        || props.contrFornData?.tpMinuta_nome
        || compraCotacaoData?.tpMinuta_nome
        || props.compraCotacaoData?.tpMinuta_nome
        || '',
      ).trim();

      if (tpMinutaNome) {
        const label = tpMinutaNome.toLowerCase();
        if (label === 'fornecedor' || label.includes('fornecedor')) return true;
      }

      return isTpMinutaFornecedor(tpMinutaId, selTiposDeMinuta);
    },
    [
      contrFornData.tpMinuta_id,
      contrFornData.tpMinuta_nome,
      props.contrFornData?.tpMinuta_id,
      props.contrFornData?.tpMinuta_nome,
      compraCotacaoData?.tpMinuta_id,
      compraCotacaoData?.tpMinuta_nome,
      props.compraCotacaoData?.tpMinuta_id,
      props.compraCotacaoData?.tpMinuta_nome,
      selTiposDeMinuta,
    ],
  );

  const effectiveHideTipoContrato = isValidationContractStep
    ? true
    : isSupplierInfoValidationMode
      ? false
      : hideTipoContrato;
  const effectiveHideTipoContratado = isValidationContractStep
    ? true
    : isSupplierInfoValidationMode
      ? false
      : hideTipoContratado;
  const effectiveHideContratado = isValidationContractStep
    ? true
    : isSupplierInfoValidationMode
      ? false
      : hideContratado;
  const effectiveHideContratoObjeto = isValidationContractStep
    ? true
    : isSupplierInfoValidationMode
      ? false
      : hideContratoObjeto;
  const effectiveHideContratoDetalhamento = isSupplierInfoValidationMode
    ? false
    : hideContratoDetalhamento;
  const effectiveHideObservacao = isValidationContractStep
    ? true
    : isSupplierInfoValidationMode
      ? false
      : hideObservacao;
  const effectiveHideDocumentoContrato = isValidationContractStep
    ? true
    : isSupplierInfoValidationMode
      ? false
      : hideDocumentoContrato;
  const isContratacaoFromPedidoCompra = Boolean(
    Number(props.pedidoCompraData?.pedidoCompra_id || pedidoCompraData?.pedidoCompra_id)
  ) && !Boolean(props.standalone) && !isSupplierInfoValidationMode;
  const effectiveHideParcelasTable = isValidationContractStep
    ? true
    : isSupplierInfoValidationMode
      ? false
      : (hideParcelasTable && !isFormularioSemContrato);
  const effectiveHideParcelasOrcamentoTable = isValidationContractStep
    ? false
    : isSupplierInfoValidationMode
      ? true
      : (isContratacaoFromPedidoCompra && isFormularioSemContrato)
        ? false
        : hideParcelasOrcamentoTable;
  const effectiveShowDocumentosObrigatoriosField = isValidationContractStep
    ? false
    : isSupplierInfoValidationMode
      ? false
      : !isFormularioSemContrato;

  const valorGlobalProposta = React.useMemo(
    () => getPropostaValorFromInfo(parsedCompraCotacaoInfo) ?? 0,
    [parsedCompraCotacaoInfo],
  );

  const listaEntregaveisEfetiva = React.useMemo(() => {
    if (!entregavelDraftParcela) return listaParcelas;
    return [...listaParcelas, entregavelDraftParcela];
  }, [listaParcelas, entregavelDraftParcela]);

  const parcelasTabelaOrcamento = isSupplierInfoValidationMode
    ? listaEntregaveisEfetiva
    : listaParcelas;

  const entregaveisValidos = !isSupplierInfoValidationMode
    || (
      (!entregavelDraftParcela || Boolean(entregavelDraftParcela._draftPersistivel))
      && isEntregaveisSumComplete(listaEntregaveisEfetiva, valorGlobalProposta)
    );

  const allValidationChecksComplete = step1ValidationAnswer === 'sim'
    && validationChecks[2]
    && entregaveisValidos;

  const getCamposObrigatoriosContrForn = () => {
    if (isValidationContractStep) {
      return effectiveHideContratoDetalhamento
        ? {}
        : { contrForn_detalhamento: 'Detalhamento' };
    }

    return {
      contrForn_desc: 'Descrição',
      ...(effectiveHideTipoContratado ? {} : { contrForn_parteTab: 'Tipo de contratado' }),
      ...(effectiveHideContratado ? {} : { contrForn_parteId: 'Contratado' }),
      ...(effectiveHideContratoObjeto ? {} : { contrForn_obj: 'Objeto' }),
      contrForn_vlrGlobal: 'Valor global',
      contrForn_dtVigIni: 'Data de início da vigência',
      contrForn_dtVigFim: 'Data de fim da vigência',
      ...(effectiveHideTipoContrato ? {} : { contrFornTp_id: 'Tipo de contrato' }),
      ...(effectiveHideContratoDetalhamento ? {} : { contrForn_detalhamento: 'Detalhamento' }),
      ...(showContratante ? { contrForn_contratante: 'Contratante' } : {}),
      ...(isFormularioSemContrato ? { meioPgto_id: 'Meio de pagamento' } : {}),
      ...(isMeioPagamentoPix ? {
        pixTp_id: 'Tipo de chave',
        contrForn_chavePix: 'Chave PIX',
      } : {}),
      ...(isMeioPagamentoCartaoCredito ? { conta_id: 'Cartão' } : {}),
    };
  };

  const setValidationCheck = (step, checked) => {
    setValidationChecks((prev) => ({ ...prev, [step]: checked }));
  };

  const handleValidationNext = async () => {
    if (validationStep >= 2) return;

    if (validationStep === 1) {
      if (step1ValidationAnswer !== 'sim') return;

      const info = parsedCompraCotacaoInfo;
      if (!info) {
        notifyError('Informações do fornecedor não encontradas.');
        return;
      }

      setIsUpsertingSupplierParte(true);
      try {
        const parte = await upsertFornecedorFromCompraCotacaoInfo(info, user.pf_id);
        setSupplierParte(parte);
        setContrFornData((prev) => ({
          ...prev,
          contrForn_parteTab: parte.contrForn_parteTab,
          contrForn_parteId: parte.contrForn_parteId,
        }));
        setValidationStep(2);
      } catch (error) {
        notifyError(error?.message || 'Não foi possível salvar os dados cadastrais do fornecedor.');
      } finally {
        setIsUpsertingSupplierParte(false);
      }
      return;
    }

    setValidationStep(validationStep + 1);
  };

  const handleValidationPrevious = () => {
    if (validationStep > 1) setValidationStep(validationStep - 1);
  };

  const handleValidationGoToStep = (step) => {
    const normalizedStep = Number(step);
    if (normalizedStep === 2 && step1ValidationAnswer !== 'sim') return;
    if (normalizedStep >= 1 && normalizedStep <= 2) {
      setValidationStep(normalizedStep);
    }
  };

  const handleStep1ValidationAnswerChange = (answer) => {
    setStep1ValidationAnswer(answer);
    if (answer !== 'nao') {
      setStep1RejectionJustification('');
    }
    if (answer !== 'sim') {
      setSupplierParte(null);
    }
  };

  const handleRejectSupplierValidation = async () => {
    const justificativa = String(step1RejectionJustification || '').trim();
    if (!justificativa) {
      notifyError('Informe a justificativa da rejeição.');
      return;
    }

    const compraCotacaoId = Number(
      compraCotacaoData?.compraCotacao_id || props.compraCotacaoData?.compraCotacao_id,
    );
    if (!compraCotacaoId) {
      notifyError('Não foi possível identificar a cotação.');
      return;
    }

    const currentInfo = parsedCompraCotacaoInfo
      || parseCompraCotacaoInfo(
        compraCotacaoData?.compraCotacao_info || props.compraCotacaoData?.compraCotacao_info,
      );
    if (!currentInfo) {
      notifyError('Não foi possível ler as informações da cotação.');
      return;
    }

    const updatedCompraCotacaoInfo = JSON.stringify({
      ...currentInfo,
      justificativa_rejeicao: justificativa,
    });

    setLoadingSumbit(true);
    try {
      await oikosApi.post('/', {
        action: 'update',
        table: 'compraCotacao',
        data: {
          compraCotacao_id: compraCotacaoId,
          compraStatus_id: 8,
          compraCotacao_info: updatedCompraCotacaoInfo,
        },
      });

      await handleSendRejeicaoFornecedorEmail(justificativa, {
        ...compraCotacaoData,
        ...props.compraCotacaoData,
        compraCotacao_id: compraCotacaoId,
        compraCotacao_info: updatedCompraCotacaoInfo,
        compraStatus_id: 8,
      });

      notifySuccess('Informações do fornecedor rejeitadas.');
      if (props.onSuccess) await props.onSuccess();
      handleClickCloseModal();
    } catch (error) {
      console.error('Erro ao rejeitar informações do fornecedor:', error);
      notifyError('Erro ao rejeitar as informações do fornecedor.');
    } finally {
      setLoadingSumbit(false);
    }
  };

  React.useEffect(() => {
    if (!modalIsOpen || documentosObrigatoriosOptions.length > 0) return undefined;

    fetchDocumentosObrigatoriosForSelect();
    return undefined;
  }, [modalIsOpen, documentosObrigatoriosOptions.length]);

  const isRejectedContractResubmit = React.useMemo(() => {
    const statusId = Number(
      contrFornData?.contrFornStatus_id
      ?? props.contrFornData?.contrFornStatus_id
      ?? compraCotacaoData?.contrFornStatus_id
      ?? props.compraCotacaoData?.contrFornStatus_id,
    );
    return statusId === 11;
  }, [
    contrFornData?.contrFornStatus_id,
    props.contrFornData?.contrFornStatus_id,
    compraCotacaoData?.contrFornStatus_id,
    props.compraCotacaoData?.contrFornStatus_id,
  ]);

  const isReadOnlyMode = React.useMemo(() => {
    if (isRejectedContractResubmit) return false;
    if (props.readOnly) return true;
    const statusId = Number(compraCotacaoData?.compraStatus_id ?? props.compraCotacaoData?.compraStatus_id);
    return statusId === 2;
  }, [isRejectedContractResubmit, props.readOnly, compraCotacaoData?.compraStatus_id, props.compraCotacaoData?.compraStatus_id]);

  const isCompraCotacaoContratacao = React.useMemo(() => {
    const compraCotacaoId = Number(
      compraCotacaoData?.compraCotacao_id
      || props?.compraCotacaoData?.compraCotacao_id,
    ) || 0;
    return !props.standalone && compraCotacaoId > 0;
  }, [
    props.standalone,
    compraCotacaoData?.compraCotacao_id,
    props?.compraCotacaoData?.compraCotacao_id,
  ]);

  const shouldSkipFornecedorEmail = isFormularioSemContrato;

  const requiresApprovalByValue = needsContrFornApproval(contrFornData.contrForn_vlrGlobal);
  const primarySubmitLabel = requiresApprovalByValue
    ? 'Enviar para aprovação'
    : (isFormularioSemContrato
      ? 'Confirmar contratação'
      : (isRejectedContractResubmit ? 'Reenviar para fornecedor' : 'Enviar para fornecedor'));

  // Destino do e-mail = pf_emailProf / pj_emailPrin do Contratado.
  // Não exibir nem persistir compraCotacao_emailInteressado neste fluxo.
  const showEmailFornecedor = false;

  const renderContrFornSelectField = (label, fieldKey, options) => (
    <Col sm={4} key={fieldKey}>
      <FormGroup>
        <Label>{label}</Label>
        <Select
          classNamePrefix="select2-selection"
          placeholder="Selecione"
          isClearable
          isDisabled={isReadOnlyMode}
          value={options.find((option) => option.value === contrFornData[fieldKey]) || null}
          options={options}
          onChange={(option) => setContrFornData({ ...contrFornData, [fieldKey]: option?.value ?? null })}
        />
      </FormGroup>
    </Col>
  );
  const b64urlEncode = (str) => {
    const bytes = new TextEncoder().encode(str);
    let bin = "";
    bytes.forEach((b) => {
      bin += String.fromCharCode(b);
    });
    return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  };

  const linkASerUsadoPaginas = linkProducaoPaginas;
  const linkASerUsadoVM = linkProducaoVM;

 /*  const linkASerUsadoPaginas = linkOikosLabPaginas;
  const linkASerUsadoVM = linkOikosLabVM; */

  const montaURLFormContratacaoFornecedor = (data) => {
    const vmBase = linkASerUsadoVM + "formContratacaoFornecedor.php#";
    const hash = b64urlEncode(JSON.stringify(data));
    return vmBase + hash;
  };

  const parseYearMonthValue = (value) => {
    if (!value || typeof value !== 'string') return null;
    const [year, month] = value.split('-').map(Number);
    if (!Number.isFinite(year) || !Number.isFinite(month)) return null;
    return (year * 100) + month;
  };
  //const [contrFornEventos, setContrFornEventos] = React.useState([]);
  //const [bdros, setBdros] = React.useState([]);

  const filteredDotacoes = React.useMemo(() => {
    const { contrForn_dtVigIni, contrForn_dtVigFim } = contrFornData;
    const dtIni = contrForn_dtVigIni;
    const dtFim = contrForn_dtVigFim;
    if (!dtIni || !dtFim) return [];
    const startYM = parseYearMonthValue(dtIni);
    const endYM = parseYearMonthValue(dtFim);
    if (startYM == null || endYM == null) return [];
    if (startYM > endYM) return [];
    return listaDotacoes.filter(({ orcDot_data }) => {
      const itemYM = parseYearMonthValue(orcDot_data);
      if (itemYM == null) return false;
      return itemYM >= startYM && itemYM <= endYM;
    });
  }, [
    contrFornData.contrForn_dtVigIni,
    contrFornData.contrForn_dtVigFim,
    listaDotacoes
  ]);

  const filteredValoresLimites = React.useMemo(() => {
    const { contrForn_dtVigIni, contrForn_dtVigFim } = contrFornData;
    const dtIni = contrForn_dtVigIni;
    const dtFim = contrForn_dtVigFim;
    if (!dtIni || !dtFim) return [];
    const startYM = parseYearMonthValue(dtIni);
    const endYM = parseYearMonthValue(dtFim);
    if (startYM == null || endYM == null) return [];
    if (startYM > endYM) return [];
    return valoresLimites.filter(({ mes }) => {
      const itemYM = parseYearMonthValue(mes);
      if (itemYM == null) return false;
      return itemYM >= startYM && itemYM <= endYM;
    });
  }, [
    contrFornData.contrForn_dtVigIni,
    contrFornData.contrForn_dtVigFim,
    valoresLimites
  ]);

  const resumoOrcamentoPorAno = React.useMemo(() => (
    buildResumoOrcamentoPorAno({
      dtIni: contrFornData.contrForn_dtVigIni,
      dtFim: contrFornData.contrForn_dtVigFim,
      listaDotacoes,
      valoresLimites,
    })
  ), [
    contrFornData.contrForn_dtVigIni,
    contrFornData.contrForn_dtVigFim,
    listaDotacoes,
    valoresLimites,
  ]);

  const hasVigenciaDatesForResumo = Boolean(
    contrFornData.contrForn_dtVigIni && contrFornData.contrForn_dtVigFim,
  );

  const isVigenciaDatasInvalidasMemo = React.useMemo(() => (
    isVigenciaDatasInvalidas(
      contrFornData.contrForn_dtVigIni,
      contrFornData.contrForn_dtVigFim,
    )
  ), [
    contrFornData.contrForn_dtVigIni,
    contrFornData.contrForn_dtVigFim,
  ]);


  React.useEffect(() => {
    if (!contrFornData.contrForn_dtPgtoFixa || !contrFornData.contrForn_diaVencPgtos) return;

    const diaVencimento = Number(contrFornData.contrForn_diaVencPgtos);
    const diaVencimentoValido = userPodeDigitarDiaVencimento
      ? diaVencimento >= 1 && diaVencimento <= 31
      : diasVencimentoPadraoOptions.some(option => option.value === diaVencimento);

    if (!diaVencimentoValido) {
      setContrFornData(prev => ({...prev, contrForn_diaVencPgtos: null}));
    }
  }, [contrFornData.contrForn_dtPgtoFixa, contrFornData.contrForn_diaVencPgtos, diasVencimentoPadraoOptions, userPodeDigitarDiaVencimento]);

  const getValorEmCentavos = (valor) => Math.round(Number(valor || 0) * 100);

  const getBdroOptionLabel = (bdro) => {
    const vencimento = bdro.bdro_dtVenc ? ` - ${moment(bdro.bdro_dtVenc).format('DD/MM/YYYY')}` : '';
    const descricao = bdro.bdro_desc ? ` - ${bdro.bdro_desc}` : '';
    return `Borderô ${bdro.bdro_id}${vencimento} - ${currencyFormatter.format(Number(bdro.bdro_vlr || 0))}${descricao}`;
  }

  const bdrosVinculaveis = React.useMemo(() => bdrosOrcItem.filter((bdro) => {
    const bdroSelecionado = listaParcelas.some((parcela) => Number(parcela.bdro_id) === Number(bdro.bdro_id));
    return bdroSelecionado || (!bdro.bdro_tabRef && !bdro.bdro_tabId);
  }), [bdrosOrcItem, listaParcelas]);

  const getBdroOptionsParaParcela = (rowIndex) => {
    const bdrosSelecionadosEmOutrasParcelas = listaParcelas
      .filter((_, index) => index !== rowIndex)
      .map((parcela) => Number(parcela.bdro_id))
      .filter(Boolean);

    return bdrosVinculaveis
      .filter((bdro) => Number(bdro.bdro_id) === Number(listaParcelas[rowIndex]?.bdro_id) || !bdrosSelecionadosEmOutrasParcelas.includes(Number(bdro.bdro_id)))
      .map((bdro) => ({...bdro, value: bdro.bdro_id, label: getBdroOptionLabel(bdro)}));
  }

  /*
  const filteredEventos = React.useMemo(() => {
    const { contrForn_dtVigIni, contrForn_dtVigFim } = contrFornData;
    if (!contrForn_dtVigIni || !contrForn_dtVigFim) return [];
    const [sY, sM] = contrForn_dtVigIni.split("-").map(Number);
    const [eY, eM] = contrForn_dtVigFim.split("-").map(Number);
    const startYM = sY * 100 + sM;
    const endYM   = eY * 100 + eM;
    if (startYM > endYM) return [];
    return contrFornEventos.filter(({ contrFornEvento_dtPrev }) => {
      const [y, m] = contrFornEvento_dtPrev.split("-").map(Number);
      const itemYM = y * 100 + m;
      return itemYM >= startYM && itemYM <= endYM;
    });
  }, [
    contrFornData.contrForn_dtVigIni,
    contrFornData.contrForn_dtVigFim,
    contrFornEventos
  ]);

  const filteredBdros = React.useMemo(() => {
    const { contrForn_dtVigIni, contrForn_dtVigFim } = contrFornData;
    if (!contrForn_dtVigIni || !contrForn_dtVigFim) return [];
    const [sY, sM] = contrForn_dtVigIni.split("-").map(Number);
    const [eY, eM] = contrForn_dtVigFim.split("-").map(Number);
    const startYM = sY * 100 + sM;
    const endYM   = eY * 100 + eM;
    if (startYM > endYM) return [];
    return bdros.filter(({ bdro_dtVenc, bdro_tabRef, bdro_tabId }) => {
      if (!bdro_dtVenc) {
        notifyError('Algum bordero não possui data de vencimento.');
        return false;
      }
      if (!bdro_tabRef && !bdro_tabId) {
        const [y, m] = bdro_dtVenc.split("-").map(Number);
        const itemYM = y * 100 + m;
        return itemYM >= startYM && itemYM <= endYM;
      }
    });
  }, [
    contrFornData.contrForn_dtVigIni,
    contrFornData.contrForn_dtVigFim,
    contrFornEventos
  ]);

  const valorLimite = React.useMemo(() => {
    let somaDotacoes = 0;
    if (filteredDotacoes.length) {
      somaDotacoes = filteredDotacoes
        .reduce((acc, { orcDot_valor }) => acc + Number(orcDot_valor || 0), 0);
    }
    console.log('somaDotacoes', somaDotacoes);
    let somaJaAlocadoEventos = 0;
    if (filteredEventos.length) {
      somaJaAlocadoEventos = filteredEventos
        .reduce((acc, { contrFornEvento_vlr }) => acc + Number(contrFornEvento_vlr || 0), 0);
    }
    console.log('somaJaAlocadoEventos', somaJaAlocadoEventos);
    let somaJaAlocadoBdros = 0;
    if (filteredBdros.length) {
      somaJaAlocadoBdros = filteredBdros
        .reduce((acc, { bdro_vlr }) => acc + Number(bdro_vlr || 0), 0);
    }
    console.log('somaJaAlocadoBdros', somaJaAlocadoBdros);
    return Number((somaDotacoes - somaJaAlocadoEventos - somaJaAlocadoBdros).toFixed(2));
  }, [filteredDotacoes, filteredEventos, filteredBdros]);
  */

  const columnsParcelas = [
    {
      accessorKey: 'contrFornEvento_num',
      header: 'Número',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.contrFornEvento_num) {
          return row.contrFornEvento_num;
        } else {
          return 'Sem número';
        }
      },
    },
    {
      accessorKey: 'contrFornEvento_desc',
      header: 'Descrição',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.contrFornEvento_desc) {
          return row.contrFornEvento_desc;
        } else {
          return 'Sem Descrição';
        }
      },
    },
    {
      accessorKey: 'contrFornEvento_pgtoPrazoDias',
      header: 'Prazo (Dias)',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => formatPgtoPrazoDiasDisplay(row.contrFornEvento_pgtoPrazoDias),
    },
    {
      accessorKey: 'contrFornEvento_dtPrev',
      header: 'Data',
      accessorFn: (row) => {
        if (row.contrFornEvento_dtPrev) {
          return moment(row.contrFornEvento_dtPrev, 'YYYY-MM-DD').toDate();
        } else {
          return null;
        }
      },
      size: 100,
      sortingFn: 'datetime',
      Cell: ({ cell, row }) => {
        if (row.original.contrFornEvento_dtPrev) {
          return moment(cell.getValue()).format('DD/MM/YYYY')
        }
      }, // Format Date for display
    },
    {
      accessorKey: 'contrFornEvento_vlr',
      header: 'Valor',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.contrFornEvento_vlr) {
          return parseFloat(row.contrFornEvento_vlr).toFixed(2);
        } else {
          return '0.00';
        }
      },
      Cell: ({ cell, row }) => {
        const value = cell.getValue();
        return value ? `R$ ${parseFloat(value).toFixed(2).replace('.', ',')}` : 'Sem Valor';
      },
    },
    ...(!isReadOnlyMode ? [{
      header: 'Ações',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <Tooltip title="Excluir parcela">
          <IconButton
            aria-label="Excluir"
            color="error"
            onClick={() => {
              handleDeleteParcela(row.original.contrFornEvento_num, row.original.contrFornEvento_id);
            }}
          >
            <Delete style={{ width: '18px', height: '18px' }} />
          </IconButton>
        </Tooltip>
      ),
    }] : []),
  ]

  const checkCamposObrigatorios = () => {

    const camposObrigatorios = {
      pedidoCompra_desc: 'Descrição',
      pedidoCompra_num: 'Nº contrato',
      //contrForn_parteTab: 'Tipo de contratado',
      //contrForn_parteId: 'Contratado',
      compra_dtDesejadaConclusao: 'Data desejada conclusão',
      compra_dtLimiteEntrega: 'Data Limite Entrega',
      compra_dtEntrega: 'Data entrega',
      compra_vlrLimite: 'Valor limite',
    }

    for (const campo of Object.keys(camposObrigatorios)) {
      if (!pedidoCompraData[campo]) {
        notifyError(`O campo "${camposObrigatorios[campo]}" é obrigatório.`)
        return false
      }
    }
    return true
  }

  function handleDeleteParcela(contrFornEvento_num, contrFornEvento_id) {
    if (isReadOnlyMode) return;

    const parcelaRemovida = listaParcelas.find(
      (parcela) => Number(parcela.contrFornEvento_num) === Number(contrFornEvento_num),
    );
    const eventoId = contrFornEvento_id ?? parcelaRemovida?.contrFornEvento_id;

    if (eventoId) {
      setParcelasExcluidasIds((prev) => (
        prev.includes(eventoId) ? prev : [...prev, eventoId]
      ));
    }

    setListaParcelas((prev) => prev
    .filter((t) => Number(t.contrFornEvento_num) !== Number(contrFornEvento_num))
    .map((p, i) => {
      const parcelaPattern = /^Parcela \d+$/; // matches "Parcela 1", "Parcela 2"...
      return {
        ...p,
        contrFornEvento_num: i + 1,
        contrFornEvento_desc: parcelaPattern.test(p.contrFornEvento_desc)
          ? `Parcela ${i + 1}`
          : p.contrFornEvento_desc,
      };
    }));
  }

  const comparaValorGlobalComParcelas = (parcelas = listaParcelas) => {
    if (effectiveHideParcelasTable) return true;

    const somaParcelas = parcelas.reduce((acc, parcela) => {
      return acc + (parcela.contrFornEvento_vlr || 0);
    }, 0);

    if (Number(Number(somaParcelas).toFixed(2)) > Number(Number(contrFornData.contrForn_vlrGlobal).toFixed(2))) {
      notifyError('A soma das parcelas não pode ser maior que o valor global do contrato.');
      return false;
    }
    if (Number(Number(somaParcelas).toFixed(2)) !== Number(Number(contrFornData.contrForn_vlrGlobal).toFixed(2))) {
      notifyError('A soma das parcelas deve ser igual ao valor global do contrato.');
      return false;
    }
    return true;
  }

  function verificaDocumentoContrForn(submitOptions = {}) {
    if (isFormularioSemContrato && !isSupplierInfoValidationMode) {
      if (nfCompraFilesContrForn.length <= 0 && !submitOptions.ignorarAvisoNfVazia) {
        setIsAvisoNfVaziaOpen(true);
        return false;
      }
      return true;
    }

    if (isSupplierInfoValidationMode) {
      return true;
    }

    if (effectiveHideDocumentoContrato && (hideContratoNfUnicaOpcao || !contrFornData.contrForn_umaNFParaTodasAsParcela)) {
      return true;
    }

    if (!effectiveHideDocumentoContrato && filesContrForn.length <= 0) {
      notifyError('Campo de "Documento do contrato" vazio')
      return false;
    }

    if (!hideContratoNfUnicaOpcao && contrFornData.contrForn_umaNFParaTodasAsParcela && nfUnicaFilesContrForn.length <= 0) {
      notifyError('Campo de "Nota Fiscal única" vazio')
      return false;
    }
    return true;
  }

  function getParcelaDtPrevParaSaldo(parcela) {
    if (parcela?.contrFornEvento_dtPrev) {
      return String(parcela.contrFornEvento_dtPrev).slice(0, 10);
    }
    if (
      isPrazoDiasInformado(parcela?.contrFornEvento_pgtoPrazoDias)
      && contrFornData.contrForn_dtVigIni
    ) {
      return moment(contrFornData.contrForn_dtVigIni)
        .add(Number.parseInt(String(parcela.contrFornEvento_pgtoPrazoDias), 10), 'days')
        .format('YYYY-MM-DD');
    }
    return null;
  }

  function verificarSaldoMensalValido(listaValoresLimites, listaParcelasCheck) {
    for (const valorLimite of listaValoresLimites) {
      const monthRef = (valorLimite.mes || valorLimite.orcDot_data).slice(0, 7); // 'YYYY-MM'

      const somaParcelasMes = listaParcelasCheck
        .filter((parcela) => {
          const dtPrev = getParcelaDtPrevParaSaldo(parcela);
          return dtPrev ? dtPrev.slice(0, 7) === monthRef : false;
        })
        .reduce((acc, cur) => acc + Number(cur.contrFornEvento_vlr || 0), 0);

      // Compara
      const diferenca = Number(Number(valorLimite.disponivel).toFixed(2)) - Number(somaParcelasMes.toFixed(2));

      if (diferenca < 0) {
        return false;
      }
    }

    return true;
  }

  function verificaDataVigencia(parcelas = listaParcelas) {
    const dtVigIni = contrFornData.contrForn_dtVigIni;
    const dtVigFim = contrFornData.contrForn_dtVigFim;

    if (!dtVigIni || !dtVigFim) {
      notifyError('Informe a data de início e de fim da vigência.');
      return false;
    }

    if (new Date(dtVigFim) < new Date(dtVigIni)) {
      notifyError('Data de início da vigência é maior que data de fim.')
      return false;
    }

    if (effectiveHideParcelasTable) return true;

    const parcelasForaDoIntervaloDeVigencia = parcelas.filter(p => {
      if (!p.contrFornEvento_dtPrev) return false;
      return (
        new Date(p.contrFornEvento_dtPrev) > new Date(dtVigFim)
        || new Date(p.contrFornEvento_dtPrev) < new Date(dtVigIni)
      );
    });
    if(parcelasForaDoIntervaloDeVigencia.length > 0) {
      notifyError('Alguma parcela está com Data Prevista fora do intervalo de vigência do contrato.')
      return false;
    }

    return true;
  }

  const handleClickOpenModal = () => {
    if (!isControlled) setIsModalOpen(true)
  };

  const handleClickCloseModal = () => {
    if (!isControlled) setIsModalOpen(false)
    else props.onClose?.()
    setIsAvisoSemBdroOpen(false);
    setIsAvisoSaldoMensalOpen(false);
    setIsAvisoNfVaziaOpen(false);
    setPage(1);
    setValidationStep(1);
    setValidationChecks({ 2: false });
    setStep1ValidationAnswer(null);
    setStep1RejectionJustification('');
    setParsedCompraCotacaoInfo(null);
    setIsSupplierValidationFlowActive(false);
    setListaParcelasPersistidas([]);
    setParcelasExcluidasIds([]);
    setBdrosOrcItem([]);
    setSourceDocuments([]);
    setIsLoadingSourceDocuments(false);
  }

  const shouldLoadSupplierValidationData = () => (
    Boolean(props.supplierInfoValidationMode) || isSupplierValidationFlowActive
  );

  const activateSupplierValidationFromCompraCotacao = (compraCotacaoRow) => {
    if (props.supplierInfoValidationMode) return;

    const parsed = parseCompraCotacaoInfo(compraCotacaoRow?.compraCotacao_info);
    const isPendingSupplierValidation = Number(compraCotacaoRow?.compraStatus_id)
      === COMPRA_STATUS_INFO_ENVIADA;

    if (!isPendingSupplierValidation) return;

    setIsSupplierValidationFlowActive(true);
    setParsedCompraCotacaoInfo(parsed);
    setValidationStep(1);
    setValidationChecks({ 2: false });
    setStep1ValidationAnswer(null);
    setStep1RejectionJustification('');
  };

  const resetModalFormState = () => {
    setPedidoCompraData(getBasePedidoCompraData());
    setCompraCotacaoData(getBaseCompraCotacaoData());
    setRequiresCompraCotacaoEmailInput(false);
    setContrFornData(getEmptyContrFornData());
    setListaParcelas([]);
    setEntregavelDraftParcela(null);
    setListaParcelasPersistidas([]);
    setParcelasExcluidasIds([]);
    setFilesContrForn([]);
    setSourceDocuments([]);
    setIsLoadingSourceDocuments(false);
    setNfUnicaFilesContrForn([]);
    setNfCompraFilesContrForn([]);
    setPropostaComercialFilesContrForn([]);
    setValorCadaParcelaCotacaoRapida('');
    setPage(1);
    setPageContrFornForm(1);
    setValidationStep(1);
    setValidationChecks({ 2: false });
    setStep1ValidationAnswer(null);
    setStep1RejectionJustification('');
    setParsedCompraCotacaoInfo(
      shouldLoadSupplierValidationData()
        ? parseCompraCotacaoInfo(props.compraCotacaoData?.compraCotacao_info)
        : null,
    );
    setIsSupplierValidationFlowActive(false);
    setIsCopyingFormLink(false);
    setBdrosOrcItem([]);
  }

  const loadExistingContrForn = async (contrFornId) => {
    setIsLoading(true);
    let loadedCompraCotacao = null;

    try {
      await fetchDocumentosObrigatoriosForSelect();

      const resContract = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'contrForn',
        data: { contrForn_id: contrFornId },
      })}`);

      const fullData = resContract?.data?.[0];

      if (!fullData) {
        notifyError('Contrato nao localizado.');
        return;
      }

      let centroDeCustoId = null;
      let projetoId = null;

      if (fullData.orcItem_id) {
        try {
          const resOrcItem = await oikosApi.get(`/?${qs.stringify({
            action: 'get',
            table: 'viewRubr_OrcItem',
            fields: { 
              nivel2_id: 'nivel2_id', 
              nivel3_id: 'orcRubr_id',
              "(SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1)" : "pf_id",
              "(SELECT projAtuacao_id FROM projAtuacao WHERE projAtuacao.projAtuacao_id = (SELECT projAtuacao_id FROM propOrcItem WHERE propOrcItem.propOrcItem_id = (SELECT propOrcItem_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1) LIMIT 1) LIMIT 1)" : "projAtuacao_id"
            },
            data: { orcItem_id: fullData.orcItem_id },
          })}`);

          if (resOrcItem?.data?.length > 0) {
            centroDeCustoId = resOrcItem.data[0].nivel2_id;
            projetoId = resOrcItem.data[0].orcRubr_id;
          }
        } catch (error) {
          console.log('Sem hierarquia orcamentaria para o contrato:', error);
        }

        await getOrcDots(fullData.orcItem_id);
      }

      if (fullData.compraCotacao_id) {
        try {
          const resCompraCotacao = await oikosApi.get(`/?${qs.stringify({
            action: 'get',
            table: 'compraCotacao',
            data: { compraCotacao_id: fullData.compraCotacao_id },
          })}`);

          const compraCotacao = resCompraCotacao?.data?.[0];
          loadedCompraCotacao = compraCotacao || null;
          if (compraCotacao) {
            setCompraCotacaoData(mergeCandidatoContext(
              {
                ...compraCotacao,
                orcItem_id: compraCotacao.orcItem_id || fullData.orcItem_id,
              },
              props.compraCotacaoData,
            ));

            let pedidoCompra = props.pedidoCompraData || null;
            if (compraCotacao.pedidoCompra_id) {
              const resPedidoCompra = await oikosApi.get(`/?${qs.stringify({
                action: 'get',
                table: 'pedidoCompra',
                data: { pedidoCompra_id: compraCotacao.pedidoCompra_id },
              })}`);

              pedidoCompra = resPedidoCompra?.data?.[0] || pedidoCompra;
              if (pedidoCompra) {
                setPedidoCompraData({
                  ...pedidoCompra,
                  orcItem_id: pedidoCompra.orcItem_id || fullData.orcItem_id,
                });
              }
            }

            activateSupplierValidationFromCompraCotacao(compraCotacao);
          }
        } catch (error) {
          console.error('Erro ao carregar compraCotacao/pedidoCompra do contrato:', error);
        }
      }

      setContrFornData({
        ...fullData,
        centroDeCustoRubr_id: centroDeCustoId,
        orcRubr_id: projetoId,
        orcItem_id: fullData.orcItem_id ? Number(fullData.orcItem_id) : null,
        contrForn_parteId: fullData.contrForn_parteId ? Number(fullData.contrForn_parteId) : null,
        contrFornTp_id: fullData.contrFornTp_id ? Number(fullData.contrFornTp_id) : null,
        tpMinuta_id: fullData.tpMinuta_id ? Number(fullData.tpMinuta_id) : null,
        minutaMod_id: fullData.minutaMod_id ? Number(fullData.minutaMod_id) : null,
        pixTp_id: fullData.pixTp_id ? Number(fullData.pixTp_id) : null,
        contrForn_chavePix: fullData.contrForn_chavePix || null,
        conta_id: fullData.conta_id ? Number(fullData.conta_id) : null,
        meioPgto_id: fullData.meioPgto_id ? Number(fullData.meioPgto_id) : null,
        contrForn_vlrGlobal: fullData.contrForn_vlrGlobal ? Number(fullData.contrForn_vlrGlobal) : 0,
        contrForn_vlrFixo: Number(fullData.contrForn_vlrFixo || 0),
        contrForn_dtPgtoFixa: Number(fullData.contrForn_dtPgtoFixa || 0),
        contrForn_renovacaoAutomatica: Number(fullData.contrForn_renovacaoAutomatica || 0),
        contrForn_umaNFParaTodasAsParcela: Number(fullData.contrForn_umaNFParaTodasAsParcela || 0),
        contrForn_maoObraLocal: Number(fullData.contrForn_maoObraLocal || 0),
        contrForn_beneficios: parseContrFornBeneficios(fullData.contrForn_beneficios),
        contrForn_documentosObrigatorios: getContrFornDocumentosObrigatoriosIds(fullData),
      });

      try {
        const resParcelas = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'contrFornEvento',
          data: {
            contrForn_id: contrFornId,
            contrFornEvento_ativo: 1,
          },
          order: 'contrFornEvento_num',
        })}`);

        const parcelasPersistidas = resParcelas?.data || [];
        const parsedInfo = parseCompraCotacaoInfo(
          loadedCompraCotacao?.compraCotacao_info
          || props.compraCotacaoData?.compraCotacao_info
          || compraCotacaoData?.compraCotacao_info,
        );
        const shouldHydrateEntregaveis = Number(loadedCompraCotacao?.compraStatus_id)
          === COMPRA_STATUS_INFO_ENVIADA;
        const parcelasCarregadas = shouldHydrateEntregaveis
          ? hydrateEntregaveisFromParcelas(
            parcelasPersistidas,
            getPropostaValorFromInfo(parsedInfo) ?? 0,
          )
          : parcelasPersistidas;

        setListaParcelas(parcelasCarregadas);
        setListaParcelasPersistidas(parcelasCarregadas);
        setParcelasExcluidasIds([]);
      } catch (error) {
        console.error('Erro ao carregar parcelas do contrato:', error);
        setListaParcelas([]);
        setListaParcelasPersistidas([]);
        setParcelasExcluidasIds([]);
      }

      setIsModalOpen(true);
    } catch (error) {
      console.error('Erro ao carregar contrato para edicao:', error);
      notifyError('Erro ao carregar contrato.');
    } finally {
      setIsLoading(false);
    }
  }

  const limparBdrosDasParcelas = () => {
    setListaParcelas((prev) => prev.map(({ bdro_id, contrFornEvento_vincularBdroExistente, ...parcela }) => parcela));
  }

  const fetchBdrosForOrcItem = async (orcItemId) => {
    if (!orcItemId) {
      setBdrosOrcItem([]);
      return;
    }

    try {
      const resBdros = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'bdro',
        data: {
          orcItem_id: orcItemId,
          bdro_ativo: 1,
        },
        order: 'bdro_dtVenc'
      })}`);

      const bdrosSemVinculo = (resBdros.data || []).filter((bdro) => !bdro.bdro_tabRef && !bdro.bdro_tabId);
      setBdrosOrcItem(bdrosSemVinculo);
    } catch (error) {
      console.error("Failed to fetch bdros:", error);
      setBdrosOrcItem([]);
    }
  }

  const getOrcDots = async (orcItemId) => {
    if (!orcItemId) {
      setListaDotacoes([]);
      setValoresLimites([]);
      return false;
    }

    try {
      await fetchBdrosForOrcItem(orcItemId);
      const resOrcDot = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'orcDot',
        data: {
          orcItem_id: orcItemId,
          orcDot_ativo: 1
        }
      })}`)
      setListaDotacoes((resOrcDot.data || []).sort((a, b) => String(a.orcDot_data).localeCompare(String(b.orcDot_data))));

      /*
      const resContrForns = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'contrForn',
        data: {
          orcItem_id: orcItemId,
        }
      })}`)
      console.log('resContrForns', resContrForns.data);

      let txtContrForn_ids = ''
      for (let index = 0; index < resContrForns.data.length; index++) {
        const element = resContrForns.data[index];
        if (index < resContrForns.data.length - 1) {
          txtContrForn_ids = txtContrForn_ids + `${element.contrForn_id}, `
        } else {
          txtContrForn_ids = txtContrForn_ids + `${element.contrForn_id}`
        }
      }

      console.log('txtContrForn_ids', txtContrForn_ids)

      let resContrFornEventos = {data: []};

      if (resContrForns.data.length > 0) {
        resContrFornEventos = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'contrFornEvento',
          data: {
            contrForn_id: `!IN! (${txtContrForn_ids})`,
          }
        })}`);

       console.log(resContrFornEventos.data);

       setContrFornEventos(resContrFornEventos.data);
      }

      setContrFornEventos([]);

      const resBdros = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'bdro',
        data: {
          orcItem_id: orcItemId,
          bdro_ativo: 1,
        }
      })}`)
      console.log('resBdros', resBdros.data);
      setBdros(resBdros.data);
      */

      const verificaBody = {
        acao: 'verificar_disponibilidade_orcItem',
        orcItem_id: orcItemId,
      }

      const res = await powerAppsApi.post('/', verificaBody, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      })

      setValoresLimites(res.data);

      console.log('Valores limites:', res.data);
      return true;
    } catch (error) {
      console.error("Failed to fetch parcelas details:", error);
      return false;
    }
  };

  const handleRefreshOrcDots = async () => {
    const orcItemId = Number(contrFornData.orcItem_id) || 0;
    if (!orcItemId || isRefreshingOrcDots) return;

    setIsRefreshingOrcDots(true);
    try {
      const ok = await getOrcDots(orcItemId);
      if (ok) notifySuccess('Saldo orçamentário atualizado.');
      else notifyError('Não foi possível atualizar o saldo orçamentário.');
    } finally {
      setIsRefreshingOrcDots(false);
    }
  };

  const fetchCentroDeCustoForSelect = async () => {
    try {
      let dataOrcRubr = {
        orcRubr_ativo: 1,
        orcRubr_mae: `!IN!(1, 2)`
      }

      const resTodosCentrosDeCustos = await selectValues('orcRubr', 'orcRubr_id', 'orcRubr_nome', dataOrcRubr);

      const sortedTodosCentrosDeCustos = (resTodosCentrosDeCustos).sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      });

      setSelCentroDeCusto(sortedTodosCentrosDeCustos);
    } catch (error) {
      console.error("Error fetching orcItems:", error);
      return [];
    }
  }

  const resolveOrcItemIdForContrato = async () => {
    const fromProps = Number(
      props.compraCotacaoData?.orcItem_id
      || props.pedidoCompraData?.orcItem_id
      || compraCotacaoData?.orcItem_id
      || pedidoCompraData?.orcItem_id,
    ) || 0;
    if (fromProps) return fromProps;

    // Fluxo Equipe: se a linha pai é vaga e o pedidoCompra veio sem orcItem, buscar na vaga
    const vagaId = Number(props.pedidoCompraData?.vaga_id || pedidoCompraData?.vaga_id) || 0;
    if (vagaId) {
      try {
        const resVaga = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'vaga',
          data: { vaga_id: vagaId },
        })}`);
        return Number(resVaga?.data?.[0]?.orcItem_id) || 0;
      } catch (error) {
        console.error('Erro ao resolver orcItem_id a partir da vaga:', error);
      }
    }

    return 0;
  };

  async function loadData() {
    setIsLoading(true);
    try {
      await Promise.all([
        fetchStatusForSelect(),
        fetchTiposDeContratoForSelect(),
        fetchPfsFornecedoresForSelect(),
        fetchPjsFornecedoresForSelect(),
        fetchContratantesForSelect(),
        fetchCentroDeCustoForSelect(),
        fetchPfsForSelect(),
        fetchTiposDeMinutaForSelect(),
        fetchMinutaModForSelect(),
        fetchPixTpForSelect(),
        fetchMeioPgtoForSelect(),
        fetchCartoesCreditoForSelect(),
        fetchFornecedoresForSelect(),
        fetchDocumentosObrigatoriosForSelect(),
      ]);

      if (props.standalone && props.proj_orcRubrId) {
        await fetchProjectsForSelect();
        await fetchOrcItemsForSelect(14, props.proj_orcRubrId);
        setContrFornData(prev => ({
          ...prev,
          centroDeCustoRubr_id: 14,
          orcRubr_id: props.proj_orcRubrId,
        }));
      }

      const normalizedOrcItemId = await resolveOrcItemIdForContrato();

      if (props.standalone && normalizedOrcItemId) {
        await preloadStandaloneOrcItem({
          setIsLoading,
          fetchProjectsForSelect,
          fetchOrcItemsForSelect,
          getOrcDots,
          setSelProjetos,
          setSelOrcItems,
          setContrFornData,
        }, normalizedOrcItemId);
      } else if (!props.standalone || !props.proj_orcRubrId) {
        let selectedCentroDeCustoId = null;
        let selectedOrcRubrId = null;

        if (normalizedOrcItemId) {
          let hierarchyOrcItemRow = null;
          try {
            const resOrcItem = await oikosApi.get(`/?${qs.stringify({
              action: 'get',
              table: 'viewRubr_OrcItem',
              fields: {
                nivel2_id: 'nivel2_id',
                nivel3_id: 'orcRubr_id',
                orcItem_id: 'value',
                item_orcamentario: 'label',
                [ORC_ITEM_VLR_ANUAL_FIELD]: 'vlrAnual',
              },
              data: { orcItem_id: normalizedOrcItemId },
            })}`);

            if (resOrcItem?.data?.length > 0) {
              hierarchyOrcItemRow = resOrcItem.data[0];
              selectedCentroDeCustoId = Number(hierarchyOrcItemRow.nivel2_id) || null;
              selectedOrcRubrId = Number(hierarchyOrcItemRow.orcRubr_id) || null;
            }
          } catch (error) {
            console.log('Sem hierarquia orcamentaria para a contratacao:', error);
          }

          // Itens orçamentários já inativos (ex: item de Equipe cuja vaga já foi aberta)
          // somem da viewRubr_OrcItem. Nesse caso usamos a hierarquia já resolvida pelo
          // chamador (OrcItemsProj) e recebida via props, para não deixar os campos vazios.
          if (!selectedCentroDeCustoId) {
            selectedCentroDeCustoId = Number(
              props.compraCotacaoData?.centroDeCustoRubr_id
              || props.pedidoCompraData?.centroDeCustoRubr_id,
            ) || null;
          }
          if (!selectedOrcRubrId) {
            selectedOrcRubrId = Number(
              props.compraCotacaoData?.orcRubr_id
              || props.pedidoCompraData?.orcRubr_id,
            ) || null;
          }
          if (!hierarchyOrcItemRow && selectedCentroDeCustoId) {
            hierarchyOrcItemRow = {
              value: normalizedOrcItemId,
              label: props.compraCotacaoData?.orcItem_label
                || props.pedidoCompraData?.orcItem_label
                || `Item #${normalizedOrcItemId}`,
              nivel2_id: selectedCentroDeCustoId,
              orcRubr_id: selectedOrcRubrId,
            };
          }

          if (Number(selectedCentroDeCustoId) === 14 && selectedOrcRubrId) {
            await fetchProjectsForSelect();
            await fetchOrcItemsForSelect(14, selectedOrcRubrId);
          } else if (selectedCentroDeCustoId) {
            await fetchOrcItemsForSelect(selectedCentroDeCustoId);
          } else {
            await fetchOrcItemsForSelect();
          }

          // Garante o item atual na lista do select (mesmo se filtro/ativo divergir)
          if (hierarchyOrcItemRow) {
            setSelOrcItems((prev) => {
              const list = Array.isArray(prev) ? prev : [];
              if (list.some((item) => Number(item.value) === Number(normalizedOrcItemId))) {
                return list;
              }
              return [
                ...list,
                {
                  ...hierarchyOrcItemRow,
                  value: Number(hierarchyOrcItemRow.value || normalizedOrcItemId),
                  label: hierarchyOrcItemRow.label || `Item #${normalizedOrcItemId}`,
                  nivel2_id: selectedCentroDeCustoId,
                  orcRubr_id: selectedOrcRubrId,
                  nivel3_id: selectedOrcRubrId,
                },
              ];
            });
          }
        } else {
          await fetchOrcItemsForSelect();
        }

        setContrFornData((prev) => ({
          ...prev,
          orcItem_id: normalizedOrcItemId || null,
          centroDeCustoRubr_id: selectedCentroDeCustoId || prev.centroDeCustoRubr_id || null,
          orcRubr_id: selectedOrcRubrId || prev.orcRubr_id || null,
          contrForn_desc: prev.contrForn_desc
            || props.compraCotacaoData?.compraCotacao_desc
            || props.pedidoCompraData?.pedidoCompra_desc
            || props.pedidoCompraData?.vaga_descricao
            || compraCotacaoData.compraCotacao_desc
            || pedidoCompraData.pedidoCompra_desc
            || '',
          contrForn_vlrGlobal: prev.contrForn_vlrGlobal
            ?? props.compraCotacaoData?.compraCotacao_vlr
            ?? props.compraCotacaoData?.candidato_valorSalario
            ?? props.pedidoCompraData?.pedidoCompra_vlrLimite
            ?? props.pedidoCompraData?.vaga_salarioMaximo
            ?? compraCotacaoData.compraCotacao_vlr
            ?? compraCotacaoData.candidato_valorSalario
            ?? pedidoCompraData.pedidoCompra_vlrLimite
            ?? 0,
          contrForn_dtVigIni: prev.contrForn_dtVigIni
            || props.pedidoCompraData?.pedidoCompra_dtVigIni
            || props.pedidoCompraData?.vaga_dtVigIni
            || pedidoCompraData.pedidoCompra_dtVigIni
            || null,
          contrForn_dtVigFim: prev.contrForn_dtVigFim
            || props.pedidoCompraData?.pedidoCompra_dtVigFim
            || props.pedidoCompraData?.vaga_dtVigFim
            || pedidoCompraData.pedidoCompra_dtVigFim
            || null,
          contrForn_parteTab: prev.contrForn_parteTab
            || props.compraCotacaoData?.compraCotacao_parteTab
            || compraCotacaoData.compraCotacao_parteTab,
          contrForn_parteId: prev.contrForn_parteId
            || props.compraCotacaoData?.compraCotacao_parteId
            || compraCotacaoData.compraCotacao_parteId,
        }));

        if (normalizedOrcItemId) {
          setPedidoCompraData((prev) => ({
            ...prev,
            ...(props.pedidoCompraData || {}),
            orcItem_id: normalizedOrcItemId,
          }));
          setCompraCotacaoData((prev) => ({
            ...prev,
            ...(props.compraCotacaoData || {}),
            orcItem_id: normalizedOrcItemId,
          }));
          await getOrcDots(normalizedOrcItemId);
        }
      }

      const compraCotacaoId = Number(props.compraCotacaoData?.compraCotacao_id);
      if (compraCotacaoId && !props.loadExistingContrFornOnOpen) {
        const fetchedCompraCotacao = await fetchCompraCotacaoById(compraCotacaoId);
        if (fetchedCompraCotacao) {
          const mergedCompraCotacao = mergeCandidatoContext(
            {
              ...fetchedCompraCotacao,
              orcItem_id: fetchedCompraCotacao.orcItem_id
                || props.compraCotacaoData?.orcItem_id
                || props.pedidoCompraData?.orcItem_id,
            },
            props.compraCotacaoData,
          );
          setCompraCotacaoData((prev) => ({
            ...mergedCompraCotacao,
            orcItem_id: Number(mergedCompraCotacao.orcItem_id)
              || Number(prev.orcItem_id)
              || Number(props.compraCotacaoData?.orcItem_id)
              || Number(props.pedidoCompraData?.orcItem_id)
              || null,
          }));
          setRequiresCompraCotacaoEmailInput(
            !String(mergedCompraCotacao.compraCotacao_emailInteressado || '').trim(),
          );
        } else {
          setRequiresCompraCotacaoEmailInput(
            !String(props.compraCotacaoData?.compraCotacao_emailInteressado || '').trim(),
          );
        }
      }

      {
        const pedidoCompraId = Number(
          props.pedidoCompraData?.pedidoCompra_id
          || props.compraCotacaoData?.pedidoCompra_id,
        ) || 0;
        const vagaId = Number(props.pedidoCompraData?.vaga_id || pedidoCompraData?.vaga_id) || 0;
        const vagaPrefill = await fetchVagaDocumentosObrigatoriosForPedido({
          pedidoCompraId,
          vagaId,
        });

        setContrFornData((prev) => {
          const currentDocumentos = getContrFornDocumentosObrigatoriosIds(prev);
          const currentBeneficios = parseContrFornBeneficios(prev.contrForn_beneficios);
          const nextDocumentos = currentDocumentos.length > 0
            ? currentDocumentos
            : (vagaPrefill.documentos || []);
          const nextBeneficios = currentBeneficios.length > 0
            ? currentBeneficios
            : (vagaPrefill.beneficios || []);

          if (
            currentDocumentos.length > 0
            && currentBeneficios.length > 0
          ) {
            return prev;
          }

          return {
            ...prev,
            ...(currentDocumentos.length > 0 ? {} : {
              contrForn_documentosObrigatorios: nextDocumentos,
            }),
            ...(currentBeneficios.length > 0 ? {} : {
              contrForn_beneficios: nextBeneficios,
            }),
          };
        });
      }
    } finally {
      setIsLoading(false);
    }
  }

  const loadSupplierValidationData = async () => {
    const compraCotacaoId = Number(
      props.compraCotacaoData?.compraCotacao_id || compraCotacaoData?.compraCotacao_id,
    );
    if (!compraCotacaoId) return;

    const parsedFromProps = parseCompraCotacaoInfo(
      props.compraCotacaoData?.compraCotacao_info || compraCotacaoData?.compraCotacao_info,
    );
    if (parsedFromProps) {
      setParsedCompraCotacaoInfo(parsedFromProps);
    }

    try {
      const fetched = await fetchCompraCotacaoWithInfo(compraCotacaoId);
      if (!fetched) return;

      const parsed = parseCompraCotacaoInfo(
        fetched.compraCotacao_info
        || props.compraCotacaoData?.compraCotacao_info
        || compraCotacaoData?.compraCotacao_info,
      );
      setParsedCompraCotacaoInfo(parsed);

      setCompraCotacaoData((prev) => ({
        ...prev,
        ...fetched,
        orcItem_id: fetched.orcItem_id || prev.orcItem_id,
      }));

      const tpMinutaFromCotacao = Number(
        props.compraCotacaoData?.tpMinuta_id
        || fetched.tpMinuta_id
        || compraCotacaoData?.tpMinuta_id,
      ) || null;
      const tpMinutaNomeFromCotacao = String(
        props.compraCotacaoData?.tpMinuta_nome
        || fetched.tpMinuta_nome
        || compraCotacaoData?.tpMinuta_nome
        || '',
      ).trim() || null;

      if (parsed) {
        const { prefill, compraCotacaoUpdates } = await buildContrFornPrefillFromInfo(parsed, fetched);
        setContrFornData((prev) => ({
          ...prev,
          ...prefill,
          // Não sobrescrever vínculo orçamentário já resolvido (fluxo vaga/equipe)
          orcItem_id: prev.orcItem_id || prefill.orcItem_id || null,
          centroDeCustoRubr_id: prev.centroDeCustoRubr_id || prefill.centroDeCustoRubr_id || null,
          orcRubr_id: prev.orcRubr_id || prefill.orcRubr_id || null,
          tpMinuta_id: prev.tpMinuta_id || tpMinutaFromCotacao || prefill.tpMinuta_id || null,
          tpMinuta_nome: prev.tpMinuta_nome || tpMinutaNomeFromCotacao || null,
        }));

        if (Object.keys(compraCotacaoUpdates).length > 0) {
          setCompraCotacaoData((prev) => ({ ...prev, ...compraCotacaoUpdates }));
          setRequiresCompraCotacaoEmailInput(false);
        }
      } else if (tpMinutaFromCotacao || tpMinutaNomeFromCotacao) {
        setContrFornData((prev) => ({
          ...prev,
          tpMinuta_id: prev.tpMinuta_id || tpMinutaFromCotacao || null,
          tpMinuta_nome: prev.tpMinuta_nome || tpMinutaNomeFromCotacao || null,
        }));
      }

      if (fetched.pedidoCompra_id) {
        try {
          const resPedidoCompra = await oikosApi.get(`/?${qs.stringify({
            action: 'get',
            table: 'pedidoCompra',
            data: { pedidoCompra_id: fetched.pedidoCompra_id },
          })}`);
          const pedidoCompra = resPedidoCompra?.data?.[0];
          if (pedidoCompra) {
            setPedidoCompraData((prev) => ({
              ...prev,
              ...pedidoCompra,
              // PedidoCompra pode não ter orcItem; no Equipe o vínculo está na vaga
              orcItem_id: Number(pedidoCompra.orcItem_id)
                || Number(fetched.orcItem_id)
                || Number(props.pedidoCompraData?.orcItem_id)
                || Number(props.compraCotacaoData?.orcItem_id)
                || Number(prev.orcItem_id)
                || null,
              vaga_id: prev.vaga_id || props.pedidoCompraData?.vaga_id || null,
            }));
          }
        } catch (pedidoCompraError) {
          console.error('Erro ao carregar cotação:', pedidoCompraError);
        }
      }

      const contrFornRecord = await fetchContrFornRecordForEmail({
        compraCotacaoId,
        contrFornRecord: {},
      });

      if (contrFornRecord?.contrForn_id) {
        setContrFornData((prev) => ({
          ...prev,
          ...contrFornRecord,
          contrForn_detalhamento: prev.contrForn_detalhamento || contrFornRecord.contrForn_detalhamento,
        }));

        try {
          const resParcelas = await oikosApi.get(`/?${qs.stringify({
            action: 'get',
            table: 'contrFornEvento',
            data: {
              contrForn_id: contrFornRecord.contrForn_id,
              contrFornEvento_ativo: 1,
            },
            order: 'contrFornEvento_num',
          })}`);

          const parcelasPersistidas = resParcelas?.data || [];
          const valorGlobal = getPropostaValorFromInfo(parsed) ?? 0;
          const parcelasCarregadas = hydrateEntregaveisFromParcelas(parcelasPersistidas, valorGlobal);

          setListaParcelas(parcelasCarregadas);
          setListaParcelasPersistidas(parcelasCarregadas);
          setParcelasExcluidasIds([]);
        } catch (parcelasError) {
          console.error('Erro ao carregar entregáveis do contrato:', parcelasError);
        }
      }
    } catch (error) {
      console.error('Erro ao carregar informações do fornecedor:', error);
      notifyError('Não foi possível carregar as informações enviadas pelo fornecedor.');
    }
  };

  const openModalFlow = async () => {
    resetModalFormState();
    await loadData();

    if (shouldLoadSupplierValidationData()) {
      await loadSupplierValidationData();
    }

    if (props.loadExistingContrFornOnOpen && props.contrFornData?.contrForn_id) {
      await loadExistingContrForn(props.contrFornData.contrForn_id);
      return;
    }

    handleClickOpenModal();
  };

  React.useEffect(() => {
    if (!isControlled || !props.isOpen) return undefined

    let cancelled = false
    ;(async () => {
      resetModalFormState()
      await loadData()
      if (cancelled) return
      if (shouldLoadSupplierValidationData()) {
        await loadSupplierValidationData()
        if (cancelled) return
      }
      if (props.loadExistingContrFornOnOpen && props.contrFornData?.contrForn_id) {
        await loadExistingContrForn(props.contrFornData.contrForn_id)
      }
    })()

    return () => { cancelled = true }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isControlled,
    props.isOpen,
    props.compraCotacaoData?.compraCotacao_id,
    props.contrFornData?.contrForn_id,
    props.supplierInfoValidationMode,
  ])

  function handleAddParcela() {
    if (isReadOnlyMode) return;
    setListaParcelas(prev => [...prev, {contrFornEvento_desc: `Parcela ${prev.length + 1}`, contrFornEvento_vlr: 0, contrFornEvento_dtPrev: null, contrFornEvento_num: prev.length + 1}]);
  }

  function handleNextPage(page) {
    console.log(page);
    if (page >= 2) return;
    return setPageContrFornForm(page + 1);
  }

  function handlePrevPage(page) {
    console.log(page);
    if (page <= 1) return;
    return setPageContrFornForm(page - 1);
  }

  const handleDetailChange = (rowIndex, field, value) => {
    if (isReadOnlyMode) return;
    setListaParcelas(old =>
      old.map((item, idx) =>
        idx === rowIndex ? { ...item, [field]: value } : item
      )
    );
  };

  const fetchStatusForSelect = async () => {
    try {
      setSelStatus(await selectValues('contrFornStatus', 'contrFornStatus_id', 'contrFornStatus_nome'));
    } catch (error) {
      console.error("Error fetching Status:", error);
      return [];
    }
  }

  const fetchTiposDeMinutaForSelect = async () => {
    try {
      setSelTiposDeMinuta(await selectValues('tpMinuta', 'tpMinuta_id', 'tpMinuta_nome'));
    } catch (error) {
      console.error("Error fetching Status:", error);
      return [];
    }
  }

  const fetchMinutaModForSelect = async () => {
    try {
      setSelMinutaMod(await selectValues('minutaMod', 'minutaMod_id', 'minutaMod_nome') || []);
    } catch (error) {
      console.error('Error fetching minutaMod:', error);
      setSelMinutaMod([]);
    }
  }

  const fetchPixTpForSelect = async () => {
    try {
      setSelPixTp(await selectValues('pixTp', 'pixTp_id', 'pixTp_nome', { pixTp_ativo: 1 }));
    } catch (error) {
      console.error('Error fetching pixTp:', error);
      setSelPixTp([]);
    }
  }

  const fetchMeioPgtoForSelect = async () => {
    try {
      setSelMeioPgto(await selectValues('meioPgto', 'meioPgto_id', 'meioPgto_desc', { meioPgto_ativo: 1 }));
    } catch (error) {
      console.error('Error fetching meioPgto:', error);
      setSelMeioPgto([]);
    }
  }

  const fetchCartoesCreditoForSelect = async () => {
    try {
      setSelCartoesCredito(await selectValues('conta', 'conta_id', 'conta_nome', {
        contaTp_id: 4,
        conta_ativo: 1,
      }));
    } catch (error) {
      console.error('Error fetching cartões de crédito:', error);
      setSelCartoesCredito([]);
    }
  }

  const fetchTiposDeContratoForSelect = async () => {
    try {
      setSelTipoContrato(await selectValues('contrFornTp', 'contrFornTp_id', 'contrFornTp_nome'));
    } catch (error) {
      console.error("Error fetching Tipos:", error);
      return [];
    }
  }

  const fetchPfsFornecedoresForSelect = async () => {
    try {
      const res = await selectValues(
        'pf',
        'pf_id',
        'pf_nomeExibicao',
        { pf_fornecedor: 1, pf_ativo: 1 },
        { pf_emailProf: 'pf_emailProf' },
      );
      const sortedFavs = (res).sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      })

      setSelPfsFornecedor(sortedFavs);
    } catch (error) {
      console.error("Error fetching Pfs:", error);
      return [];
    }
  }

  const fetchPfsForSelect = async () => {
    try {
      const res = await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {pf_ativo: 1});
      const sortedFavs = (res).sort((a, b) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
      })

      setSelPfs(sortedFavs);
    } catch (error) {
      console.error("Error fetching Pfs for select:", error);
      return [];
    }
  }

  const fetchPjsFornecedoresForSelect = async () => {
    try {
      const res = await selectValues(
        'pj',
        'pj_id',
        'pj_razaosocial',
        { pj_fornecedor: 1, pj_ativo: 1 },
        { pj_emailPrin: 'pj_emailPrin' },
      );
      const sortedFavs = (res).sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        setSelPjsFornecedor(sortedFavs);
    } catch (error) {
      console.error("Error fetching Pjs:", error);
      return [];
    }
  }

  const fetchContratantesForSelect = async () => {
    try {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pj',
        data: { pj_id: '!IN!(1, 2)' },
      })}`);

      const options = (res.data || [])
        .filter((pj) => [1, 2].includes(Number(pj.pj_id)))
        .map((pj) => ({
          value: pj.pj_id,
          label: pj.pj_nomefanta || pj.pj_razaosocial,
        }))
        .sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        });

      setSelContratantes(options);
    } catch (error) {
      console.error('Error fetching contratantes:', error);
      setSelContratantes([]);
    }
  }

  const fetchDocumentosObrigatoriosForSelect = async () => {
    try {
      const options = await fetchDocumentosObrigatoriosTpDocumentoOptions();
      setDocumentosObrigatoriosOptions(options);
      return options;
    } catch (error) {
      console.error('Erro ao carregar documentos obrigatorios:', error);
      setDocumentosObrigatoriosOptions([]);
      return [];
    }
  };

  const fetchVagaDocumentosObrigatoriosForPedido = async ({
    pedidoCompraId,
    vagaId,
  } = {}) => {
    const normalizedVagaId = Number(vagaId) || 0;
    const normalizedPedidoCompraId = Number(pedidoCompraId) || 0;
    if (!normalizedVagaId && !normalizedPedidoCompraId) {
      return { documentos: null, beneficios: null };
    }

    try {
      const response = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'vaga',
        data: normalizedVagaId
          ? { vaga_id: normalizedVagaId }
          : { pedidoCompra_id: normalizedPedidoCompraId },
        fields: {
          vaga_documentosObrigatorios: 'vaga_documentosObrigatorios',
          vaga_beneficios: 'vaga_beneficios',
        },
      })}`);

      const vaga = response?.data?.[0];
      const documentos = vaga?.vaga_documentosObrigatorios
        ? parseMultiSelectIds(vaga.vaga_documentosObrigatorios)
        : null;
      const beneficios = vaga?.vaga_beneficios
        ? parseContrFornBeneficios(vaga.vaga_beneficios)
        : null;

      return { documentos, beneficios };
    } catch (error) {
      console.error('Erro ao carregar documentos e beneficios da vaga:', error);
      return { documentos: null, beneficios: null };
    }
  };

  const fetchOrcItemsForSelect = async (centro_id = null, orcRubrId = 0) => {
    let resp = {data: []};
    try {
      if (orcRubrId === 0) {
        const dataOrcItems = centro_id ? {
          orcItem_ativo: 1,
          nivel2_id: centro_id,
        } : {
          orcItem_ativo: 1,
        }

        resp = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'viewRubr_OrcItem',
          fields: {
            orcItem_id: 'value',
            item_orcamentario: 'label',
            nivel2_id: 'nivel2_id',
            nivel2: 'cc_nome',
            nivel3_id: 'nivel3_id',
            nivel3: 'orcRubr_nome',
            [ORC_ITEM_VLR_ANUAL_FIELD]: 'vlrAnual',
            "(SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1)" : "pf_id",
            "(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1) LIMIT 1)" : "pf_emailProf",
            "(SELECT categGr_id FROM categ WHERE categ.categ_id = viewRubr_OrcItem.categ_id LIMIT 1)": "categGr_id",
            "(SELECT projAtuacao_id FROM projAtuacao WHERE projAtuacao.projAtuacao_id = (SELECT projAtuacao_id FROM propOrcItem WHERE propOrcItem.propOrcItem_id = (SELECT propOrcItem_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1) LIMIT 1) LIMIT 1)" : "projAtuacao_id"
          },
          data: dataOrcItems,
          order: 'label'
        })}`);
      } else {
        resp = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'viewRubr_OrcItem',
          fields: {
            orcItem_id: 'value',
            item_orcamentario: 'label',
            nivel2_id: 'nivel2_id',
            nivel3_id: 'orcRubr_id',
            nivel3: 'orcRubr_nome',
            [ORC_ITEM_VLR_ANUAL_FIELD]: 'vlrAnual',
            "(SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1)" : "pf_id",
            "(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1) LIMIT 1)" : "pf_emailProf",
            "(SELECT categGr_id FROM categ WHERE categ.categ_id = viewRubr_OrcItem.categ_id LIMIT 1)": "categGr_id",
            "(SELECT projAtuacao_id FROM projAtuacao WHERE projAtuacao.projAtuacao_id = (SELECT projAtuacao_id FROM propOrcItem WHERE propOrcItem.propOrcItem_id = (SELECT propOrcItem_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1) LIMIT 1) LIMIT 1)" : "projAtuacao_id"
          },
          data: {
            orcItem_ativo: 1,
            nivel3_id: orcRubrId,
          },
          order: 'label'
        })}`);
      }

      setSelOrcItems(resp.data);
      return resp.data
    } catch (error) {
      console.error("Error fetching orcItems:", error);
      return [];
    }
  }

  const orcItemsFiltradosPorCentroDeCusto = React.useMemo(() => {
    const centroId = Number(contrFornData.centroDeCustoRubr_id) || 0;
    const selectedOrcItemId = Number(contrFornData.orcItem_id) || 0;
    let filtered = selOrcItems;

    if (centroId) {
      if (centroId === 14) {
        const orcRubrId = Number(contrFornData.orcRubr_id) || 0;
        filtered = orcRubrId
          ? selOrcItems.filter((item) => Number(item.nivel3_id || item.orcRubr_id) === orcRubrId)
          : selOrcItems;
      } else {
        filtered = selOrcItems.filter((item) => Number(item.nivel2_id) === centroId);
      }
    }

    if (selectedOrcItemId) {
      const selected = selOrcItems.find((item) => Number(item.value) === selectedOrcItemId);
      if (selected && !filtered.some((item) => Number(item.value) === selectedOrcItemId)) {
        return [...filtered, selected];
      }
    }

    return filtered;
  }, [selOrcItems, contrFornData.centroDeCustoRubr_id, contrFornData.orcRubr_id, contrFornData.orcItem_id]);

  const fetchProjectsForSelect = async () => {
    setIsFetchingProjectLoading(true);
    try {
      const resProjetos = await selectValues('proj', 'proj_id', 'proj_nome', { proj_ativo: 1 }, {
        "(SELECT orcRubr_id FROM proj AS p WHERE proj.proj_id = p.proj_id LIMIT 1)" : "orcRubr_id",
      });
      const projetosOrdenados = resProjetos.sort((a, b) => a.label < b.label ? -1 : a.label > b.label ? 1 : 0);
      setSelProjetos(projetosOrdenados);
      console.log('Projetos:', projetosOrdenados);
      return projetosOrdenados;
    } catch (error) {
      console.error("Error fetching projects:", error);
      return [];
    } finally {
      setIsFetchingProjectLoading(false);
    }
  }

  const fetchFornecedoresForSelect = async (table) => {
    try {
      let resp = {data: []};
      if (table === 'pf') {
        resp = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'pf',
          fields: { pf_id: 'value', pf_nomeExibicao: 'label' },
          data: {pf_fornecedor: 1, pf_ativo: 1},
          order: 'label'
        })}`);
      } else if (table === 'pj') {
        resp = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'pj',
          fields: { pj_id: 'value', pj_nomefanta: 'label' },
          data: {pj_fornecedor: 1, pj_ativo: 1},
          order: 'label'
        })}`);
      }
      setSelFornecedores(resp.data);
      return resp.data;
    } catch (error) {
      console.error("Error fetching fornecedores:", error);
      return [];
    }
  }

  const getPossiveisFornecedores = async (pfTrue) => {
    try {
      if (!pfTrue) {
        const res = await selectValues('pj', 'pj_id', 'pj_nomefanta');
        const sortedFavs = res.sort((a, b) => a.label < b.label ? -1 : a.label > b.label ? 1 : 0);
        setSelPjs(sortedFavs);
        return sortedFavs;
      }
      const res = await selectValues('pf', 'pf_id', 'pf_nomeExibicao');
      const sortedFavs = res.sort((a, b) => a.label < b.label ? -1 : a.label > b.label ? 1 : 0);
      setSelPfs(sortedFavs);
      return sortedFavs;
    } catch (error) {
      console.error("Failed to fetch fornecedores:", error);
      return [];
    }
  };

  const getFornecedores = async (pfTrue) => {
    try {
      if (!pfTrue) {
        const res = await selectValues('pj', 'pj_id', 'pj_razaosocial', {pj_fornecedor: 1});

        const sortedFavs = (res).sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        setSelPjsFornecedor(sortedFavs);

        return sortedFavs;

      } else {
        const res = await selectValues('pf', 'pf_id', 'pf_nomeExibicao', {pf_fornecedor: 1});

        const sortedFavs = (res).sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        setSelPfsFornecedor(sortedFavs);

        return sortedFavs;

      }
    } catch (error) {
      console.error("Failed to fetch product details:", error);
    }
  };

  const getSourceDocumentRecord = React.useCallback(() => {
    if (Number(compraCotacaoData?.compraCotacao_id)) {
      return {
        tabRef: 'compraCotacao',
        tabId: Number(compraCotacaoData.compraCotacao_id),
        titulo: 'Documentos da cotação',
      };
    }

    if (Number(compraCotacaoData?.candidato_id)) {
      return {
        tabRef: 'candidato',
        tabId: Number(compraCotacaoData.candidato_id),
        titulo: 'Documentos do candidato',
      };
    }

    return null;
  }, [compraCotacaoData]);

  const resolveCandidatoIdForDocuments = React.useCallback(async () => {
    const fromRow = Number(compraCotacaoData?.candidato_id) || 0;
    if (fromRow) return fromRow;

    const compraCotacaoId = Number(
      compraCotacaoData?.compraCotacao_id || props.compraCotacaoData?.compraCotacao_id,
    ) || 0;
    if (!compraCotacaoId) return 0;

    try {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'candidato',
        data: { compraCotacao_id: compraCotacaoId },
        order: 'candidato_id DESC',
      })}`);
      return Number(res?.data?.[0]?.candidato_id) || 0;
    } catch (error) {
      console.error('Erro ao resolver candidato da compraCotacao:', error);
      return 0;
    }
  }, [
    compraCotacaoData?.candidato_id,
    compraCotacaoData?.compraCotacao_id,
    props.compraCotacaoData?.compraCotacao_id,
  ]);

  const fetchSourceDocuments = React.useCallback(async (tabRef, tabId) => {
    const normalizedTabId = Number(tabId) || 0;
    if (!tabRef || !normalizedTabId) return [];

    const response = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'documentoVinc',
      data: {
        documentoVinc_tabRef: tabRef,
        documentoVinc_tabId: normalizedTabId,
        documentoVinc_ativo: 1,
      },
      fields: {
        documentoVinc_id: 'documentoVinc_id',
        documento_id: 'documento_id',
        '(SELECT documento_desc FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1)': 'documento_desc',
        '(SELECT documento_ativo FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1)': 'documento_ativo',
        '(SELECT tpDocumento_id FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1)': 'tpDocumento_id',
        '(SELECT tpDocumento_desc FROM tpDocumento WHERE tpDocumento.tpDocumento_id = (SELECT tpDocumento_id FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1) LIMIT 1)': 'tpDocumento_desc',
        '(SELECT arquivo_id FROM arquivo WHERE arquivo.arquivo_tabRef = "documento" AND arquivo.arquivo_tabId = documentoVinc.documento_id AND arquivo.arquivo_ativo = 1 ORDER BY arquivo_id DESC LIMIT 1)': 'arquivo_id',
        '(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabRef = "documento" AND arquivo.arquivo_tabId = documentoVinc.documento_id AND arquivo.arquivo_ativo = 1 ORDER BY arquivo_id DESC LIMIT 1)': 'arquivo_caminho',
        '(SELECT arquivo_desc FROM arquivo WHERE arquivo.arquivo_tabRef = "documento" AND arquivo.arquivo_tabId = documentoVinc.documento_id AND arquivo.arquivo_ativo = 1 ORDER BY arquivo_id DESC LIMIT 1)': 'arquivo_desc',
      },
    })}`);

    return (response?.data || []).filter((doc) => Number(doc?.documento_ativo) === 1 && (doc?.arquivo_caminho || doc?.documento_desc));
  }, []);

  React.useEffect(() => {
    let cancelled = false;

    async function loadSourceDocuments() {
      if (!modalIsOpen) return;

      const sourceRecord = getSourceDocumentRecord();
      if (!sourceRecord) {
        setSourceDocuments([]);
        setIsLoadingSourceDocuments(false);
        return;
      }

      setIsLoadingSourceDocuments(true);
      try {
        const primaryDocs = await fetchSourceDocuments(sourceRecord.tabRef, sourceRecord.tabId);
        let mergedDocs = [...primaryDocs];

        // Proposta da candidatura (formEspecifico) fica em documentoVinc.tabRef = 'candidato'.
        // Proposta atualizada (formContratacaoFornecedor) fica em 'compraCotacao'.
        // Mescla os dois para o modal de validação poder exibir a última proposta disponível.
        if (sourceRecord.tabRef === 'compraCotacao') {
          const candidatoId = await resolveCandidatoIdForDocuments();
          if (candidatoId) {
            const candidatoDocs = await fetchSourceDocuments('candidato', candidatoId);
            const seenDocumentoIds = new Set(
              mergedDocs.map((doc) => Number(doc.documento_id)).filter(Boolean),
            );
            candidatoDocs.forEach((doc) => {
              const documentoId = Number(doc.documento_id) || 0;
              if (documentoId && seenDocumentoIds.has(documentoId)) return;
              if (documentoId) seenDocumentoIds.add(documentoId);
              mergedDocs.push(doc);
            });
          }
        }

        if (!cancelled) setSourceDocuments(mergedDocs);
      } catch (error) {
        if (!cancelled) setSourceDocuments([]);
        console.error('Erro ao carregar documentos vinculados ao registro de origem:', error);
      } finally {
        if (!cancelled) setIsLoadingSourceDocuments(false);
      }
    }

    loadSourceDocuments();

    return () => {
      cancelled = true;
    };
  }, [
    fetchSourceDocuments,
    getSourceDocumentRecord,
    modalIsOpen,
    resolveCandidatoIdForDocuments,
  ]);

  async function getUploadedArquivoMeta(documentoId) {
    const documentoIdNormalizado = Number(documentoId) || 0;
    if (!documentoIdNormalizado) return null;

    try {
      const arquivoRes = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'arquivo',
        data: {
          arquivo_tabRef: 'documento',
          arquivo_tabId: documentoIdNormalizado,
          arquivo_ativo: 1,
        },
        order: 'arquivo_id DESC',
        limit: 1,
      })}`);

      return arquivoRes?.data?.[0] || null;
    } catch (error) {
      console.error('Erro ao consultar arquivo salvo:', error);
      return null;
    }
  }

  async function saveDocuments(files, contrFornRecord, tpDocumentoId = 35) {
    // Cria um registro na tabela de documentos para cada arquivo
    return Promise.all(files.map(async (file) => {
      const documentoDesc = file.props?.description || file.data?.path || trimContrFornDesc();
      const documentBody = {
        action: 'insert',
        table: 'documento',
        data: {
          tpDocumento_id: tpDocumentoId,
          documento_desc: documentoDesc,
          documento_iniVig: undefined,
          documento_fimVig: undefined,
          documento_dtEmissao: undefined,
          documento_prazo: undefined,
          documento_ref: undefined,
          privacidade_id: 2,
        },
      }
      const documentCreated = await oikosApi.post('/', documentBody)

      // Cria uma vinculação entre o documento (anexo) e o registro da minuta
      if (documentCreated.data[0].documento_id) {
        const vinculationBody = {
          action: 'insert',
          table: 'documentoVinc',
          data: {
            documento_id: documentCreated.data[0].documento_id,
            documentoVinc_tabRef: 'contrForn',
            documentoVinc_tabId: contrFornRecord.contrForn_id,
          },
        }
        await oikosApi.post('/', vinculationBody)
      }

      // Faz upload do arquivo e registra na tabela 'arquivo'
      const formData = new FormData()
      const filePayload = file.data instanceof Blob
        ? file.data
        : new Blob([file.data], { type: file.data?.type || 'application/octet-stream' });
      const fileName = file.data?.name || file.data?.path || file.props?.description || 'arquivo';
      formData.append('file', filePayload, fileName);
      formData.append('table', 'arquivo')
      formData.append('action', 'upload_file')
      formData.append('arquivo_tabRef', 'documento')
      formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
      formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
      formData.append('arquivo_desc', file.data.path)
      const fileUploadRes = await oikosApi.post('/', formData)
      console.tron.log('fileUploadRes', fileUploadRes)
      const arquivoSalvo = await getUploadedArquivoMeta(documentCreated.data[0].documento_id)
      const arquivoCaminho = arquivoSalvo?.arquivo_caminho || fileUploadRes?.data?.[0]?.arquivo_caminho || fileUploadRes?.data?.arquivo_caminho || file.data.path

      return {
        documento_id: documentCreated.data[0].documento_id,
        documento_desc: documentBody.data.documento_desc,
        arquivo_caminho: arquivoCaminho,
        link: arquivoCaminho ? `${linkASerUsadoVM}${arquivoCaminho}` : null,
      }
    }))
  }

  async function handleSendContratacaoFornecedorEmail(
    contrFornRecord,
    pdfDocument,
    compraCotacaoOverride = null,
    formDocuments = [],
  ) {
    if (shouldSkipFornecedorEmail) return false;

    const cotacaoSource = compraCotacaoOverride || compraCotacaoData;
    const compraCotacaoWithInfo = await persistCompraCotacaoInfoForFornecedorEmail(cotacaoSource);
    if (!compraCotacaoWithInfo) return false;

    const compraCotacaoForHash = await resolveCompraCotacaoDataForHash(compraCotacaoWithInfo, contrFornRecord);
    const destino = await resolveContratacaoEmailDestino({
      compraCotacaoData: compraCotacaoWithInfo,
      contrFornRecord: {
        ...contrFornData,
        ...contrFornRecord,
      },
      selPfsFornecedor,
      selPjsFornecedor,
    });

    if (!destino?.email) {
      notifyWarning(
        'Contrato salvo, mas o contratado não possui e-mail (pf_emailProf / pj_emailPrin) para enviar a notificação.',
      );
      return false;
    }

    const files = buildContratacaoHashFiles(pdfDocument, formDocuments);
    const selectedOrcItemForHash = selOrcItems.find((orcItem) => (
      Number(orcItem.value) === Number(
        contrFornRecord?.orcItem_id
        || contrFornData?.orcItem_id
        || pedidoCompraData?.orcItem_id,
      )
    ));

    // Preferir docs do form quando o registro da API vier sem o campo (insert/update).
    // Minuta "Fornecedor": injeta tpDocumento 20 só no hash (não no multi-select da UI).
    const documentosIdsFromRecord = getContrFornDocumentosObrigatoriosIds(contrFornRecord);
    const documentosIdsFromState = getContrFornDocumentosObrigatoriosIds(contrFornData);
    const documentosIdsBase = documentosIdsFromRecord.length > 0
      ? documentosIdsFromRecord
      : documentosIdsFromState;
    const documentosIdsForHash = mergeMinutaFornecedorDocIntoHashIds(documentosIdsBase, {
      tpMinutaId: contrFornRecord?.tpMinuta_id ?? contrFornData?.tpMinuta_id,
      selTiposDeMinuta,
      tpMinutaNome: contrFornRecord?.tpMinuta_nome ?? contrFornData?.tpMinuta_nome,
    });
    const contrFornForHash = {
      ...contrFornData,
      ...contrFornRecord,
      contrForn_documentosObrigatorios: documentosIdsForHash,
    };

    const documentosOptionsForEmail = await resolveDocumentosObrigatoriosOptionsForMinuta(
      contrFornForHash,
      documentosObrigatoriosOptions,
    );

    const minutaData = buildContrFornMinutaData({
      contrFornData: contrFornForHash,
      listaParcelas,
      selOrcItems,
      selPfsFornecedor,
      selPjsFornecedor,
      selCentroDeCusto,
      selProjetos,
      selTipoContrato,
      selTiposDeMinuta,
      documentosObrigatoriosOptions: documentosOptionsForEmail,
      showDocumentosObrigatorios: documentosIdsForHash.length > 0,
      savedAnexos: formDocuments,
      filesContrForn,
      trimContrFornDesc,
    });

    const contrFornForParte = {
      ...contrFornData,
      ...contrFornRecord,
    };
    const contratado = await fetchContratadoRecord(
      contrFornForParte.contrForn_parteTab,
      contrFornForParte.contrForn_parteId,
    );

    const payload = {
      compraCotacaoData: compraCotacaoForHash || compraCotacaoWithInfo,
      pedidoCompraData,
      contrFornData: contrFornForHash,
      minutaData,
      contratado: contratado || null,
      email: destino.email,
      nome: destino.nome,
      identificador: destino.identificador,
      pf_emailProf: selectedOrcItemForHash?.pf_emailProf
        || contrFornRecord?.pf_emailProf
        || contrFornData?.pf_emailProf
        || pedidoCompraData?.pf_emailProf
        || compraCotacaoForHash?.pf_emailProf
        || cotacaoSource?.pf_emailProf
        || null,
      ...(files.length > 0 ? { files } : {}),
    };

    console.log('payload', payload);

    try {
      const formLink = montaURLFormContratacaoFornecedor(payload);

      console.log('formLink', formLink);
      
      await sendFormEmail({
        emailDest: destino.email,
        nomeDest: destino.nome,
        formLink,
        mensagemIntro: EMAIL_TEXT_ENVIAR_FORNECEDOR.mensagemIntro,
        formLinkLabel: EMAIL_TEXT_ENVIAR_FORNECEDOR.formLinkLabel,
        corpoTitulo: EMAIL_TEXT_ENVIAR_FORNECEDOR.corpoTitulo,
        corpo: buildPedidoCompraEmailContextHtml({
          pedidoCompraData,
          compraCotacaoData: compraCotacaoForHash || cotacaoSource || compraCotacaoData,
        }) || undefined,
        ...(Number(contrFornRecord?.contrForn_id)
          ? {
            emailEnvioTabRef: 'contrForn',
            emailEnvioTabId: Number(contrFornRecord.contrForn_id),
          }
          : Number(compraCotacaoWithInfo?.compraCotacao_id)
            ? {
              emailEnvioTabRef: 'compraCotacao',
              emailEnvioTabId: Number(compraCotacaoWithInfo.compraCotacao_id),
            }
            : {}),
      }, EMAIL_TEXT_ENVIAR_FORNECEDOR.assunto);
      return true;
    } catch (e) {
      notifyError('Contrato salvo, mas falha ao enviar o e-mail de contratação.');
      console.error('Erro ao enviar e-mail de contratação:', e);
      return false;
    }
  }

  async function handleSendRejeicaoFornecedorEmail(
    justificativa,
    compraCotacaoOverride = null,
  ) {
    const cotacaoSource = compraCotacaoOverride || compraCotacaoData;
    const contrFornRecord = await fetchContrFornRecordForEmail({
      contrFornRecord: contrFornData,
      contrFornId: contrFornData?.contrForn_id || props.contrFornData?.contrForn_id,
      compraCotacaoId: cotacaoSource?.compraCotacao_id,
    });
    const compraCotacaoForHash = await resolveCompraCotacaoDataForHash(cotacaoSource, contrFornRecord);
    const destino = await resolveContratacaoEmailDestino({
      compraCotacaoData: cotacaoSource,
      contrFornRecord,
      selPfsFornecedor,
      selPjsFornecedor,
    });

    if (!destino?.email) {
      notifyWarning('Rejeição registrada, mas nenhum e-mail de destinatário foi encontrado para enviar a notificação.');
      return false;
    }

    const selectedOrcItemForHash = selOrcItems.find((orcItem) => (
      Number(orcItem.value) === Number(
        contrFornRecord?.orcItem_id
        || contrFornData?.orcItem_id
        || pedidoCompraData?.orcItem_id,
      )
    ));

    // Sempre resolver labels via tpDocumento (ids do hash).
    // Minuta "Fornecedor": injeta tpDocumento 20 só no hash.
    const documentosIdsForHash = mergeMinutaFornecedorDocIntoHashIds(
      getContrFornDocumentosObrigatoriosIds(contrFornRecord),
      {
        tpMinutaId: contrFornRecord?.tpMinuta_id,
        selTiposDeMinuta,
        tpMinutaNome: contrFornRecord?.tpMinuta_nome,
      },
    );
    const contrFornForHash = {
      ...contrFornRecord,
      contrForn_documentosObrigatorios: documentosIdsForHash,
    };
    const documentosOptionsForEmail = await resolveDocumentosObrigatoriosOptionsForMinuta(
      contrFornForHash,
      [],
    );

    const minutaData = buildContrFornMinutaData({
      contrFornData: contrFornForHash,
      listaParcelas,
      selOrcItems,
      selPfsFornecedor,
      selPjsFornecedor,
      selCentroDeCusto,
      selProjetos,
      selTipoContrato,
      selTiposDeMinuta,
      documentosObrigatoriosOptions: documentosOptionsForEmail,
      showDocumentosObrigatorios: documentosIdsForHash.length > 0,
      savedAnexos: [],
      filesContrForn,
      trimContrFornDesc,
    });

    const payload = {
      compraCotacaoData: compraCotacaoForHash || cotacaoSource,
      pedidoCompraData,
      contrFornData: contrFornForHash,
      minutaData,
      email: destino.email,
      nome: destino.nome,
      identificador: destino.identificador,
      justificativa_rejeicao: justificativa,
      pf_emailProf: selectedOrcItemForHash?.pf_emailProf
        || contrFornRecord?.pf_emailProf
        || contrFornData?.pf_emailProf
        || pedidoCompraData?.pf_emailProf
        || compraCotacaoForHash?.pf_emailProf
        || cotacaoSource?.pf_emailProf
        || null,
    };

    try {
      const formLink = montaURLFormContratacaoFornecedor(payload);

      await sendFormEmail({
        emailDest: destino.email,
        nomeDest: destino.nome,
        formLink,
        mensagemIntro: EMAIL_TEXT_REENVIAR_FORNECEDOR.mensagemIntro,
        formLinkLabel: EMAIL_TEXT_REENVIAR_FORNECEDOR.formLinkLabel,
        corpoTitulo: EMAIL_TEXT_REENVIAR_FORNECEDOR.corpoTitulo,
        corpo: buildPedidoCompraEmailContextHtml({
          pedidoCompraData,
          compraCotacaoData: compraCotacaoForHash || cotacaoSource || compraCotacaoData,
          justificativa,
        }) || undefined,
        ...(Number(contrFornRecord?.contrForn_id)
          ? {
            emailEnvioTabRef: 'contrForn',
            emailEnvioTabId: Number(contrFornRecord.contrForn_id),
          }
          : Number(cotacaoSource?.compraCotacao_id || compraCotacaoData?.compraCotacao_id)
            ? {
              emailEnvioTabRef: 'compraCotacao',
              emailEnvioTabId: Number(cotacaoSource?.compraCotacao_id || compraCotacaoData?.compraCotacao_id),
            }
            : {}),
      }, EMAIL_TEXT_REENVIAR_FORNECEDOR.assunto);
      return true;
    } catch (e) {
      notifyError('Rejeição registrada, mas falha ao enviar o e-mail ao fornecedor.');
      console.error('Erro ao enviar e-mail de rejeição:', e);
      return false;
    }
  }

  function comparaValorGlobalComSaldo() {
    const valorGlobal = Number(Number(
      (isSupplierInfoValidationMode && valorGlobalProposta > 0
        ? valorGlobalProposta
        : contrFornData.contrForn_vlrGlobal) || 0,
    ).toFixed(2));

    const somaValoresLimites = Number((
      resumoOrcamentoPorAno.length > 0
        ? resumoOrcamentoPorAno.reduce(
          (acc, cur) => Number(acc) + Number(cur.valorDisponivel || 0),
          0,
        )
        : valoresLimites.reduce(
          (acc, cur) => Number(acc) + Number(cur.disponivel || 0),
          0,
        )
    ).toFixed(2));

    if (valorGlobal > somaValoresLimites) {
      notifyError('Valor global do contrato acima do valor disponível');
      return false;
    }
    return true;
  }

  const checkCamposObrigatoriosParcelas = (parcela, counter) => {
    if (effectiveHideParcelasTable) return true;

    const camposObrigatorios = {
      contrFornEvento_desc: 'Descrição',
      contrFornEvento_num: 'Nº contrato',
      ...(parcela.contrFornEvento_dependeAtividade && {contrFornEvento_pgtoPrazoDias: 'Prazo'}),
      contrFornEvento_dtPrev: 'Data',
    }

    for (const campo of Object.keys(camposObrigatorios)) {
      if (!parcela[campo]) {
        notifyError(`O campo "${camposObrigatorios[campo]}" da parcela ${counter} é obrigatório.`)
        return false
      }
    }

    const exigeNfPorParcela = !hideContratoNfUnicaOpcao
      && !contrFornData.contrForn_umaNFParaTodasAsParcela;
    if (exigeNfPorParcela && parcela.contrFornEvento_liberacaoAutomatica === 1) {
      if (Array.isArray(parcela.contrFornEvento_nf) && parcela.contrFornEvento_nf.length === 0) {
        notifyError(`O campo "Nota Fiscal" da parcela ${counter} é obrigatório.`)
        return false
      }
    }
    return true
  }

  function checkCamposObrigatoriosContrForn() {
    const camposObrigatorios = getCamposObrigatoriosContrForn()

    for (const campo of Object.keys(camposObrigatorios)) {
      if (!contrFornData[campo]) {
        console.log(contrFornData);
        notifyError(`O campo "${camposObrigatorios[campo]}" do contrato é obrigatório.`)
        return false
      }
    }

    if (!isValidationContractStep) {
      if (isCentroDeCustoObrigatorio() && !contrFornData.centroDeCustoRubr_id) {
        notifyError('O campo "Centro de custo" do contrato é obrigatório.')
        return false
      }

      if (isOrcItemObrigatorio() && !contrFornData.orcItem_id) {
        notifyError('O campo "Item orçamentário" do contrato é obrigatório.')
        return false
      }
    }

    if (!isValidationContractStep && showEmailFornecedor) {
      const email = String(compraCotacaoData?.compraCotacao_emailInteressado || '').trim();
      if (!email) {
        notifyError('O campo "E-mail do fornecedor" é obrigatório.');
        return false;
      }
      if (!email.includes('@')) {
        notifyError('Informe um e-mail do fornecedor válido.');
        return false;
      }
    }

    return true
  }

  async function ensureContratadoEmailDestino({ criarContratoParaAprovacao = false } = {}) {
    if (
      shouldSkipFornecedorEmail
      || criarContratoParaAprovacao
      || !isCompraCotacaoContratacao
      || isSupplierInfoValidationMode
    ) {
      return true;
    }

    const parteTab = contrFornData.contrForn_parteTab || compraCotacaoData?.compraCotacao_parteTab;
    const parteId = contrFornData.contrForn_parteId || compraCotacaoData?.compraCotacao_parteId;
    if (!parteTab || !parteId) {
      notifyError('Selecione o Contratado antes de enviar a contratação.');
      return false;
    }

    const destino = await resolveContratacaoEmailDestino({
      compraCotacaoData,
      contrFornRecord: {
        ...contrFornData,
        contrForn_parteTab: parteTab,
        contrForn_parteId: parteId,
      },
      selPfsFornecedor,
      selPjsFornecedor,
    });

    if (!destino?.email) {
      notifyError(
        'O contratado não possui e-mail cadastrado (pf_emailProf ou pj_emailPrin). Cadastre o e-mail do fornecedor antes de enviar.',
      );
      return false;
    }

    return true;
  }

  async function persistCompraCotacaoEmailIfNeeded() {
    // Mantido por compatibilidade de chamadas; o e-mail da Contratação
    // não usa mais compraCotacao_emailInteressado.
    return true;
  }


  const formatCompraCotacaoInfoCurrency = (value) => (
    new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(Number(value || 0)).replace(/\u00a0/g, " ")
  );

  const buildCompraCotacaoInfoForFornecedorEmail = (source = {}) => JSON.stringify({
    informacoes_contrato: {
      valor_global: formatCompraCotacaoInfoCurrency(source.compraCotacao_vlr),
      objeto_resumido: trimContrFornDesc(source.compraCotacao_desc || ""),
    },
  });

  async function persistCompraCotacaoInfoForFornecedorEmail(compraCotacaoOverride = null) {
    const source = compraCotacaoOverride || compraCotacaoData || {};
    const compraCotacaoId = Number(source?.compraCotacao_id) || 0;
    const compraCotacao_info = buildCompraCotacaoInfoForFornecedorEmail(source);
    const nextCompraCotacaoData = {
      ...source,
      compraCotacao_info,
    };

    if (!compraCotacaoId) {
      return nextCompraCotacaoData;
    }

    try {
      await oikosApi.post("/", {
        action: "update",
        table: "compraCotacao",
        data: {
          compraCotacao_id: compraCotacaoId,
          compraCotacao_info,
        },
      });

      setCompraCotacaoData((prev) => (
        Number(prev?.compraCotacao_id) === compraCotacaoId
          ? { ...prev, compraCotacao_info }
          : prev
      ));

      return nextCompraCotacaoData;
    } catch (error) {
      console.error("Erro ao atualizar compraCotacao_info antes do envio ao fornecedor:", error);
      notifyError("Erro ao salvar as informações da cotação antes de enviar ao fornecedor.");
      return null;
    }
  }

  async function updateCompraCotacaoStatusesAfterContract(compraCotacaoId, pedidoCompraId) {
    const normalizedCompraCotacaoId = Number(compraCotacaoId) || 0
    const normalizedPedidoCompraId = Number(pedidoCompraId) || 0
    if (!normalizedCompraCotacaoId) return

    await oikosApi.post('/', {
      action: 'update',
      table: 'compraCotacao',
      data: {
        compraCotacao_id: normalizedCompraCotacaoId,
        compraStatus_id: 2,
      },
    })

    if (!normalizedPedidoCompraId) return

    await oikosApi.post('/', {
      action: 'update',
      table: 'pedidoCompra',
      data: {
        pedidoCompra_id: normalizedPedidoCompraId,
        pedidoCompraStatus_id: PEDIDO_COMPRA_STATUS_CONTRATADO,
      },
    })

    const res = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'compraCotacao',
      data: { pedidoCompra_id: normalizedPedidoCompraId },
    })}`)

    const outrasCotacoes = (res.data || []).filter(
      (cotacao) => Number(cotacao.compraCotacao_id) !== normalizedCompraCotacaoId,
    )

    if (outrasCotacoes.length <= 0) return

    await Promise.all(outrasCotacoes.map((cotacao) => oikosApi.post('/', {
      action: 'update',
      table: 'compraCotacao',
      data: {
        compraCotacao_id: cotacao.compraCotacao_id,
        compraStatus_id: 4,
      },
    })))
  }

  const getContratadoNome = () => {
    if (contrFornData.contrForn_parteTab === 'pf') {
      return selPfsFornecedor.find((f) => f.value === contrFornData.contrForn_parteId)?.label || '';
    }
    if (contrFornData.contrForn_parteTab === 'pj') {
      return selPjsFornecedor.find((f) => f.value === contrFornData.contrForn_parteId)?.label || '';
    }
    return '';
  };

  const buildContrFornSubmitData = (numeroContrato, { isInsert = false, contrFornStatusId } = {}) => {
    const anoVigenteFallback = getAnoVigenteDateRange();

    return {
    orcItem_id: contrFornData.orcItem_id || pedidoCompraData.orcItem_id || undefined,
    compraCotacao_id: contrFornData.compraCotacao_id || compraCotacaoData.compraCotacao_id || props?.compraCotacaoData?.compraCotacao_id || undefined,
    contrForn_desc: contrFornData.contrForn_desc || undefined,
    contrForn_num: isInsert ? numeroContrato : (contrFornData.contrForn_num || numeroContrato),
    contrForn_detalhamento: effectiveHideContratoDetalhamento ? undefined : (contrFornData.contrForn_detalhamento || undefined),
    contrForn_obj: effectiveHideContratoObjeto ? undefined : (contrFornData.contrForn_obj || undefined),
    // Cotação rápida: não associar contratado (pf/pj)
    ...(isFormularioSemContrato
      ? {}
      : {
        contrForn_parteTab: contrFornData.contrForn_parteTab
          || compraCotacaoData.compraCotacao_parteTab
          || props?.compraCotacaoData?.compraCotacao_parteTab
          || undefined,
        contrForn_parteId: contrFornData.contrForn_parteId
          || compraCotacaoData.compraCotacao_parteId
          || props?.compraCotacaoData?.compraCotacao_parteId
          || undefined,
      }),
    contrForn_dtAssin: contrFornData.contrForn_dtAssin || undefined,
    contrForn_dtVigIni: contrFornData.contrForn_dtVigIni || anoVigenteFallback?.dtIni || undefined,
    contrForn_dtVigFim: contrFornData.contrForn_dtVigFim || anoVigenteFallback?.dtFim || undefined,
    contrForn_dtRescisao: contrFornData.contrForn_dtRescisao || undefined,
    contrFornTp_id: contrFornData.contrFornTp_id || undefined,
    contrForn_vlrGlobal: contrFornData.contrForn_vlrGlobal || undefined,
    contrForn_obs: effectiveHideObservacao ? undefined : (contrFornData.contrForn_obs || undefined),
    ...(showContratante ? { contrForn_contratante: contrFornData.contrForn_contratante || 1 } : {}),
    contrFornStatus_id: contrFornStatusId ?? (contrFornData.contrFornStatus_id || 1),
    tpMinuta_id: isFormularioSemContrato ? undefined : (contrFornData.tpMinuta_id || undefined),
    ...(isFormularioSemContrato
      ? {
        meioPgto_id: Number(contrFornData.meioPgto_id) || undefined,
        // PIX: só preenche pixTp_id e contrForn_chavePix quando meio = PIX
        ...(isMeioPagamentoPix ? {
          pixTp_id: Number(contrFornData.pixTp_id) || undefined,
          contrForn_chavePix: String(contrFornData.contrForn_chavePix || '').trim() || undefined,
        } : {}),
        // Cartão: só preenche conta_id quando meio = Cartão
        ...(isMeioPagamentoCartaoCredito ? {
          conta_id: Number(contrFornData.conta_id) || undefined,
        } : {}),
      }
      : {}),
    pf_id: user.pf_id,
    contrForn_vlrFixo: hideContratoValorFixoOpcao ? 1 : (contrFornData.contrForn_vlrFixo || 0),
    contrForn_dtPgtoFixa: hideContratoDiaFixoPagamentoOpcao ? 0 : (contrFornData.contrForn_dtPgtoFixa || 0),
    contrForn_renovacaoAutomatica: hideContratoRenovacaoAutomaticaOpcao ? 0 : (contrFornData.contrForn_renovacaoAutomatica || 0),
    contrForn_maoObraLocal: hideContratoMaoObraLocalOpcao ? 1 : (contrFornData.contrForn_maoObraLocal || 0),
    ...buildContrFornExtendedFieldsPayload(contrFornData, showEquipeContrFornFields),
    ...buildContrFornDocumentosObrigatoriosPayload(contrFornData, true),
  };
  };

  async function createContrFornApprovalTasks(contrFornId, contrFornNum, { pfId } = {}) {
    const contratadoNome = getContratadoNome();
    const postBodyTask = {
      action: 'insert',
      table: 'task',
      data: {
        task_tabRef: 'contrForn',
        task_tabId: contrFornId,
        pf_id: user.pf_id,
        task_prazo: moment().add(3, 'days').format('YYYY-MM-DD') || undefined,
        taskTp_id: 3,
        dpto_id: undefined,
        task_desc: `Aprovar contrato ${contrFornNum} ${contratadoNome}`,
        task_orientacao: 'Avalie o anexo desta tarefa. Após, clique em "Aprovar" ou "Rejeitar" de acordo com o seu julgamento',
      },
    };

    const responseTask = await oikosApi.post(`/`, postBodyTask);
    const taskMaeId = responseTask?.data?.[0]?.task_id;
    if (!taskMaeId) return;

    const centroFromOrcItem = Number(
      selOrcItems.find((oi) => Number(oi.value) === Number(contrFornData.orcItem_id))?.nivel2_id,
    ) || 0;
    const centroDeCusto = Number(contrFornData.centroDeCustoRubr_id) || centroFromOrcItem;
    const normalizedPfId = Number(pfId) || 0;
    // Centro 13 ou 14 → pf_id 2; demais centros → pf_id 1 (pfId explícito tem prioridade).
    const pfDestino = normalizedPfId > 0
      ? normalizedPfId
      : ([13, 14].includes(centroDeCusto) ? 2 : 1);

    await oikosApi.post(`/`, {
      ...postBodyTask,
      data: {
        ...postBodyTask.data,
        pf_id: pfDestino,
        task_mae: taskMaeId,
      },
    });
  }

  const getApprovalTaskOptions = () => (
    // Contratação de compraCotacao: destino da task filha por centro de custo (13/14 → 2, senão → 1).
    // Não força pfId fixo para não sobrescrever essa regra.
    undefined
  );

  async function persistContrFornParcelas(contrFornId, parcelasOverride = null) {
    const parcelasToPersist = parcelasOverride ?? listaParcelas;
    if (effectiveHideParcelasTable && !isSupplierInfoValidationMode && parcelasOverride == null) return;

    const deletedFromDiff = listaParcelasPersistidas
      .filter((parcela) => parcela.contrFornEvento_id)
      .filter((parcela) => !parcelasToPersist.some(
        (item) => Number(item.contrFornEvento_id) === Number(parcela.contrFornEvento_id),
      ))
      .map((parcela) => Number(parcela.contrFornEvento_id));

    const idsToDeactivate = [...new Set([
      ...parcelasExcluidasIds.map(Number),
      ...deletedFromDiff,
    ])].filter(Boolean);

    if (idsToDeactivate.length > 0) {
      await Promise.all(idsToDeactivate.map(async (contrFornEvento_id) => {
        await oikosApi.post('/', {
          action: 'update',
          table: 'contrFornEvento',
          data: {
            contrFornEvento_id,
            contrFornEvento_ativo: 0,
            contrFornEvento_usuarioMod: user.pf_id,
          },
        });
      }));
    }

    await Promise.all(parcelasToPersist.map(async (parcela) => {
      const action = parcela.contrFornEvento_id ? 'update' : 'insert';
      const clearAgendamentoFields = Boolean(isSupplierInfoValidationMode);
      const prazoDias = parcela.contrFornEvento_pgtoPrazoDias;
      const hasDtPrev = hasEntregavelDtPrev(parcela);
      const prazoInformado = isPrazoDiasInformado(prazoDias);

      let pgtoPrazoDiasPersist;
      if (clearAgendamentoFields) {
        // Modo data fixa ou prazo vazio: não preencher a coluna (undefined).
        // Modo prazo com 0 ou mais: gravar o número.
        pgtoPrazoDiasPersist = (!hasDtPrev && prazoInformado) ? Number(prazoDias) : undefined;
      } else {
        pgtoPrazoDiasPersist = persistPgtoPrazoDias(prazoDias);
      }

      const isLiberacaoAutomatica = Number(parcela.contrFornEvento_liberacaoAutomatica) === 1;
      const isAprovLiberado = Number(parcela.contrFornEvento_aprovLiberado) === 1
        || isLiberacaoAutomatica;

      await oikosApi.post('/', {
        action,
        table: 'contrFornEvento',
        data: {
          ...(parcela.contrFornEvento_id ? { contrFornEvento_id: parcela.contrFornEvento_id } : { contrForn_id: contrFornId }),
          contrFornEvento_num: parcela.contrFornEvento_num || undefined,
          contrFornEvento_desc: parcela.contrFornEvento_desc || undefined,
          // API Oikos não grava NULL em DATE (vira ''); omitir dtPrev quando vazio.
          contrFornEvento_pgtoPrazoDias: pgtoPrazoDiasPersist,
          contrFornEvento_dtPrev: hasDtPrev
            ? moment(parcela.contrFornEvento_dtPrev).format('YYYY-MM-DD')
            : undefined,
          contrFornEvento_dtReal: parcela.contrFornEvento_dtReal ? moment(parcela.contrFornEvento_dtReal).format('YYYY-MM-DD') : undefined,
          contrFornEvento_aprovNecessita: 1,
          contrFornEvento_liberacaoAutomatica: isLiberacaoAutomatica ? 1 : 0,
          // Não zerar parcelas já liberadas (inclui liberação automática no cadastro).
          ...(action === 'insert' || isAprovLiberado
            ? { contrFornEvento_aprovLiberado: isAprovLiberado ? 1 : 0 }
            : {}),
          contrFornEvento_obs: parcela.contrFornEvento_obs || undefined,
          contrFornEvento_ativo: 1,
          contrFornEvento_usuarioMod: user.pf_id,
          ...(action === 'insert' ? { contrFornEvento_usuarioCria: user.pf_id } : {}),
          categ_id: parcela.categ_id || undefined,
          contrFornEvento_vlr: parcela.contrFornEvento_vlr || 0,
        },
      });
    }));
  }

  const getStandaloneSubmitContext = () => ({
    contrFornData,
    listaParcelas,
    filteredValoresLimites,
    valoresLimites,
    resumoOrcamentoPorAno,
    bdrosVinculaveis,
    bdrosOrcItem,
    filesContrForn,
    nfUnicaFilesContrForn,
    selOrcItems,
    selPfsFornecedor,
    selPjsFornecedor,
    user,
    trimContrFornDesc,
    saveDocuments,
    checkCamposObrigatoriosContrForn,
    checkCamposObrigatoriosParcelas,
    comparaValorGlobalComParcelas,
    verificaDocumentoContrForn,
    verificaDataVigencia,
    setIsAvisoSaldoMensalOpen,
    setIsAvisoSemBdroOpen,
    setLoadingSubmit: setLoadingSumbit,
    handleClickCloseModal,
    onSuccess: props.onSuccess,
    buildPdfDoc,
    handleSendContratacaoFornecedorEmail,
  });

  const getParcelasParaSubmit = () => {
    if (effectiveHideParcelasTable && !isSupplierInfoValidationMode) return [];
    if (isSupplierInfoValidationMode) {
      const extra = entregavelDraftParcela?._draftPersistivel ? [entregavelDraftParcela] : [];
      const merged = [...listaParcelas, ...extra];
      if (merged.length === 0) return [];
      return renumberEntregaveis(merged, valorGlobalProposta)
        .map(normalizeEntregavelAgendamentoFields);
    }
    if (listaParcelas.length > 0) return listaParcelas;
    return [];
  };

  /** Cotação rápida: uma única parcela com o valor global do contrato. */
  const buildParcelaUnicaCotacaoRapida = () => {
    const valor = Number(contrFornData.contrForn_vlrGlobal) || 0;
    return [{
      contrFornEvento_num: 1,
      contrFornEvento_desc: 'Parcela 1',
      contrFornEvento_vlr: valor,
      contrFornEvento_dtPrev: contrFornData.contrForn_dtVigFim
        || contrFornData.contrForn_dtVigIni
        || moment().format('YYYY-MM-DD'),
    }];
  };

  const insertNewContrFornParcelas = async (contrFornId, parcelas = listaParcelas) => {
    await Promise.all(parcelas.map(async (parcela) => {
      const parcelaBody = {
        action: 'insert',
        table: 'contrFornEvento',
        data: {
          contrForn_id: contrFornId || undefined,
          contrFornEvento_num: parcela.contrFornEvento_num || undefined,
          contrFornEvento_desc: parcela.contrFornEvento_desc || undefined,
          contrFornEvento_pgtoPrazoDias: persistPgtoPrazoDias(parcela.contrFornEvento_pgtoPrazoDias),
          //contrFornEvento_dependeAtividade: parcela.contrFornEvento_dependeAtividade ?? undefined,
          contrFornEvento_dtPrev: parcela.contrFornEvento_dtPrev ? moment(parcela.contrFornEvento_dtPrev).format('YYYY-MM-DD') : undefined,
          contrFornEvento_dtReal: parcela.contrFornEvento_dtReal ? moment(parcela.contrFornEvento_dtReal).format('YYYY-MM-DD') : undefined,
          contrFornEvento_aprovNecessita: 1,
          contrFornEvento_aprovLiberado: 0,
          contrFornEvento_liberacaoAutomatica: parcela.contrFornEvento_liberacaoAutomatica ? 1 : 0,
          contrFornEvento_obs: parcela.contrFornEvento_obs || undefined,
          contrFornEvento_usuarioCria: user.pf_id,
          contrFornEvento_usuarioMod: user.pf_id,
          categ_id: parcela.categ_id || undefined,
          contrFornEvento_vlr: parcela.contrFornEvento_vlr || 0,
        },
      };
      await oikosApi.post('/', parcelaBody);
    }));
  };

  const saveContrFornFormDocumentsAndPdf = async (contrFornRecord) => {
    if (isFormularioSemContrato && nfCompraFilesContrForn.length > 0) {
      await saveDocuments(nfCompraFilesContrForn, contrFornRecord, 27);
    }

    if (isFormularioSemContrato && propostaComercialFilesContrForn.length > 0) {
      await saveDocuments(propostaComercialFilesContrForn, contrFornRecord, 21);
    }

    if (effectiveHideDocumentoContrato) {
      return [];
    }

    const savedFormDocuments = await saveDocuments(filesContrForn, contrFornRecord);
    const { doc: pdfDoc, fileName: pdfFileName } = buildPdfDoc(savedFormDocuments);
    const pdfBlob = pdfDoc.output('blob');
    const pdfFile = new File([pdfBlob], pdfFileName, { type: 'application/pdf' });
    pdfFile.path = pdfFileName;
    await saveDocuments([{ data: pdfFile }], contrFornRecord);
    return savedFormDocuments;
  };

  async function submitSupplierValidationContrForn(parcelasSubmit = []) {
    const info = parsedCompraCotacaoInfo;
    if (!info) {
      notifyError('Informações do fornecedor não encontradas.');
      throw new Error('Informações do fornecedor não encontradas.');
    }

    const minutaFornecedor = isMinutaFornecedor
      || isTpMinutaFornecedor(
        contrFornData.tpMinuta_id
          ?? props.contrFornData?.tpMinuta_id
          ?? compraCotacaoData?.tpMinuta_id
          ?? props.compraCotacaoData?.tpMinuta_id,
        selTiposDeMinuta,
      );

    if (!minutaFornecedor && !Number(contrFornData?.minutaMod_id)) {
      notifyError('Selecione um modelo de minuta.');
      throw new Error('Selecione um modelo de minuta.');
    }

    if (minutaFornecedor) {
      const minutaDoc = findMinutaFornecedorDocFromInfo(info);
      if (!Number(minutaDoc?.documento_id)) {
        notifyError('A minuta do fornecedor (documento obrigatório) não foi encontrada. Peça o reenvio das informações.');
        throw new Error('Minuta do fornecedor não encontrada no compraCotacao_info.');
      }
    }

    let parte;
    try {
      parte = await upsertFornecedorFromCompraCotacaoInfo(info, user.pf_id);
      setSupplierParte(parte);
    } catch (error) {
      notifyError(error?.message || 'Não foi possível salvar os dados cadastrais do fornecedor.');
      throw error;
    }

    const compraCotacaoId = Number(
      props.compraCotacaoData?.compraCotacao_id || compraCotacaoData?.compraCotacao_id,
    );
    const contrFornRecord = await fetchContrFornRecordForEmail({
      compraCotacaoId,
      contrFornRecord: contrFornData,
    });

    if (!contrFornRecord?.contrForn_id) {
      notifyError('Contrato não encontrado para esta cotação. A cotação deve ter um contrato vinculado.');
      throw new Error('Contrato não encontrado para esta cotação.');
    }

    const vlrGlobal = Number(
      getPropostaValorFromInfo(info) ?? contrFornData.contrForn_vlrGlobal,
    ) || 0;
    // Aprovação por valor só no primeiro gate; na validação segue para Em assinatura.
    const contrFornStatusId = CONTR_FORN_STATUS_EM_ASSINATURA;

    const updateData = buildSupplierValidationContrFornUpdateData({
      contrFornId: contrFornRecord.contrForn_id,
      info,
      contrFornData,
      parte,
      userId: user.pf_id,
      contrFornStatusId,
      includeMinutaMod: !minutaFornecedor,
    });

    await oikosApi.post('/', {
      action: 'update',
      table: 'contrForn',
      data: updateData,
    });

    await persistContrFornParcelas(contrFornRecord.contrForn_id, parcelasSubmit);

    if (minutaFornecedor) {
      try {
        const minutaDoc = findMinutaFornecedorDocFromInfo(info);
        await ensureMinutaDocumentoVincToContrForn(
          minutaDoc.documento_id,
          contrFornRecord.contrForn_id,
        );
      } catch (error) {
        console.error('Erro ao vincular minuta do fornecedor ao contrato:', error);
        notifyError(error?.message || 'Não foi possível vincular a minuta do fornecedor ao contrato.');
        throw error;
      }
    } else {
      const contrFornForMinuta = {
        ...contrFornRecord,
        ...contrFornData,
        contrForn_id: contrFornRecord.contrForn_id,
        contrForn_num: contrFornRecord.contrForn_num || contrFornData.contrForn_num,
        minutaMod_id: contrFornData.minutaMod_id,
        contrForn_detalhamento: contrFornData.contrForn_detalhamento,
        contrForn_parteTab: parte.contrForn_parteTab || contrFornData.contrForn_parteTab,
        contrForn_parteId: parte.contrForn_parteId || contrFornData.contrForn_parteId,
        contrForn_vlrGlobal: vlrGlobal || contrFornData.contrForn_vlrGlobal,
      };

      try {
        const { file: minutaPdfFile } = await buildMinutaContratoPdfDoc({
          contrFornData: contrFornForMinuta,
          compraCotacaoInfo: parsedCompraCotacaoInfo,
          selContratantes,
          selPfsFornecedor,
          selPjsFornecedor,
          listaParcelas: parcelasSubmit,
          includeEntregaveis: !parcelasMensaisFixas,
        });

        await saveDocuments(
          [{ data: minutaPdfFile, props: { description: 'Minuta de Contrato' } }],
          { contrForn_id: contrFornRecord.contrForn_id },
          TP_DOCUMENTO_MINUTA_CONTRATO,
        );
      } catch (error) {
        console.error('Erro ao gerar/salvar minuta de contrato:', error);
        notifyError(error?.message || 'Não foi possível salvar a Minuta de Contrato.');
        throw error;
      }
    }

    await updateCompraCotacaoStatusesAfterContract(
      compraCotacaoId,
      pedidoCompraData?.pedidoCompra_id
        || props.pedidoCompraData?.pedidoCompra_id
        || compraCotacaoData?.pedidoCompra_id,
    );

    notifySuccess('Contratação confirmada. Contrato em assinatura.');

    try {
      if (props.onSuccess) await props.onSuccess();
    } catch (error) {
      console.error('Erro ao atualizar a tela após confirmar contratação:', error);
    } finally {
      handleClickCloseModal();
    }
  };

  async function handleSubmitContrForn(submitOptions = {}) {
    if (isReadOnlyMode) return;

    submitOptionsRef.current = submitOptions;
    const criarContratoParaAprovacao = Boolean(submitOptions.criarContratoParaAprovacao);

    if (props.standalone && !contrFornData.contrForn_id) {
      return submitStandaloneContrForn(getStandaloneSubmitContext(), submitOptions);
    }

    setLoadingSumbit(true);

    if (isSupplierInfoValidationMode) {
      if (!allValidationChecksComplete) {
        notifyError('Confirme a validação de todas as etapas antes de contratar.');
        return setLoadingSumbit(false);
      }
      if (validationStep !== 2) {
        notifyError('Conclua todas as etapas de validação antes de confirmar a contratação.');
        return setLoadingSumbit(false);
      }
    }

    let parcelasSubmit = getParcelasParaSubmit();

    if (isSupplierInfoValidationMode) {
      const entregaveisError = validarEntregaveisParaSubmit(parcelasSubmit, valorGlobalProposta);
      if (entregaveisError) {
        notifyError(entregaveisError);
        return setLoadingSumbit(false);
      }
      if (
        isValidationContractStep
        && !submitOptions.ignorarAvisoSaldoMensal
        && !verificarSaldoMensalValido(filteredValoresLimites, parcelasSubmit)
      ) {
        setIsAvisoSaldoMensalOpen(true);
        return setLoadingSumbit(false);
      }
    } else if (!effectiveHideParcelasTable && parcelasSubmit.length <= 0) {
      notifyError('É necessário cadastrar pelo menos uma parcela.');
      return setLoadingSumbit(false);
    }

    const verificaCamposObrigatoriosContrForn = checkCamposObrigatoriosContrForn();
    if (!verificaCamposObrigatoriosContrForn) return setLoadingSumbit(false);

    // Saldo e soma das parcelas já foram validados na criação do contrForn.
    if (!isSupplierInfoValidationMode) {
      const comparacaoValorGlobalComSaldo = comparaValorGlobalComSaldo();
      if (!comparacaoValorGlobalComSaldo) return setLoadingSumbit(false);

      const comparacaoValorGlobalComParcelas = comparaValorGlobalComParcelas(parcelasSubmit);
      if (!comparacaoValorGlobalComParcelas) return setLoadingSumbit(false);
    }

    const checkDocumento = verificaDocumentoContrForn(submitOptions);
    if (!checkDocumento) return setLoadingSumbit(false);

    if (!effectiveHideParcelasTable && !isSupplierInfoValidationMode) {
      for (let index = 0; index < parcelasSubmit.length; index++) {
        const parcela = parcelasSubmit[index];
        const check = checkCamposObrigatoriosParcelas(parcela, (index + 1))
        if (!check) {
          setLoadingSumbit(false);
          return
        };
      }
    }

    if (!isSupplierInfoValidationMode) {
      if (!effectiveHideParcelasOrcamentoTable && !submitOptions.ignorarAvisoSaldoMensal) {
        const isSaldoValido = verificarSaldoMensalValido(filteredValoresLimites, parcelasSubmit);
        if (!isSaldoValido) {
          setIsAvisoSaldoMensalOpen(true);
          return setLoadingSumbit(false);
        }
      }

      const checkDataVigencia = verificaDataVigencia(parcelasSubmit);
      if (!checkDataVigencia) return setLoadingSumbit(false);
    }

    const emailPersistido = await persistCompraCotacaoEmailIfNeeded();
    if (!emailPersistido) return setLoadingSumbit(false);

    const contratadoEmailOk = await ensureContratadoEmailDestino({ criarContratoParaAprovacao });
    if (!contratadoEmailOk) return setLoadingSumbit(false);

    if (isSupplierInfoValidationMode) {
      try {
        await submitSupplierValidationContrForn(parcelasSubmit);
      } catch (error) {
        console.error('Erro ao confirmar contratação na validação:', error);
      } finally {
        setLoadingSumbit(false);
      }
      return;
    }

    const numeroContrato = `${pedidoCompraData.pedidoCompra_id}.${props?.compraCotacaoData?.compraCotacao_id}/${new Date().getFullYear()}`;

    const hasExistingPedidoCompra = Boolean(
      props.pedidoCompraData?.pedidoCompra_id
      || pedidoCompraData?.pedidoCompra_id,
    );
    const hasExistingCompraCotacao = Boolean(
      props.compraCotacaoData?.compraCotacao_id
      || compraCotacaoData?.compraCotacao_id,
    );

    if (!hasExistingPedidoCompra && !hasExistingCompraCotacao) {
      const postBodyPedidoCompra = {
        action: 'insert',
        table: 'pedidoCompra',
        data: {
          compraStatus_id: 2,
          orcItem_id: compraCotacaoData.orcItem_id,
          pf_id: user.pf_id,
        }
      };
      const responsePedidoCompra = await oikosApi.post(`/`, postBodyPedidoCompra);
      console.log(responsePedidoCompra);
  
      const postBodyCompraCotacao = {
        action: 'insert',
        table: 'compraCotacao',
        data: {
          pedidoCompra_id: responsePedidoCompra.data[0].pedidoCompra_id,
          compraCotacao_vlr: contrFornData.contrForn_vlrGlobal
        }
      };
      const responseCompraCotacao = await oikosApi.post(`/`, postBodyCompraCotacao);
      console.log(responseCompraCotacao);
    }

    try {
      if (isRejectedContractResubmit && !contrFornData.contrForn_id) {
        notifyError('Contrato rejeitado sem identificador. Não é possível reenviar.');
        return setLoadingSumbit(false);
      }

      if (criarContratoParaAprovacao) {
        if (contrFornData.contrForn_id) {
          notifyError('Contrato já existente. Use "Enviar para fornecedor" para reenviar ao fornecedor.');
          return setLoadingSumbit(false);
        }

        const valorContrato = Number(contrFornData.contrForn_vlrGlobal) || 0;
        const requiresApproval = needsContrFornApproval(valorContrato);
        const contrFornStatusId = requiresApproval
          ? CONTR_FORN_STATUS_EM_APROVACAO
          : (isFormularioSemContrato
            ? CONTR_FORN_STATUS_ATIVO
            : CONTR_FORN_STATUS_EM_ASSINATURA);

        const postBody = {
          action: 'insert',
          table: 'contrForn',
          data: buildContrFornSubmitData(numeroContrato, { isInsert: true, contrFornStatusId }),
        };

        const response = await oikosApi.post(`/`, postBody);
        const contrFornCreated = response.data[0];

        await insertNewContrFornParcelas(contrFornCreated.contrForn_id, parcelasSubmit);
        await saveContrFornFormDocumentsAndPdf(contrFornCreated);

        if (requiresApproval) {
          await createContrFornApprovalTasks(
            contrFornCreated.contrForn_id,
            contrFornCreated.contrForn_num,
            getApprovalTaskOptions(),
          );
        }

        const compraCotacaoIdMarcador = Number(
          props?.compraCotacaoData?.compraCotacao_id || compraCotacaoData?.compraCotacao_id,
        ) || 0;
        if (compraCotacaoIdMarcador) {
          try {
            await oikosApi.post('/', {
              action: 'update',
              table: 'compraCotacao',
              data: {
                compraCotacao_id: compraCotacaoIdMarcador,
                compraCotacao_info: buildCriarContratoDiretoCompraCotacaoInfo(
                  props?.compraCotacaoData?.compraCotacao_info
                    || compraCotacaoData?.compraCotacao_info,
                ),
              },
            });
          } catch (error) {
            console.error('Erro ao marcar fluxo criar contrato direto na cotação:', error);
          }
        }

        if (isCompraCotacaoContratacao) {
          await updateCompraCotacaoStatusesAfterContract(
            props?.compraCotacaoData?.compraCotacao_id || compraCotacaoData.compraCotacao_id,
            pedidoCompraData?.pedidoCompra_id,
          );
        }

        if (props.onSuccess) await props.onSuccess();
        setIsModalOpen(false);
        return;
      }

      if (contrFornData.contrForn_id) {
        const contrFornId = contrFornData.contrForn_id;
        const valorContrato = Number(contrFornData.contrForn_vlrGlobal) || 0;
        const requiresApproval = needsContrFornApproval(valorContrato)
          && !shouldSkipFornecedorEmail;
        const contrFornStatusId = requiresApproval
          ? CONTR_FORN_STATUS_EM_APROVACAO
          : 1;

        const updateBody = {
          action: 'update',
          table: 'contrForn',
          data: {
            contrForn_id: contrFornId,
            ...buildContrFornSubmitData(numeroContrato, { isInsert: false, contrFornStatusId }),
          },
        };

        await oikosApi.post(`/`, updateBody);
        await persistContrFornParcelas(contrFornId);

        const savedFormDocuments = await saveDocuments(filesContrForn, { contrForn_id: contrFornId });

        const { doc: pdfDoc, fileName: pdfFileName } = buildPdfDoc(savedFormDocuments);
        const pdfBlob = pdfDoc.output('blob');
        const pdfFile = new File([pdfBlob], pdfFileName, { type: 'application/pdf' });
        pdfFile.path = pdfFileName;
        const savedPdfDocuments = await saveDocuments([{ data: pdfFile }], { contrForn_id: contrFornId });

        if (requiresApproval) {
          await createContrFornApprovalTasks(
            contrFornId,
            updateBody.data.contrForn_num || contrFornData.contrForn_num,
            getApprovalTaskOptions(),
          );
        } else if (!isSupplierInfoValidationMode && !shouldSkipFornecedorEmail) {
          await handleSendContratacaoFornecedorEmail(
            { ...contrFornData, ...updateBody.data },
            savedPdfDocuments?.[0],
            compraCotacaoData,
            savedFormDocuments,
          );
        }

        if (!requiresApproval) {
          await updateCompraCotacaoStatusesAfterContract(
            props?.compraCotacaoData?.compraCotacao_id || compraCotacaoData.compraCotacao_id,
            pedidoCompraData?.pedidoCompra_id,
          );
        }

        if (props.onSuccess) await props.onSuccess();
        setIsModalOpen(false);
        return;
      }

      {
        const valorContrato = Number(contrFornData.contrForn_vlrGlobal) || 0;
        const requiresApproval = needsContrFornApproval(valorContrato)
          && !shouldSkipFornecedorEmail;
        const contrFornStatusId = requiresApproval
          ? CONTR_FORN_STATUS_EM_APROVACAO
          : 1;

        const postBody = {
          action: 'insert',
          table: 'contrForn',
          data: buildContrFornSubmitData(numeroContrato, { isInsert: true, contrFornStatusId }),
        };
        console.log(postBody)

        const response = await oikosApi.post(`/`, postBody);
        const contrFornCreated = response.data[0];

        await insertNewContrFornParcelas(contrFornCreated.contrForn_id, parcelasSubmit);

        const savedFormDocuments = await saveDocuments(filesContrForn, contrFornCreated)

        const { doc: pdfDoc, fileName: pdfFileName } = buildPdfDoc(savedFormDocuments)
        const pdfBlob = pdfDoc.output('blob')
        const pdfFile = new File([pdfBlob], pdfFileName, { type: 'application/pdf' })
        pdfFile.path = pdfFileName
        const savedPdfDocuments = await saveDocuments([{ data: pdfFile }], contrFornCreated)

        if (requiresApproval) {
          await createContrFornApprovalTasks(
            contrFornCreated.contrForn_id,
            contrFornCreated.contrForn_num,
            getApprovalTaskOptions(),
          );
        } else if (!isSupplierInfoValidationMode && !shouldSkipFornecedorEmail) {
          await handleSendContratacaoFornecedorEmail(
            {
              ...contrFornData,
              ...(contrFornCreated || {}),
              contrForn_documentosObrigatorios:
                contrFornData.contrForn_documentosObrigatorios
                ?? contrFornCreated?.contrForn_documentosObrigatorios,
            },
            savedPdfDocuments?.[0],
            compraCotacaoData,
            savedFormDocuments,
          )
        }

        if (!requiresApproval) {
          await updateCompraCotacaoStatusesAfterContract(
            props?.compraCotacaoData?.compraCotacao_id || compraCotacaoData.compraCotacao_id,
            pedidoCompraData?.pedidoCompra_id,
          )
        }

        if (props.onSuccess) await props.onSuccess()

        setIsModalOpen(false);
      }
    } catch (error) {
      console.error("Error creating cotação:", error);
    } finally {
      setLoadingSumbit(false);
    }
  }

  useEffect(() => {
    const normalizedOrcItemId = compraCotacaoData.orcItem_id || pedidoCompraData.orcItem_id;
    if (normalizedOrcItemId) getOrcDots(normalizedOrcItemId);
  }, [compraCotacaoData.orcItem_id, pedidoCompraData.orcItem_id])


  const PERIODICITY_MONTHS = {
    Mensal: 1,
    Bimestral: 2,
    Trimestral: 3,
    Quadrimestral: 4,
    Semestral: 6,
    Anual: 12
  };

  function dateWithDayClamped(base, dayOfMonth) {
    const y = base.getFullYear();
    const m = base.getMonth();
    const lastDayOfMonth = new Date(y, m + 1, 0).getDate();
    const d = Math.min(Math.max(dayOfMonth, 1), lastDayOfMonth);
    return new Date(y, m, d);
  }

  function fmtYYYYMMDD(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  function splitValueIntoInstallments(value, installments) {
    const totalCents = Math.round(value * 100);
    const baseCents = Math.floor(totalCents / installments);
    const remainder = totalCents - baseCents * installments;
    const centsArray = Array.from({ length: installments }, (_, i) => i === installments - 1 ? baseCents + remainder : baseCents);
    return centsArray.map((c) => c / 100);
  }

  function handleAddParcelasByPeriod(value, initialDate, periodicity, dayOfMonth, installments) {
    if (isReadOnlyMode) return;
    setListaParcelas([])
    value = parseFloat(value);
    dayOfMonth = parseInt(dayOfMonth, 10);
    installments = parseInt(installments, 10);

    const monthsStep = PERIODICITY_MONTHS[periodicity];
    if (!monthsStep) return notifyError('Periodicidade inválida');
    if (!(installments > 0 && Number.isInteger(installments))) return notifyError('Parcelas deve ser um valor inteiro positivo');
    if (typeof value !== 'number' || !isFinite(value) || value < 0) return notifyError('Valor deve ser um número positivo');
    if (!initialDate) return notifyError('Insira data de início');

    const [year, month, day] = initialDate.split('-').map(Number);
    const start = new Date(year, month - 1, day);
    if (isNaN(start.getTime())) return notifyError('Preencha a data de início');

    const dates = [];
    for (let i = 0; i < installments; i++) {
      const base = new Date(start);
      base.setMonth(base.getMonth() + i * monthsStep);
      dates.push(dateWithDayClamped(base, dayOfMonth));
    }

    const amounts = splitValueIntoInstallments(value, installments);
    setListaParcelas((prev) => {
      const startIndex = prev.length;
      const toAdd = dates.map((d, i) => ({
        contrFornEvento_vlr: amounts[i],
        contrFornEvento_dtPrev: fmtYYYYMMDD(d),
        contrFornEvento_num: startIndex + i + 1,
        contrFornEvento_desc: `Parcela ${startIndex + i + 1}`,
      }));
      return [...prev, ...toAdd];
    });
  }

  function handleGerarParcelasCotacaoRapida() {
    if (isReadOnlyMode) return;

    const installments = parseInt(contrFornData.contrForn_numParcelas, 10);
    const valorCadaParcela = Number(valorCadaParcelaCotacaoRapida);

    if (!contrFornData.contrForn_dtVigIni || !contrFornData.contrForn_dtVigFim) {
      return notifyError('Informe a data de início e de fim da vigência antes de gerar as parcelas.');
    }
    if (!(installments > 0 && Number.isInteger(installments))) {
      return notifyError('Informe um número de parcelas válido.');
    }
    if (!(valorCadaParcela > 0) || !Number.isFinite(valorCadaParcela)) {
      return notifyError('Informe o valor de cada parcela.');
    }

    const vlrGlobal = Number(contrFornData.contrForn_vlrGlobal) || 0;
    const totalFromFields = Number((valorCadaParcela * installments).toFixed(2));
    const amounts = (
      vlrGlobal > 0
      && Math.abs(totalFromFields - vlrGlobal) < 0.05
    )
      ? splitValueIntoInstallments(vlrGlobal, installments)
      : Array.from({ length: installments }, () => valorCadaParcela);

    const startDate = moment(contrFornData.contrForn_dtVigIni);
    const parcelas = amounts.map((valor, index) => ({
      contrFornEvento_num: index + 1,
      contrFornEvento_desc: `Parcela ${index + 1}`,
      contrFornEvento_vlr: valor,
      contrFornEvento_dtPrev: startDate.clone().add(index, 'months').format('YYYY-MM-DD'),
    }));

    setListaParcelas(parcelas);
  }

  const buildPdfDoc = (savedAnexos = null) => {
    const anexosParaExibir = getAnexosParaPdf(savedAnexos, filesContrForn);
    const doc = new jsPDF()
    const accentColor = [0, 122, 114]
    const lightAccentColor = [231, 245, 243]
    const pageWidth = doc.internal.pageSize.getWidth()
    const normalizedOrcItem = selOrcItems.find(item => Number(item.value) === Number(contrFornData.orcItem_id))
    const contratado = contrFornData.contrForn_parteTab === 'pf'
      ? selPfsFornecedor.find(item => Number(item.value) === Number(contrFornData.contrForn_parteId))?.label
      : selPjsFornecedor.find(item => Number(item.value) === Number(contrFornData.contrForn_parteId))?.label
    const centroDeCusto = selCentroDeCusto.find(item => Number(item.value) === Number(contrFornData.centroDeCustoRubr_id))?.label
    const projeto = selProjetos.find(item => Number(item.orcRubr_id) === Number(contrFornData.orcRubr_id))?.label
    const tipoContrato = selTipoContrato.find(item => Number(item.value) === Number(contrFornData.contrFornTp_id))?.label
    const tipoMinuta = selTiposDeMinuta.find(item => Number(item.value) === Number(contrFornData.tpMinuta_id))?.label
    const formatDate = (value) => (value ? moment(value).format('DD/MM/YYYY') : '-')
    const formatText = (value) => (value && String(value).trim() ? String(value).trim() : '-')
    const formatCurrency = (value) => currencyFormatter.format(Number(value || 0))
    const valorGlobalExibido = contrFornData.contrForn_vlrFixo === 0
      ? listaParcelas.reduce((acc, parcela) => Number(acc) + Number(parcela.contrFornEvento_vlr || 0), 0)
      : contrFornData.contrForn_vlrGlobal

    doc.setFillColor(...accentColor)
    doc.rect(0, 0, pageWidth, 24, 'F')
    doc.setTextColor(255, 255, 255)
    doc.setFontSize(18)
    doc.setFont(undefined, 'bold')
    doc.text('Ecossis', 14, 15)
    doc.setFontSize(12)
    doc.text('Resumo de Contratação', pageWidth - 14, 15, { align: 'right' })

    doc.setTextColor(0, 0, 0)
    doc.setFontSize(10)
    doc.setFont(undefined, 'normal')
    doc.text(`Gerado em ${moment().format('DD/MM/YYYY HH:mm')}`, 14, 32)

    const summaryRows = [
      ['Objeto resumido', formatText(trimContrFornDesc())],
      ['Centro de custo', formatText(centroDeCusto)],
      ['Projeto', formatText(projeto)],
      ['Item orçamentário', formatText(normalizedOrcItem?.label)],
      ['Contratado', formatText(contratado)],
      ['Tipo de contratado', contrFornData.contrForn_parteTab === 'pf' ? 'Pessoa Física' : contrFornData.contrForn_parteTab === 'pj' ? 'Pessoa Jurídica' : '-'],
      ['Tipo de contrato', formatText(tipoContrato)],
      ...(isFormularioSemContrato
        ? [
          ['Meio de pagamento', formatText(
            selMeioPgto.find((item) => Number(item.value) === Number(contrFornData.meioPgto_id))?.label,
          )],
          ...(isMeioPagamentoPix ? [
            ['Tipo de chave', formatText(
              selPixTp.find((item) => Number(item.value) === Number(contrFornData.pixTp_id))?.label,
            )],
            ['Chave PIX', formatText(contrFornData.contrForn_chavePix)],
          ] : []),
          ...(isMeioPagamentoCartaoCredito ? [
            ['Cartão', formatText(
              selCartoesCredito.find((item) => Number(item.value) === Number(contrFornData.conta_id))?.label,
            )],
          ] : []),
        ]
        : [['Modelo de minuta', formatText(tipoMinuta)]]),
      ...(!isFormularioSemContrato ? [
        ['Início da vigência', formatDate(contrFornData.contrForn_dtVigIni)],
        ['Fim da vigência', formatDate(contrFornData.contrForn_dtVigFim)],
      ] : []),
      ['Valor global', formatCurrency(valorGlobalExibido)],
      ...(contrFornData.contrForn_dtPgtoFixa === 1
        ? [['Periodicidade', formatText(contrFornData.contrForn_periodicidade)]]
        : []),
      ...buildContrFornStandardExtraPdfRows(contrFornData),
    ]

    doc.autoTable({
      startY: 38,
      body: summaryRows,
      theme: 'grid',
      styles: { fontSize: 9, cellPadding: 3, textColor: [0, 0, 0] },
      columnStyles: {
        0: { fontStyle: 'bold', fillColor: lightAccentColor, cellWidth: 52 },
      },
      tableLineColor: [210, 225, 222],
      tableLineWidth: 0.1,
    })

    let currentY = (doc.lastAutoTable || doc.previousAutoTable).finalY + 10

    const sectionTitle = (title) => {
      if (currentY > 265) {
        doc.addPage()
        currentY = 20
      }
      doc.setFontSize(12)
      doc.setFont(undefined, 'bold')
      doc.setTextColor(...accentColor)
      doc.text(title, 14, currentY)
      currentY += 6
      doc.setTextColor(0, 0, 0)
      doc.setFont(undefined, 'normal')
    }

    sectionTitle('Objeto do contrato')
    const objLines = doc.splitTextToSize(formatText(contrFornData.contrForn_obj), pageWidth - 28)
    doc.setFontSize(10)
    doc.text(objLines, 14, currentY)
    currentY += (objLines.length * 5) + 6

    sectionTitle('Detalhamento do serviço')
    const detailLines = doc.splitTextToSize(formatText(contrFornData.contrForn_detalhamento), pageWidth - 28)
    doc.text(detailLines, 14, currentY)
    currentY += (detailLines.length * 5) + 6

    sectionTitle('Observações')
    const obsLines = doc.splitTextToSize(formatText(contrFornData.contrForn_obs), pageWidth - 28)
    doc.text(obsLines, 14, currentY)
    currentY += (obsLines.length * 5) + 8

    if (showEquipeContrFornFields) {
      sectionTitle('Informações de contratação (equipe)')
      doc.autoTable({
        startY: currentY,
        body: buildContrFornExtendedFieldsPdfRows(contrFornData),
        theme: 'grid',
        styles: { fontSize: 9, cellPadding: 3, textColor: [0, 0, 0] },
        columnStyles: {
          0: { fontStyle: 'bold', fillColor: lightAccentColor, cellWidth: 72 },
        },
        tableLineColor: [210, 225, 222],
        tableLineWidth: 0.1,
      })
      currentY = (doc.lastAutoTable || doc.previousAutoTable).finalY + 10
    }

    if (getContrFornDocumentosObrigatoriosIds(contrFornData).length > 0) {
      sectionTitle('Documentos obrigatórios')
      const documentosLabel = formatDocumentosObrigatoriosLabels(
        contrFornData,
        documentosObrigatoriosOptions,
      )
      const documentosLines = doc.splitTextToSize(formatText(documentosLabel), pageWidth - 28)
      doc.setFontSize(10)
      doc.text(documentosLines, 14, currentY)
      currentY += (documentosLines.length * 5) + 8
    }

    if (anexosParaExibir.length > 0) {
      sectionTitle('Anexos do contrato')
      const anexosRows = anexosParaExibir.map((anexo) => ([
        formatText(anexo.documento_desc || anexo.arquivo_caminho),
        formatText(anexo.link),
      ]))

      doc.autoTable({
        startY: currentY,
        head: [['Documento', 'Link']],
        body: anexosRows,
        theme: 'grid',
        styles: { fontSize: 9, cellPadding: 3, textColor: [0, 0, 0] },
        headStyles: { fillColor: accentColor, textColor: [255, 255, 255], fontStyle: 'bold' },
        alternateRowStyles: { fillColor: [248, 251, 250] },
        columnStyles: {
          0: { cellWidth: 60 },
          1: { cellWidth: 'auto' },
        },
        tableLineColor: [210, 225, 222],
        tableLineWidth: 0.1,
      })
      currentY = (doc.lastAutoTable || doc.previousAutoTable).finalY + 10
    }

    sectionTitle('Parcelas')
    const parcelasRows = listaParcelas.length > 0
      ? listaParcelas.map((parcela, index) => ([
        parcela.contrFornEvento_num || index + 1,
        formatText(parcela.contrFornEvento_desc),
        formatDate(parcela.contrFornEvento_dtPrev),
        parcela.contrFornEvento_dependeAtividade === 1 ? formatText(parcela.contrFornEvento_pgtoPrazoDias) : '-',
        formatCurrency(parcela.contrFornEvento_vlr),
      ]))
      : [['-', 'Nenhuma parcela cadastrada', '-', '-', '-']]

    doc.autoTable({
      startY: currentY,
      head: [['Número', 'Descrição', 'Data prevista', 'Prazo (dias)', 'Valor']],
      body: parcelasRows,
      theme: 'grid',
      styles: { fontSize: 9, cellPadding: 3, textColor: [0, 0, 0] },
      headStyles: { fillColor: accentColor, textColor: [255, 255, 255], fontStyle: 'bold' },
      alternateRowStyles: { fillColor: [248, 251, 250] },
      tableLineColor: [210, 225, 222],
      tableLineWidth: 0.1,
    })

    const formatText2 = (value) => (value && String(value).trim() ? String(value).trim() : 'ecossis')
    const fileName = `contratacao_${formatText2(trimContrFornDesc()).toLowerCase().replace(/[^a-z0-9]+/g, '_')}.pdf`
    return { doc, fileName }
  }

  const handleGeneratePdf = () => {
    const { doc, fileName } = buildPdfDoc()
    doc.save(fileName)
  };

  const handleCopyFormularioFornecedorLink = async () => {
    const contrFornId = Number(contrFornData?.contrForn_id) || 0;
    if (!contrFornId || isCopyingFormLink) return;

    setIsCopyingFormLink(true);
    try {
      const built = await buildFormContratacaoFornecedorLinkByContrFornId(contrFornId);
      if (!built?.formLink) return;

      await navigator.clipboard.writeText(built.formLink);
      notifySuccess('Link do formulário copiado.');
    } catch (error) {
      console.error('Erro ao copiar o link do formulário do fornecedor:', error);
      notifyError('Não foi possível copiar o link do formulário.');
    } finally {
      setIsCopyingFormLink(false);
    }
  };

  const renderTabelaOrcamentoMensal = () => {
    if (effectiveHideParcelasOrcamentoTable) return null;

    const somaVlrParcelas = parcelasTabelaOrcamento.reduce(
      (prev, cur) => Number(prev) + Number(cur.contrFornEvento_vlr || 0),
      0,
    );
    const somaDisponivel = filteredValoresLimites.reduce(
      (prev, cur) => Number(cur.disponivel) + prev,
      0,
    );
    const saldoDisponivel = somaDisponivel - somaVlrParcelas;

    return (
      <Col sm={12} className="pt-4">
        {!hasVigenciaDatesForResumo ? (
          <span style={{ fontWeight: 'bold' }}>
            Selecione uma data de início e fim de vigência
          </span>
        ) : isVigenciaDatasInvalidasMemo ? (
          <span style={{ fontWeight: 'bold' }}>Datas de início e/ou fim erradas.</span>
        ) : (
          <div className="table-responsive">
            <Table striped bordered>
              <thead>
                <tr>
                  <th></th>
                  {filteredDotacoes?.length > 0 && filteredDotacoes.map((dotacao, index) => {
                    const date = new Date(`${dotacao.orcDot_data}T12:00:00`);
                    const month = date.toLocaleDateString('pt-BR', { month: 'short' });
                    const year = date.getFullYear();
                    const formattedMonth = month.replace('.', '').charAt(0).toUpperCase() + month.slice(1, 3);

                    return (
                      <th key={index} style={{ minWidth: '10vw' }}>
                        {`${formattedMonth}/${year}`}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {(filteredDotacoes?.length > 0 && filteredValoresLimites?.length > 0) ? (
                  <>
                    <tr>
                      <th>Orçado</th>
                      {filteredDotacoes.map((_, index) => {
                        if (!filteredDotacoes[index]?.orcDot_valor) {
                          return <td key={`prov-${index}`}>{currencyFormatter.format(0)}</td>;
                        }
                        return (
                          <td key={`prov-${index}`}>
                            {currencyFormatter.format(filteredDotacoes[index].orcDot_valor)}
                          </td>
                        );
                      })}
                    </tr>
                    <tr>
                      <th>Já alocado</th>
                      {filteredValoresLimites.map((_, index) => {
                        if (!filteredDotacoes[index]?.orcDot_valor) {
                          return <td key={`prov-${index}`}>{currencyFormatter.format(0)}</td>;
                        }
                        const monthRef = filteredDotacoes[index].orcDot_data.slice(0, 7);
                        const sumOrcadoMes = filteredDotacoes
                          .filter(dotacao => dotacao.orcDot_data ? dotacao.orcDot_data.slice(0, 7) === monthRef : false)
                          .reduce((acc, curr) => acc + Number(curr.orcDot_valor || 0), 0);
                        const disponivelMes = Number(filteredValoresLimites[index]?.disponivel || 0);
                        const somaPersistidaMes = listaParcelasPersistidas
                          .filter((parcela) => {
                            const dtPrev = getParcelaDtPrevParaSaldo(parcela);
                            return dtPrev ? dtPrev.slice(0, 7) === monthRef : false;
                          })
                          .reduce((acc, curr) => acc + Number(curr.contrFornEvento_vlr || 0), 0);
                        const jaAlocadoOutrosContratos = Math.max(
                          0,
                          (sumOrcadoMes - disponivelMes) - somaPersistidaMes
                        );
                        return (
                          <td key={`prov-${index}`}>
                            {currencyFormatter.format(jaAlocadoOutrosContratos)}
                          </td>
                        );
                      })}
                    </tr>
                    <tr>
                      <th>Valor disponível</th>
                      {filteredValoresLimites.map((_, index) => {
                        if (!filteredValoresLimites[index]) {
                          return <td key={`prov-${index}`}>{currencyFormatter.format(0)}</td>;
                        }
                        return (
                          <td key={`prov-${index}`}>
                            {currencyFormatter.format(filteredValoresLimites[index].disponivel)}
                          </td>
                        );
                      })}
                    </tr>
                    <tr>
                      <th>Soma dos eventos</th>
                      {filteredDotacoes.map((dotacao, index) => {
                        const monthRef = dotacao.orcDot_data.slice(0, 7);
                        const sumForMonth = parcelasTabelaOrcamento
                          .filter((parcela) => {
                            const dtPrev = getParcelaDtPrevParaSaldo(parcela);
                            return dtPrev ? dtPrev.slice(0, 7) === monthRef : false;
                          })
                          .reduce((acc, curr) => acc + Number(curr.contrFornEvento_vlr || 0), 0);

                        return (
                          <td key={`val-${index}`}>
                            {currencyFormatter.format(sumForMonth)}
                          </td>
                        );
                      })}
                    </tr>
                    <tr>
                      <th>Diferença</th>
                      {filteredDotacoes.map((dotacao, index) => {
                        const monthRef = dotacao.orcDot_data.slice(0, 7);
                        const somaParcelas = parcelasTabelaOrcamento
                          .filter((parcela) => {
                            const dtPrev = getParcelaDtPrevParaSaldo(parcela);
                            return dtPrev ? dtPrev.slice(0, 7) === monthRef : false;
                          })
                          .reduce((acc, cur) => acc + Number(cur.contrFornEvento_vlr || 0), 0);
                        const sumOrcadoMes = filteredDotacoes
                          .filter(item => item.orcDot_data ? item.orcDot_data.slice(0, 7) === monthRef : false)
                          .reduce((acc, curr) => acc + Number(curr.orcDot_valor || 0), 0);
                        const disponivelMes = Number(filteredValoresLimites[index]?.disponivel || 0);
                        const somaPersistidaMes = listaParcelasPersistidas
                          .filter((parcela) => {
                            const dtPrev = getParcelaDtPrevParaSaldo(parcela);
                            return dtPrev ? dtPrev.slice(0, 7) === monthRef : false;
                          })
                          .reduce((acc, cur) => acc + Number(cur.contrFornEvento_vlr || 0), 0);
                        const jaAlocadoOutrosContratos = Math.max(
                          0,
                          (sumOrcadoMes - disponivelMes) - somaPersistidaMes
                        );
                        const diferenca = sumOrcadoMes - jaAlocadoOutrosContratos - somaParcelas;
                        const color = diferenca < 0 ? 'red' : 'green';

                        return (
                          <td key={`dif-${index}`} style={{ color }}>
                            {currencyFormatter.format(diferenca)}
                          </td>
                        );
                      })}
                    </tr>
                  </>
                ) : <></>}
              </tbody>
              <tfoot>
                <tr>
                  <td>Saldo disponível</td>
                  <td style={{ color: saldoDisponivel < 0 ? 'red' : 'green' }}>
                    {currencyFormatter.format(saldoDisponivel)}
                  </td>
                </tr>
              </tfoot>
            </Table>
          </div>
        )}
      </Col>
    );
  };

  return (
    <>
      {!props.hideTrigger && (
      <IconButton
        onClick={async () => {
          await openModalFlow();
        }}
      >
        {isLoading ? <Spinner /> : <MonetizationOn />}
      </IconButton>
      )}

      <Modal
        isOpen={modalIsOpen}
        toggle={handleClickCloseModal}
        size="xl"
        >
        <ModalHeader>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {isAguardandoInfoFornecedor
              ? 'Aguardando informações do fornecedor'
              : isSupplierInfoValidationMode
              ? 'Validar informações enviadas pelo fornecedor'
              : (props.modalTitle || (props.standalone ? 'Cadastro de contrato de fornecedor' : isReadOnlyMode ? 'Contratação (visualização)' : isRejectedContractResubmit ? 'Contratação (reenvio)' : 'Contratação'))}
          </Typography>
        </ModalHeader>
        <ModalBody>
          {isLoading ? (
            <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '260px' }}>
              <Spinner />
              <span className="mt-3">Carregando item orçamentário...</span>
            </div>
          ) : isAguardandoInfoFornecedor ? (
            <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ minHeight: '220px' }}>
              <Typography variant="body1">
                Aguardando o envio das informações pelo fornecedor.
              </Typography>
              <Typography variant="body2" color="textSecondary" className="mt-2">
                Você pode copiar o mesmo link enviado por e-mail e encaminhá-lo diretamente ao fornecedor.
              </Typography>
            </div>
          ) : (
            <>
              {isSupplierInfoValidationMode && (
                <Box sx={{ mb: 3, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                  {['Dados cadastrais e proposta', 'Contrato'].map((label, idx) => {
                    const stepNumber = idx + 1;
                    const isActive = validationStep === stepNumber;

                    return (
                      <Typography
                        key={label}
                        component="button"
                        type="button"
                        variant="body2"
                        onClick={() => handleValidationGoToStep(stepNumber)}
                        sx={{
                          fontWeight: isActive ? 700 : 400,
                          color: isActive ? 'primary.main' : 'text.secondary',
                          cursor: 'pointer',
                          border: 'none',
                          background: 'none',
                          padding: 0,
                          textAlign: 'left',
                          textDecoration: isActive ? 'underline' : 'none',
                          '&:hover': {
                            color: 'primary.main',
                            textDecoration: 'underline',
                          },
                        }}
                      >
                        {stepNumber}. {label}
                      </Typography>
                    );
                  })}
                </Box>
              )}

              {isSupplierInfoValidationMode && validationStep === 1 && (
                <ContrFornValidationStepCadastro
                  parsedInfo={parsedCompraCotacaoInfo}
                  sourceDocuments={sourceDocuments}
                  validationAnswer={step1ValidationAnswer}
                  onValidationAnswerChange={handleStep1ValidationAnswerChange}
                  rejectionJustification={step1RejectionJustification}
                  onRejectionJustificationChange={setStep1RejectionJustification}
                />
              )}

              {(!isSupplierInfoValidationMode || validationStep === 2) && (
            <>
              {Number(contrFornData.contrFornStatus_id) === 11 && String(contrFornData.contrForn_consideracoesInteressado || '').trim() && !isValidationContractStep && (
                <Box
                  sx={{
                    mb: 3,
                    p: 2,
                    border: '1px solid #f0c36d',
                    backgroundColor: '#fff7e6',
                    borderRadius: '6px',
                  }}
                >
                  <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
                    Considerações do interessado
                  </Typography>
                  <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                    {contrFornData.contrForn_consideracoesInteressado}
                  </Typography>
                </Box>
              )}

              {!isSupplierInfoValidationMode && (isLoadingSourceDocuments || sourceDocuments.length > 0) && (() => {
                const sourceRecord = getSourceDocumentRecord();
                const sectionTitle = sourceRecord?.titulo || 'Documentos vinculados';

                return (
                  <Box
                    sx={{
                      mb: 3,
                      p: 2,
                      border: '1px solid #d9dee8',
                      backgroundColor: '#f7f9fc',
                      borderRadius: '6px',
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
                      {sectionTitle}
                    </Typography>
                    {isLoadingSourceDocuments ? (
                      <Typography variant="body2" color="text.secondary">
                        Carregando arquivos vinculados...
                      </Typography>
                    ) : (
                      sourceDocuments.map((doc) => {
                        const filePath = doc?.arquivo_caminho;
                        const fileName = doc?.arquivo_desc || doc?.documento_desc || filePath || 'Arquivo';
                        const fileUrl = filePath ? `https://oikos.ecoss.is/oikos/${filePath}` : null;

                        return (
                          <Box key={doc.arquivo_id || doc.documento_id || doc.documentoVinc_id || fileName} sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 0.5 }}>
                            <Typography variant="body2" sx={{ flex: 1, minWidth: 0 }} noWrap title={fileName}>
                              {fileName}
                            </Typography>
                            {fileUrl && (
                              <Button color="primary" size="sm" tag="a" href={fileUrl} target="_blank" rel="noopener noreferrer">
                                Visualizar
                              </Button>
                            )}
                          </Box>
                        );
                      })
                    )}
                  </Box>
                );
              })()}

              <fieldset disabled={isReadOnlyMode} style={{ border: 0, margin: 0, padding: 0, minWidth: 0 }}>
              <Row>
              {isValidationContractStep ? (
                <>
                  {!isMinutaFornecedor && (
                    <>
                      <Col sm={6} md={4}>
                        <FormGroup>
                          <Label>
                            Modelo de minuta da Ecossis
                          </Label>
                          <Select
                            classNamePrefix="select2-selection"
                            placeholder="Selecione"
                            isClearable
                            isDisabled={isReadOnlyMode}
                            options={selMinutaMod}
                            value={contrFornData.minutaMod_id
                              ? selMinutaMod.filter((x) => Number(x.value) === Number(contrFornData.minutaMod_id))
                              : null}
                            onChange={(option) => setContrFornData({
                              ...contrFornData,
                              minutaMod_id: option?.value ? Number(option.value) : null,
                            })}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={12}>
                        <ContrFornValidationMinutaPreview
                          minutaModId={contrFornData.minutaMod_id}
                          contrFornData={contrFornData}
                          compraCotacaoInfo={parsedCompraCotacaoInfo}
                          selContratantes={selContratantes}
                          selPfsFornecedor={selPfsFornecedor}
                          selPjsFornecedor={selPjsFornecedor}
                        />
                      </Col>
                    </>
                  )}
                  {!effectiveHideContratoDetalhamento && (
                    <Col sm={12}>
                      <FormGroup>
                        <Label>
                          Campo de detalhamento do serviço
                        </Label>
                        <TextareaAutosize
                          placeholder='Detalhamento do serviço...'
                          margin="dense"
                          id="input_obs"
                          name="input_obs"
                          variant="standard"
                          value={contrFornData.contrForn_detalhamento || null}
                          className='mb-3 p-1'
                          style={{ width: '100%', height: '100px' }}
                          readOnly={isReadOnlyMode}
                          onChange={(e) => setContrFornData({ ...contrFornData, contrForn_detalhamento: e.target.value })}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  <Col sm={12}>
                    <ContrFornValidationEntregaveis
                      valorGlobalProposta={valorGlobalProposta}
                      entregaveis={listaParcelas}
                      onChange={setListaParcelas}
                      onDraftChange={setEntregavelDraftParcela}
                      disabled={isReadOnlyMode}
                      parcelasMensaisFixas={parcelasMensaisFixas}
                      onParcelasMensaisFixasChange={setParcelasMensaisFixas}
                    />
                  </Col>
                  {renderTabelaOrcamentoMensal()}
                </>
              ) : (
              <>
              <Col sm={3}>
                <FormGroup>
                  <Label>
                    Centro de custo
                  </Label>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="Selecione um item"
                    value={contrFornData.centroDeCustoRubr_id ? selCentroDeCusto.filter(x => (Number(x.value) === Number(contrFornData.centroDeCustoRubr_id))) : null}
                    options={selCentroDeCusto}
                    isDisabled={isReadOnlyMode || props.centroDeCustoDisabled}
                    onChange={(e) => {
                      const centroId = e?.value ?? null;
                      setBdrosOrcItem([]);
                      limparBdrosDasParcelas();
                      setListaDotacoes([]);

                      if (!centroId) {
                        setSelProjetos([]);
                        setSelOrcItems([]);
                        setContrFornData({
                          ...contrFornData,
                          centroDeCustoRubr_id: null,
                          orcRubr_id: null,
                          orcItem_id: null,
                        });
                        return;
                      }

                      if (Number(centroId) === 14) {
                        fetchProjectsForSelect();
                        setSelOrcItems([]);
                        setContrFornData({
                          ...contrFornData,
                          centroDeCustoRubr_id: centroId,
                          orcRubr_id: null,
                          orcItem_id: null,
                        });
                        return;
                      }

                      setSelProjetos([]);
                      setContrFornData({
                        ...contrFornData,
                        centroDeCustoRubr_id: centroId,
                        orcRubr_id: null,
                        orcItem_id: null,
                      });
                      fetchOrcItemsForSelect(centroId);
                    }}
                  />
                </FormGroup>
              </Col>

              { selProjetos.length > 0 && isFetchingProjectLoading === false &&
                <Col sm={9}>
                  <FormGroup>
                    <Label onClick={() => console.log(contrFornData.orcRubr_id, selProjetos.filter(x => (x.orcRubr_id === contrFornData.orcRubr_id)))}>
                      Projeto
                    </Label>
                    <Select
                      classNamePrefix="select2-selection"
                      placeholder="Selecione um item"
                      isDisabled={isReadOnlyMode || props.orcItemDisabled}
                      value={contrFornData.orcRubr_id ? selProjetos.find(x => Number(x.orcRubr_id) === Number(contrFornData.orcRubr_id)) : null}
                      options={selProjetos}
                      onChange={(e) => {
                        const orcRubrId = e?.orcRubr_id ?? null;
                        setContrFornData({ ...contrFornData, orcRubr_id: orcRubrId, orcItem_id: null });
                        setBdrosOrcItem([]);
                        limparBdrosDasParcelas();
                        if (orcRubrId) {
                          fetchOrcItemsForSelect(contrFornData.centroDeCustoRubr_id, orcRubrId);
                        } else {
                          setSelOrcItems([]);
                        }
                      }}
                    />
                  </FormGroup>
                </Col>
              }

              <Col sm={12}>
                <FormGroup>
                  <div className="d-flex flex-wrap align-items-end" style={{ gap: '8px' }}>
                    <div style={{ flex: '1 1 280px', minWidth: 0 }}>
                      <Label>
                        Item orçamentário
                      </Label>
                      <Select
                        classNamePrefix="select2-selection"
                        placeholder="Selecione um item"
                        value={contrFornData.orcItem_id ? orcItemsFiltradosPorCentroDeCusto.filter(x => (Number(x.value) === Number(contrFornData.orcItem_id))) : null}
                        options={orcItemsFiltradosPorCentroDeCusto}
                        getOptionLabel={formatOrcItemSelectLabel}
                        isDisabled={isReadOnlyMode || props.orcItemDisabled}
                        onChange={(e) => {
                          const nextOrcItemId = e?.value ?? null;
                          const isEquipe = isEquipeOrcItemById(selOrcItems, nextOrcItemId);
                          setContrFornData({
                            ...contrFornData,
                            orcItem_id: nextOrcItemId,
                            ...(isEquipe ? {} : getEmptyContrFornExtendedFields()),
                          });
                          limparBdrosDasParcelas();
                          console.log(nextOrcItemId);
                          getOrcDots(nextOrcItemId);
                        }}
                      />
                    </div>
                    <IconButton
                      size="small"
                      type="button"
                      disabled={!Number(contrFornData.orcItem_id) || isRefreshingOrcDots}
                      onClick={handleRefreshOrcDots}
                      aria-label="Atualizar saldo orçamentário"
                      title="Atualizar valor disponível, dotações e valores já alocados"
                      sx={{
                        marginBottom: '8px',
                        border: '1px solid #ced4da',
                        borderRadius: '8px',
                        width: 36,
                        height: 36,
                      }}
                    >
                      {isRefreshingOrcDots ? <Spinner size="sm" /> : <Refresh fontSize="small" />}
                    </IconButton>
                    {!Number(contrFornData.orcItem_id) && (
                    <div>
                      <Label>
                        Não encontrou o item orçamentário?
                      </Label>
                      <div>
                        <Button
                          type="button"
                          color="secondary"
                          disabled={isReadOnlyMode}
                          onClick={handleOpenSolicitarOrcItem}
                        >
                          Solicitar criação de um item orçamentário
                        </Button>
                      </div>
                    </div>
                    )}
                  </div>
                </FormGroup>
              </Col>

              <Col sm={4}>
                <FormGroup>
                  <Label>
                    Data Início Vigência
                  </Label>
                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    disabled={isReadOnlyMode}
                    selected={contrFornData.contrForn_dtVigIni ? moment(contrFornData.contrForn_dtVigIni).toDate() : null}
                    onChange={date => {
                      if (date) {
                        setContrFornData({ ...contrFornData, contrForn_dtVigIni: moment(date).format('YYYY-MM-DD') });
                      } else {
                        setContrFornData({ ...contrFornData, contrForn_dtVigIni: null });
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              <Col sm={4}>
                <FormGroup>
                  <Label>
                    Data Fim Vigência
                  </Label>
                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    disabled={isReadOnlyMode}
                    selected={contrFornData.contrForn_dtVigFim ? moment(contrFornData.contrForn_dtVigFim).toDate() : null}
                    onChange={date => {
                      if(date) {
                        setContrFornData({ ...contrFornData, contrForn_dtVigFim: moment(date).format('YYYY-MM-DD') })
                      } else {
                        setContrFornData({ ...contrFornData, contrForn_dtVigFim: null })
                      }
                    }}
                  />
                </FormGroup>
              </Col>

              <Col sm={4}>
                <FormGroup>
                  <Label>
                    Valor
                  </Label>
                  <MaskedInput
                    unmask
                    inputRef={el => {const inputVlrGlobal = el}}
                    mask="R$ num"
                    disabled={isReadOnlyMode || contrFornData.contrForn_vlrFixo === 0}
                    blocks={{
                      num: {
                        mask: Number,
                        scale: 2, // digits after point 0 for integers
                        signed: false, // disallow negative
                        thousandsSeparator: '.', // any single char
                        padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                        normalizeZeros: false, // appends or removes zeros at ends
                        radix: ',', // fractional delimiter
                        min: 0,
                        max: 1000000000,
                      },
                    }}
                    lazy={false}
                    value={contrFornData.contrForn_vlrFixo === 0 ? String(listaParcelas.reduce((acc,cur) => {
                      console.log('acc e cur', acc, cur);
                      return Number(acc) + Number(cur.contrFornEvento_vlr)
                    }, 0)) : String(contrFornData.contrForn_vlrGlobal)}
                    onAccept={value => {
                      const vlrGlobal = Number(value);
                      const numParcelasNumber = Number(contrFornData.contrForn_numParcelas);
                      if (
                        isFormularioSemContrato
                        && Number.isInteger(numParcelasNumber)
                        && numParcelasNumber > 0
                        && vlrGlobal > 0
                      ) {
                        setValorCadaParcelaCotacaoRapida(
                          String(Number((vlrGlobal / numParcelasNumber).toFixed(2))),
                        );
                      }
                      setContrFornData({ ...contrFornData, contrForn_vlrGlobal: value });
                    }}
                  />
                </FormGroup>
              </Col>

              {
                (contrFornData.orcItem_id && hasVigenciaDatesForResumo) ?
                  isVigenciaDatasInvalidasMemo ? (
                    <Col sm={12} className='mb-4'>
                      <span style={{ fontWeight: 'bold' }}>Datas de início e/ou fim erradas.</span>
                    </Col>
                  ) : (
                  <Col sm={12} className='mb-4'>
                    <div className='mb-2 d-flex flex-wrap'>
                      {resumoOrcamentoPorAno.map(({
                        year,
                        somaDotacoes,
                        valorDisponivel,
                        jaAlocados,
                      }) => (
                        <div key={year} className='d-flex flex-column mr-4 mb-2'>
                          <strong className='mb-1'>{year}</strong>
                          <span>
                            Valor disponível:{' '}
                            <span style={{ fontWeight: 'bold' }}>
                              {currencyFormatter.format(valorDisponivel)}
                            </span>
                          </span>
                          <span>
                            Soma de dotações para esse item:{' '}
                            <span style={{ fontWeight: 'bold' }}>
                              {currencyFormatter.format(somaDotacoes)}
                            </span>
                          </span>
                          <span>
                            Já alocados:{' '}
                            <span style={{ fontWeight: 'bold' }}>
                              {currencyFormatter.format(jaAlocados)}
                            </span>
                          </span>
                        </div>
                      ))}
                    </div>
                  </Col>
                  )
                : (contrFornData.orcItem_id && !hasVigenciaDatesForResumo) ?
                  <Col sm={12} className='mb-4'>
                    <span style={{ fontWeight: 'bold' }}>
                      Selecione uma data de início e fim de vigência
                    </span>
                  </Col>:
                <></>
              }

              {showContratante && (
                <Col sm={4}>
                  <FormGroup>
                    <Label>Contratante</Label>
                    <Select
                      classNamePrefix="select2-selection"
                      placeholder="Selecione o contratante"
                      isDisabled={isReadOnlyMode}
                      value={selContratantes.filter((item) => (
                        Number(item.value) === Number(contrFornData.contrForn_contratante)
                      ))}
                      options={selContratantes}
                      onChange={(option) => setContrFornData({
                        ...contrFornData,
                        contrForn_contratante: option?.value ?? null,
                      })}
                    />
                  </FormGroup>
                </Col>
              )}

              {!effectiveHideTipoContratado && (
              <Col sm={4}>
                <FormGroup>
                  <Label>
                    Tipo de contratado
                  </Label>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="PF ou PJ"
                    isDisabled={isReadOnlyMode}
                    value={[{value: 'pf', label: 'Pessoa Física'}, {value: 'pj', label: 'Pessoa Jurídica'}].filter(x => (x.value === contrFornData.contrForn_parteTab))}
                    options={[{value: 'pf', label: 'Pessoa Física'}, {value: 'pj', label: 'Pessoa Jurídica'}]}
                    onChange={(e) => setContrFornData({
                      ...contrFornData,
                      contrForn_parteTab: e.value,
                      contrForn_parteId: null,
                    })}
                  />
                </FormGroup>
              </Col>
              )}

              {!effectiveHideContratado && (
              <Col sm={4}>
                <FormGroup>
                  <div className="d-flex">
                    <Label>
                      Contratado
                    </Label>
                    {!isReadOnlyMode && (
                    <ModalFormAddFornecedor
                      contrFornData={contrFornData}
                      setContrFornData={setContrFornData}
                      getPossiveisFornecedores={getPossiveisFornecedores}
                      fetchFornecedoresForSelect={fetchFornecedoresForSelect}
                      isPf={contrFornData.contrForn_parteTab === 'pf'}
                      setSelPfsFornecedor={setSelPfsFornecedor}
                      setSelPjsFornecedor={setSelPjsFornecedor}
                      fetchPfsFornecedoresForSelect={fetchPfsFornecedoresForSelect}
                      fetchPjsFornecedoresForSelect={fetchPjsFornecedoresForSelect}
                    />
                    )}
                    {
                      !isReadOnlyMode && contrFornData.contrForn_parteId &&
                      <ModalFormEditFornecedor
                        contrFornData={contrFornData}
                        contrForn_parteId={contrFornData.contrForn_parteId}
                        setContrFornData={setContrFornData}
                        getPossiveisFornecedores={getPossiveisFornecedores}
                        fetchFornecedoresForSelect={fetchFornecedoresForSelect}
                        isPf={contrFornData.contrForn_parteTab === 'pf'}
                        setSelPfsFornecedor={setSelPfsFornecedor}
                        setSelPjsFornecedor={setSelPjsFornecedor}
                        fetchPfsFornecedoresForSelect={fetchPfsFornecedoresForSelect}
                        fetchPjsFornecedoresForSelect={fetchPjsFornecedoresForSelect}
                      />
                    }
                  </div>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="Selecione um contratado"
                    isDisabled={isReadOnlyMode}
                    value={contrFornData.contrForn_parteTab === 'pf' ? selPfsFornecedor.filter(x => (x.value === contrFornData.contrForn_parteId)) : selPjsFornecedor.filter(x => (x.value === contrFornData.contrForn_parteId))}
                    options={!contrFornData.contrForn_parteTab ? [] : contrFornData.contrForn_parteTab === 'pf' ? selPfsFornecedor : selPjsFornecedor}
                    onChange={(e) => setContrFornData({ ...contrFornData, contrForn_parteId: e.value })}
                  />
                </FormGroup>
              </Col>
              )}

              {showEmailFornecedor && (
                <Col sm={4}>
                  <FormGroup>
                    <Label>E-mail do fornecedor</Label>
                    <Input
                      type="email"
                      placeholder="email@fornecedor.com"
                      value={compraCotacaoData.compraCotacao_emailInteressado || ''}
                      disabled={isReadOnlyMode}
                      onChange={(e) => setCompraCotacaoData({
                        ...compraCotacaoData,
                        compraCotacao_emailInteressado: e.target.value,
                      })}
                    />
                  </FormGroup>
                </Col>
              )}

              {effectiveShowDocumentosObrigatoriosField && (
                <Col sm={4}>
                  <FormGroup>
                    <Label>Documentos Obrigatórios</Label>
                    <Select
                      classNamePrefix="select2-selection"
                      placeholder="Selecione"
                      isMulti
                      isClearable
                      closeMenuOnSelect={false}
                      isDisabled={isReadOnlyMode}
                      options={documentosObrigatoriosOptions}
                      value={documentosObrigatoriosOptions.filter((option) => (
                        getContrFornDocumentosObrigatoriosIds(contrFornData).includes(Number(option.value))
                      ))}
                      onChange={(options) => {
                        const selectedDocumentos = (options || []).map((option) => Number(option.value));
                        setContrFornData({
                          ...contrFornData,
                          contrForn_documentosObrigatorios: selectedDocumentos,
                        });
                      }}
                    />
                  </FormGroup>
                </Col>
              )}

              {!isFormularioSemContrato && (
              <Col sm={4}>
                <FormGroup>
                  <Label>
                    Modelo de minuta
                  </Label>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="Modelo de minuta"
                    isDisabled={isReadOnlyMode}
                    value={contrFornData.tpMinuta_id ? selTiposDeMinuta.filter(x => (x.value === contrFornData.tpMinuta_id)) : null}
                    options={selTiposDeMinuta}
                    onChange={(e) => setContrFornData({ ...contrFornData, tpMinuta_id: e.value })}
                  />
                </FormGroup>
              </Col>
              )}

              {isFormularioSemContrato && (
              <Col sm={4}>
                <FormGroup>
                  <Label>Meio de pagamento</Label>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="Selecione"
                    isClearable
                    isDisabled={isReadOnlyMode}
                    value={selMeioPgto.find(
                      (option) => Number(option.value) === Number(contrFornData.meioPgto_id),
                    ) || null}
                    options={selMeioPgto}
                    onChange={(option) => {
                      const meioPgtoId = option?.value != null ? Number(option.value) : null;
                      setContrFornData({
                        ...contrFornData,
                        meioPgto_id: meioPgtoId,
                        ...(meioPgtoId === MEIO_PGTO.PIX ? {} : {
                          pixTp_id: null,
                          contrForn_chavePix: null,
                        }),
                        ...(meioPgtoId === MEIO_PGTO.CARTAO ? {} : {
                          conta_id: null,
                        }),
                      });
                    }}
                  />
                </FormGroup>
              </Col>
              )}

              {isMeioPagamentoPix && (
              <>
                <Col sm={4}>
                  <FormGroup>
                    <Label>Tipo de chave</Label>
                    <Select
                      classNamePrefix="select2-selection"
                      placeholder="Selecione"
                      isClearable
                      isDisabled={isReadOnlyMode}
                      options={selPixTp}
                      value={selPixTp.filter(
                        (item) => Number(item.value) === Number(contrFornData.pixTp_id),
                      )}
                      onChange={(option) => setContrFornData({
                        ...contrFornData,
                        pixTp_id: option?.value ?? null,
                      })}
                    />
                  </FormGroup>
                </Col>
                <Col sm={4}>
                  <FormGroup>
                    <Label>Chave PIX</Label>
                    <Input
                      type="text"
                      placeholder="Informe a chave PIX"
                      disabled={isReadOnlyMode}
                      value={contrFornData.contrForn_chavePix || ''}
                      onChange={(e) => setContrFornData({
                        ...contrFornData,
                        contrForn_chavePix: e.target.value,
                      })}
                    />
                  </FormGroup>
                </Col>
              </>
              )}

              {isMeioPagamentoCartaoCredito && (
              <Col sm={4}>
                <FormGroup>
                  <Label>Cartão</Label>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="Selecione"
                    isClearable
                    isDisabled={isReadOnlyMode}
                    options={selCartoesCredito}
                    value={selCartoesCredito.filter(
                      (item) => Number(item.value) === Number(contrFornData.conta_id),
                    )}
                    onChange={(option) => setContrFornData({
                      ...contrFornData,
                      conta_id: option?.value ?? null,
                    })}
                  />
                </FormGroup>
              </Col>
              )}

              {isFormularioSemContrato && !isSupplierInfoValidationMode && (
              <>
                <Col sm={3}>
                  <FormGroup>
                    <Label>Parcelas</Label>
                    <Input
                      type="number"
                      min={1}
                      step={1}
                      placeholder="Qtd. de parcelas..."
                      disabled={isReadOnlyMode}
                      value={contrFornData.contrForn_numParcelas || ''}
                      onChange={(e) => {
                        const numParcelas = e.target.value;
                        const numParcelasNumber = Number(numParcelas);
                        const vlrGlobal = Number(contrFornData.contrForn_vlrGlobal) || 0;
                        let nextValorCadaParcela = valorCadaParcelaCotacaoRapida;

                        if (
                          numParcelas
                          && Number.isInteger(numParcelasNumber)
                          && numParcelasNumber > 0
                          && vlrGlobal > 0
                        ) {
                          nextValorCadaParcela = String(
                            Number((vlrGlobal / numParcelasNumber).toFixed(2)),
                          );
                        }

                        setContrFornData({
                          ...contrFornData,
                          contrForn_numParcelas: numParcelas || null,
                        });
                        setValorCadaParcelaCotacaoRapida(nextValorCadaParcela);
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col sm={4}>
                  <FormGroup>
                    <Label>Valor de cada parcela</Label>
                    <MaskedInput
                      unmask
                      mask="num"
                      disabled={isReadOnlyMode}
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          radix: ',',
                          min: 0,
                        },
                      }}
                      value={valorCadaParcelaCotacaoRapida ? String(valorCadaParcelaCotacaoRapida) : null}
                      onAccept={(value) => setValorCadaParcelaCotacaoRapida(value)}
                    />
                  </FormGroup>
                </Col>
                <Col sm={3} className="d-flex align-items-end pb-3">
                  <Button
                    color="primary"
                    disabled={isReadOnlyMode}
                    onClick={handleGerarParcelasCotacaoRapida}
                  >
                    Gerar parcelas
                  </Button>
                </Col>
                <Col sm={12}>
                  <FormGroup>
                    <Label>Anexo (NF da compra)</Label>
                    {!isReadOnlyMode ? (
                      <AddFiles
                        multiple={false}
                        files={nfCompraFilesContrForn}
                        onFilesChange={setNfCompraFilesContrForn}
                      />
                    ) : nfCompraFilesContrForn?.length > 0 ? (
                      nfCompraFilesContrForn.map((file) => (
                        <Typography key={file?.props?.id || file?.props?.name} variant="body2">
                          {file?.props?.name || 'Anexo'}
                        </Typography>
                      ))
                    ) : (
                      <Typography variant="body2" color="text.secondary">Nenhum anexo</Typography>
                    )}
                  </FormGroup>
                </Col>
                <Col sm={12}>
                  <FormGroup>
                    <div className="d-flex align-items-center">
                      <Label className="mb-0 mr-1">Proposta comercial</Label>
                      <Tooltip
                        title="Pode ser um PDF, um print de troca de e-mails negociando o contrato, um print do site de venda do produto, prints de WhatsApp ou qualquer outra evidência da negociação."
                      >
                        <IconButton size="small" type="button" aria-label="Ajuda sobre proposta comercial">
                          <InfoOutlined fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </div>
                    {!isReadOnlyMode ? (
                      <AddFiles
                        multiple={false}
                        files={propostaComercialFilesContrForn}
                        onFilesChange={setPropostaComercialFilesContrForn}
                      />
                    ) : propostaComercialFilesContrForn?.length > 0 ? (
                      propostaComercialFilesContrForn.map((file) => (
                        <Typography key={file?.props?.id || file?.props?.name} variant="body2">
                          {file?.props?.name || 'Proposta comercial'}
                        </Typography>
                      ))
                    ) : (
                      <Typography variant="body2" color="text.secondary">Nenhum anexo</Typography>
                    )}
                  </FormGroup>
                </Col>
              </>
              )}

              <Col sm={12}>
                <FormGroup>
                  <Label>
                    Objeto resumido do contrato
                  </Label>
                  <Input
                    type="text"
                    placeholder="Objeto resumido do contrato..."
                    value={trimContrFornDesc()}
                    disabled={isReadOnlyMode}
                    onChange={(e) => setContrFornData({ ...contrFornData, contrForn_desc: e.target.value })}
                  />
                </FormGroup>
              </Col>

              {!effectiveHideContratoObjeto && (
              <Col sm={12}>
                <Label>
                  Objeto do contrato
                </Label>
                <TextareaAutosize
                  placeholder='Descreva o objeto do contrato'
                  margin="dense"
                  id="input_obs"
                  name="input_obs"
                  variant="standard"
                  value={contrFornData.contrForn_obj || null}
                  className='mb-3 p-1'
                  style={{ width: '100%', height: '100px' }}
                  readOnly={isReadOnlyMode}
                  onChange={(e) => setContrFornData({ ...contrFornData, contrForn_obj: e.target.value })}
                />
              </Col>
              )}

              {!effectiveHideContratoDetalhamento && (
              <Col sm={12}>
                <FormGroup>
                  <Label>
                    Campo de detalhamento do serviço
                  </Label>
                  <TextareaAutosize
                    placeholder='Detalhamento do serviço...'
                    margin="dense"
                    id="input_obs"
                    name="input_obs"
                    variant="standard"
                    value={contrFornData.contrForn_detalhamento || null}
                    className='mb-3 p-1'
                    style={{ width: '100%', height: '100px' }}
                    readOnly={isReadOnlyMode}
                    onChange={(e) => setContrFornData({ ...contrFornData, contrForn_detalhamento: e.target.value })}
                  />
                </FormGroup>
              </Col>
              )}

              {showEquipeContrFornFields && (
                <>
                  {renderContrFornSelectField('Continuidade', 'contrForn_continuidade', CONTR_FORN_CONTINUIDADE_OPTIONS)}
                  {renderContrFornSelectField('Haverá necessidade de presença recorrente?', 'contrForn_presencaRecorrente', CONTR_FORN_PRESENCA_RECORRENTE_OPTIONS)}
                  {renderContrFornSelectField('Como a execução será comprovada?', 'contrForn_comprovacaoExecucao', CONTR_FORN_COMPROVACAO_EXECUCAO_OPTIONS)}
                  {renderContrFornSelectField('Modelo de cobrança', 'contrForn_modeloCobranca', CONTR_FORN_MODELO_COBRANCA_OPTIONS)}
                  {renderContrFornSelectField('Comprovação da cobrança', 'contrForn_comprovacaoCobranca', CONTR_FORN_COMPROVACAO_COBRANCA_OPTIONS)}
                  {renderContrFornSelectField('Qual será a data de pagamento?', 'contrForn_dataPagamento', CONTR_FORN_DATA_PAGAMENTO_OPTIONS)}
                  <Col sm={4}>
                    <FormGroup>
                      <Label>Benefícios</Label>
                      <Select
                        classNamePrefix="select2-selection"
                        placeholder="Selecione"
                        isMulti
                        isClearable
                        isDisabled={isReadOnlyMode}
                        closeMenuOnSelect={false}
                        value={CONTR_FORN_BENEFICIOS_OPTIONS.filter((option) => (
                          (contrFornData.contrForn_beneficios || []).includes(option.value)
                        ))}
                        options={CONTR_FORN_BENEFICIOS_OPTIONS}
                        onChange={(options) => setContrFornData({
                          ...contrFornData,
                          contrForn_beneficios: (options || []).map((option) => option.value),
                        })}
                      />
                    </FormGroup>
                  </Col>
                  {renderContrFornSelectField('Haverá reembolso de despesas?', 'contrForn_reembolsoDespesas', CONTR_FORN_REEMBOLSO_DESPESAS_OPTIONS)}
                  {renderContrFornSelectField('A prestadora poderá atender terceiros?', 'contrForn_atenderTerceiros', CONTR_FORN_ATENDER_TERCEIROS_OPTIONS)}
                  {renderContrFornSelectField('A prestadora poderá utilizar equipe ou prepostos?', 'contrForn_utilizarEquipePrepostos', CONTR_FORN_UTILIZAR_EQUIPE_PREPOSTOS_OPTIONS)}
                  {renderContrFornSelectField('Há contrato/aditivo anterior?', 'contrForn_contratoAditivoAnterior', CONTR_FORN_CONTRATO_ADITIVO_ANTERIOR_OPTIONS)}
                </>
              )}

              {/*
              <Col sm={4}>
                <FormGroup>
                  <Label>
                    Data da assinatura
                  </Label>
                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={contrFornData.contrForn_dtAssin ? moment(contrFornData.contrForn_dtAssin).toDate() : null}
                    onChange={date => {
                      if (date) {
                        setContrFornData({ ...contrFornData, contrForn_dtAssin: moment(date).format('YYYY-MM-DD') });
                      } else {
                        setContrFornData({ ...contrFornData, contrForn_dtAssin: null });
                      }
                    }}
                  />
                </FormGroup>
              </Col>
              */}

              {!effectiveHideTipoContrato && (
              <Col className="pt-4" sm={12}>
                <FormGroup>
                  <Label>
                    Tipo de contrato
                  </Label>
                  <Select
                    classNamePrefix="select2-selection"
                    placeholder="Selecione um item"
                    isDisabled={isReadOnlyMode}
                    value={selTipoContrato ? selTipoContrato.filter(x => (x.value === contrFornData.contrFornTp_id)) : null}
                    options={selTipoContrato}
                    onChange={(e) => {
                      if (e.value === 1 || e.value === 5) {
                        if (listaParcelas.length > 0) {
                          listaParcelas.map((p) => {
                            p.contrFornEvento_liberacaoAutomatica = 0;
                            p.contrFornEvento_nf = undefined;
                            return p;
                          })
                        }
                        return setContrFornData({ ...contrFornData, contrFornTp_id: e.value, contrForn_dtPgtoFixa: 0 });
                      }
                      return setContrFornData({ ...contrFornData, contrFornTp_id: e.value})
                    }}
                  />
                </FormGroup>
              </Col>
              )}

              {!hideContratoValorFixoOpcao && (
              <Col className="d-flex align-items-center pt-4" sm={4}>
                <span className="mr-2">O valor global do contrato não é fixo?</span>
                <input type="checkbox" name="valor-fixo" checked={contrFornData.contrForn_vlrFixo === 0} id="valor-fixo" onChange={(e) => {setContrFornData({...contrFornData, contrForn_vlrFixo: e.target.checked ? 0 : 1})}}/>
              </Col>
              )}

              {!hideContratoDiaFixoPagamentoOpcao && (
              <Col className="d-flex align-items-center pt-4" sm={4}>
                <span className="mr-2">O contrato prevê que as parcelas possuem dia fixo para pagamento?</span>
                <input type="checkbox" name="data-fixa" checked={contrFornData.contrForn_dtPgtoFixa === 1} id="data-fixa" onChange={(e) => {setContrFornData({...contrFornData, contrForn_dtPgtoFixa: e.target.checked ? 1 : 0})}}/>
              </Col>
              )}

              {!hideContratoRenovacaoAutomaticaOpcao && (
              <Col className="d-flex align-items-center pt-4" sm={4}>
                <span className="mr-2">Renovação automática?</span>
                <input type="checkbox" name="valor-fixo" checked={contrFornData.contrForn_renovacaoAutomatica === 1} id="valor-fixo" onChange={(e) => {setContrFornData({...contrFornData, contrForn_renovacaoAutomatica: e.target.checked ? 1 : 0})}}/>
              </Col>
              )}

              {!hideContratoNfUnicaOpcao && (
              <Col className="d-flex align-items-center pt-4" sm={4}>
                <span className="mr-2">Uma Nota Fiscal para todas as parcela?</span>
                <input type="checkbox" name="valor-fixo" checked={contrFornData.contrForn_umaNFParaTodasAsParcela === 1} id="valor-fixo" onChange={(e) => {
                  setContrFornData({...contrFornData, contrForn_umaNFParaTodasAsParcela: e.target.checked ? 1 : 0});
                  setListaParcelas(listaParcelas.map((p) => {
                    p.contrFornEvento_nf = undefined;
                    return p;
                  }))
                }}/>
              </Col>
              )}

              {!hideContratoMaoObraLocalOpcao && (
              <Col className="d-flex align-items-center pt-4" sm={4}>
                <span className="mr-2">A mão de Obra é Local?</span>
                <input type="checkbox" name="valor-fixo" id="valor-fixo" onChange={(e) => {setContrFornData({...contrFornData, contrForn_maoObraLocal: e.target.checked ? 0 : 1})}}/>
              </Col>
              )}

              {
                !hideContratoDiaFixoPagamentoOpcao && contrFornData.contrForn_dtPgtoFixa ?
                <Col className="pt-4" sm={4}>
                  <FormGroup>
                    <Label>
                      Periodicidade
                    </Label>
                    <Select
                      classNamePrefix="select2-selection"
                      isClearable
                      isDisabled={isReadOnlyMode}
                      placeholder="Selecione um item"
                      value={contrFornData.contrForn_periodicidade ? [{label: "Mensal", value: "Mensal"},{label: "Bimestral", value: "Bimestral"},{label: "Trimestral", value: "Trimestral"},{label: "Quadrimestral", value: "Quadrimestral"},{label: "Semestral", value: "Semestral"},{label: "Anual", value: "Anual"}].filter(x => (x.value === contrFornData.contrForn_periodicidade)) : null}
                      options={[{label: "Mensal", value: "Mensal"},{label: "Bimestral", value: "Bimestral"},{label: "Trimestral", value: "Trimestral"},{label: "Quadrimestral", value: "Quadrimestral"},{label: "Semestral", value: "Semestral"},{label: "Anual", value: "Anual"}]}
                      onChange={(e) => {
                        if (e) {
                          setContrFornData({ ...contrFornData, contrForn_periodicidade: e.value });
                        } else {
                          setContrFornData({ ...contrFornData, contrForn_periodicidade: null });
                        }
                      }}
                    />
                  </FormGroup>
                </Col> : <></>
              }

              {
                !hideContratoDiaFixoPagamentoOpcao && contrFornData.contrForn_dtPgtoFixa ?
                <Col className="pt-4" sm={4}>
                  <FormGroup>
                    <Label>
                      Dia do mês para o vencimento?
                    </Label>
                    {userPodeDigitarDiaVencimento ? (
                      <Input
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength={2}
                        placeholder="Dia do mês..."
                        disabled={isReadOnlyMode}
                        value={contrFornData.contrForn_diaVencPgtos || ''}
                        onChange={(e) => {
                          const diaVencimento = e.target.value.replace(/\D/g, '');

                          if (!diaVencimento) {
                            return setContrFornData({ ...contrFornData, contrForn_diaVencPgtos: null });
                          }

                          const diaVencimentoNumber = Number(diaVencimento);

                          if (diaVencimentoNumber >= 1 && diaVencimentoNumber <= 31) {
                            setContrFornData({ ...contrFornData, contrForn_diaVencPgtos: diaVencimentoNumber });
                          }
                        }}
                      />
                    ) : (
                      <Select
                        classNamePrefix="select2-selection"
                        isClearable
                        isDisabled={isReadOnlyMode}
                        placeholder="Selecione um item"
                        value={diasVencimentoPadraoOptions.find(x => x.value === Number(contrFornData.contrForn_diaVencPgtos)) || null}
                        options={diasVencimentoPadraoOptions}
                        onChange={(e) => {
                          if (e) {
                            setContrFornData({ ...contrFornData, contrForn_diaVencPgtos: e.value });
                          } else {
                            setContrFornData({ ...contrFornData, contrForn_diaVencPgtos: null });
                          }
                        }}
                      />
                    )}
                  </FormGroup>
                </Col> : <></>
              }

              {
                !hideContratoDiaFixoPagamentoOpcao && contrFornData.contrForn_dtPgtoFixa ?
                <Col className="pt-4" sm={4}>
                  <FormGroup>
                    <Label>
                      Número de parcelas
                    </Label>
                    <Input
                      type="number"
                      placeholder="Número de parcelas..."
                      disabled={isReadOnlyMode}
                      value={contrFornData.contrForn_numParcelas}
                      onChange={(e) => setContrFornData({...contrFornData, contrForn_numParcelas: e.target.value})}
                    />
                  </FormGroup>
                </Col> : <></>
              }

              {
                !hideContratoDiaFixoPagamentoOpcao && contrFornData.contrForn_dtPgtoFixa ?
                <Col className="pt-4" sm={4}>
                  <FormGroup>
                    <Button onClick={(e)=>{handleAddParcelasByPeriod(Number(contrFornData.contrForn_vlrGlobal).toFixed(2), contrFornData.contrForn_dtVigIni, contrFornData.contrForn_periodicidade, Number(contrFornData.contrForn_diaVencPgtos).toFixed(0), Number(contrFornData.contrForn_numParcelas).toFixed(0) )}}>Gerar parcelas</Button>
                  </FormGroup>
                </Col> : <></>
              }

              {!effectiveHideObservacao && (
              <Col sm={12} className="pt-4">
                <Label>
                  Observação
                </Label>
                <TextareaAutosize
                  placeholder='Observações...'
                  margin="dense"
                  id="input_obs"
                  name="input_obs"
                  variant="standard"
                  className='mb-3 p-1'
                  value={contrFornData.contrForn_obs || null}
                  style={{ width: '100%', height: '100px' }}
                  readOnly={isReadOnlyMode}
                  onChange={(e) => setContrFornData({ ...contrFornData, contrForn_obs: e.target.value })}
                />
              </Col>
              )}

              {!effectiveHideDocumentoContrato && (
              <Col sm={12}>
                <FormGroup>
                  <Label>
                    Documento do contrato
                  </Label>
                  {!isReadOnlyMode ? (
                  <AddFiles
                    multiple={true}
                    //accept={['.pdf']}
                    files={filesContrForn} // Pass state
                    onFilesChange={setFilesContrForn} // Update state
                  />
                  ) : filesContrForn?.length > 0 ? (
                    filesContrForn.map((file) => (
                      <Typography key={file?.props?.id || file?.props?.name} variant="body2">
                        {file?.props?.name || 'Anexo'}
                      </Typography>
                    ))
                  ) : (
                    <Typography variant="body2" color="text.secondary">Nenhum anexo</Typography>
                  )}
                  {/* <AddFiles
                    multiple={true}
                    //accept={['.pdf']}
                    files={filesContrForn} // Pass state
                    onFilesChange={setFilesContrForn} // Update state
                  /> */}
                </FormGroup>
              </Col>
              )}

              {!hideContratoNfUnicaOpcao && contrFornData.contrForn_umaNFParaTodasAsParcela ?
              <Col sm={12} className="pt-4">
                <FormGroup>
                  <Label>
                    Nota Fiscal única para todas as parcelas
                  </Label>
                  {!isReadOnlyMode ? (
                  <AddFiles
                    multiple={false}
                    //accept={['.pdf']}
                    files={nfUnicaFilesContrForn} // Pass state
                    onFilesChange={setNfUnicaFilesContrForn} // Update state
                  />
                  ) : nfUnicaFilesContrForn?.length > 0 ? (
                    nfUnicaFilesContrForn.map((file) => (
                      <Typography key={file?.props?.id || file?.props?.name} variant="body2">
                        {file?.props?.name || 'Anexo'}
                      </Typography>
                    ))
                  ) : (
                    <Typography variant="body2" color="text.secondary">Nenhum anexo</Typography>
                  )}
                  {/* <AddFiles
                    multiple={true}
                    //accept={['.pdf']}
                    files={filesContrForn} // Pass state
                    onFilesChange={setFilesContrForn} // Update state
                  /> */}
                </FormGroup>
              </Col> : <></>
              }

              {renderTabelaOrcamentoMensal()}

              {!effectiveHideParcelasTable && (
                <Col sm={12}>
                  <MaterialReactTable
                    columns={columnsParcelas}
                    data={listaParcelas}
                    initialState={{
                      density: 'compact',
                      expanded: {}, //expand all groups by default
                      pagination: { pageIndex: 0, pageSize: 50 },
                      sorting: [{ id: 'contrFornEvento_num', desc: false }], //sort by state by default
                    }}
                    enableGrouping={false}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    enablePagination={(listaParcelas.length > 50)}
                    muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '[class="MuiSvgIcon-root"]': {width: '24px !important'}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                    renderTopToolbarCustomActions={() => (
                      isReadOnlyMode ? null : (
                      <Box marginLeft="auto">
                        <IconButton style={{backgroundColor: "rgba(51, 153, 51, 0.92)", color: "white"}} onClick={handleAddParcela}>
                          <Add/>
                        </IconButton>
                      </Box>
                      )
                    )}
                    muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Produtos por página</span>,
                      rowsPerPageOptions: [50, 100],
                    }}
                    positionPagination='bottom'
                    muiTablePaperProps={{sx: {boxShadow: 'none'}}}
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableRowExpansion={true}
                    enableDensityToggle={false}
                    enableColumnFilters={false}
                    muiTableHeadCellProps={{
                      sx: {
                        '.MuiSvgIcon-root': {fontSize: "18px"},
                        fontSize: '12px',
                        fontWeight: 'normal', // Remove bold text in the header
                        padding: '8px', // Adjust padding to reduce white space
                      },
                    }}
                    renderDetailPanel={({ row }) => {
                      const p = row.original;
                      return (
                        <Box p={2}>
                          <fieldset disabled={isReadOnlyMode} style={{ border: 0, margin: 0, padding: 0, minWidth: 0 }}>
                          <Row>
                            <Col md={4} className="pt-4">
                              <FormGroup>
                                <Label for="desc">Descrição</Label>
                                <Input
                                  id="desc"
                                  disabled={isReadOnlyMode}
                                  value={p.contrFornEvento_desc ?? ''}
                                  onChange={e =>
                                    handleDetailChange(row.index, 'contrFornEvento_desc', e.target.value)
                                  }
                                />
                              </FormGroup>
                            </Col>

                            <Col md={4} className="pt-4">
                              <FormGroup>
                                <Label for="vlr">Valor</Label>
                                <MaskedInput
                                  unmask
                                  mask="num"
                                  disabled={isReadOnlyMode}
                                  blocks={{
                                    num: {
                                      mask: Number,
                                      scale: 2,
                                      signed: false,
                                      thousandsSeparator: '.',
                                      radix: ',',
                                      min: 0,
                                    },
                                  }}
                                  value={p.contrFornEvento_vlr ? String(p.contrFornEvento_vlr) : null}
                                  onAccept={value =>
                                    handleDetailChange(row.index, 'contrFornEvento_vlr', Number(value))
                                  }
                                />
                              </FormGroup>
                            </Col>

                            {
                              bdrosVinculaveis.length > 0 &&
                              <Col className="d-flex align-items-center pt-4" sm={4}>
                                <span className="mr-2">Deseja vincular a um Borderô já existente?</span>
                                <input
                                  type="checkbox"
                                  checked={p.contrFornEvento_vincularBdroExistente === 1 || !!p.bdro_id}
                                  onChange={(e) => {
                                    handleDetailChange(row.index, 'contrFornEvento_vincularBdroExistente', e.target.checked ? 1 : 0);
                                    if (!e.target.checked) {
                                      handleDetailChange(row.index, 'bdro_id', null);
                                    }
                                  }}
                                />
                              </Col>
                            }

                            {
                              bdrosVinculaveis.length > 0 && (p.contrFornEvento_vincularBdroExistente === 1 || !!p.bdro_id) &&
                              <Col md={4} className="pt-4">
                                <FormGroup>
                                  <Label>Borderô</Label>
                                  <Select
                                    classNamePrefix="select2-selection"
                                    placeholder="Selecione um borderô"
                                    isClearable
                                    isDisabled={isReadOnlyMode}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                      menu: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    value={p.bdro_id ? getBdroOptionsParaParcela(row.index).filter(x => Number(x.value) === Number(p.bdro_id)) : null}
                                    options={getBdroOptionsParaParcela(row.index)}
                                    onChange={(e) => {
                                      handleDetailChange(row.index, 'bdro_id', e ? e.value : null);
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            }

                            <Col className="d-flex align-items-center pt-4" sm={4}>
                              <span className="mr-2">A parcela depende da execução de uma atividade?</span>
                              <input
                                type="checkbox"
                                name="data-fixa"
                                id="data-fixa"
                                checked={p.contrFornEvento_dependeAtividade === 1}
                                onChange={(e) => {
                                  handleDetailChange(row.index, 'contrFornEvento_dependeAtividade', e.target.checked ? 1 : 0);
                                  if (!e.target.checked) {
                                    handleDetailChange(row.index, 'contrFornEvento_dtPrev', null);
                                    handleDetailChange(row.index, 'contrFornEvento_pgtoPrazoDias', null);
                                  }
                                }}
                              />
                            </Col>

                            {
                              p.contrFornEvento_dependeAtividade === 1 ?
                              <>
                                <Col sm={4} className="pt-4">
                                  <FormGroup>
                                    <Label>
                                      Data Prevista p/ realização da atividade
                                    </Label>
                                    <DatePicker
                                      placeholderText="__/__/_____"
                                      locale="pt-BR"
                                      className="form-control"
                                      dateFormat="dd/MM/yyyy"
                                      popperContainer={()=><></>}
                                      dropdownMode="select"
                                      disabled={isReadOnlyMode}
                                      selected={p.contrFornEvento_dtPrev ? moment(p.contrFornEvento_dtPrev).toDate() : null}
                                      onChange={date => {
                                        handleDetailChange(row.index, 'contrFornEvento_dtPrev', date ? moment(date).format('YYYY-MM-DD') : null);
                                      }}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={4} className="pt-4">
                                  <FormGroup>
                                    <Label for="prazo">{'Prazo p/ pagamento após a realização da atividade (dias)'}</Label>
                                    <Input
                                      type='number'
                                      id="prazo"
                                      disabled={isReadOnlyMode}
                                      value={p.contrFornEvento_pgtoPrazoDias ?? ''}
                                      onChange={e =>
                                        handleDetailChange(row.index, 'contrFornEvento_pgtoPrazoDias', e.target.value)
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </> :
                              <Col sm={4} className="pt-4">
                                <FormGroup>
                                  <Label>
                                    Data Prevista p/ realização do pagamento
                                  </Label>
                                  <DatePicker
                                    placeholderText="__/__/_____"
                                    locale="pt-BR"
                                    className="form-control"
                                    dateFormat="dd/MM/yyyy"
                                    popperContainer={()=><></>}
                                    dropdownMode="select"
                                    disabled={isReadOnlyMode}
                                    selected={p.contrFornEvento_dtPrev ? moment(p.contrFornEvento_dtPrev).toDate() : null}
                                    onChange={date => {
                                      handleDetailChange(row.index, 'contrFornEvento_dtPrev', date ? moment(date).format('YYYY-MM-DD') : null);
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            }

                            {
                              contrFornData.contrFornTp_id !== 1 && contrFornData.contrFornTp_id !== 5 &&
                              <Col className="d-flex align-items-center pt-4" sm={4}>
                                <span className="mr-2">A parcela possui liberação automática?</span>
                                <input
                                  type="checkbox"
                                  name="data-fixa"
                                  id="data-fixa"
                                  checked={p.contrFornEvento_liberacaoAutomatica === 1}
                                  onChange={(e) => {
                                    handleDetailChange(row.index, 'contrFornEvento_liberacaoAutomatica', e.target.checked ? 1 : 0);
                                    if (!e.target.checked) {
                                      handleDetailChange(row.index, 'contrFornEvento_nf', []);
                                    }
                                  }}
                                />
                              </Col>
                            }

                            {
                              p.contrFornEvento_liberacaoAutomatica === 1 && !contrFornData.contrForn_umaNFParaTodasAsParcela &&
                              <Col md={4} className="pt-4">
                                <FormGroup>
                                  <Label for="prazo">Adicione a Nota Fiscal</Label>
                                  {!isReadOnlyMode ? (
                                  <AddFiles
                                    multiple={false}
                                    //accept={['.pdf']}
                                    files={p.contrFornEvento_nf} // Pass state
                                    onFilesChange={(e) => {handleDetailChange(row.index, 'contrFornEvento_nf', e)}} // Update state
                                  />
                                  ) : p.contrFornEvento_nf?.length > 0 ? (
                                    p.contrFornEvento_nf.map((file) => (
                                      <Typography key={file?.props?.id || file?.props?.name} variant="body2">
                                        {file?.props?.name || 'Anexo'}
                                      </Typography>
                                    ))
                                  ) : (
                                    <Typography variant="body2" color="text.secondary">Nenhum anexo</Typography>
                                  )}
                                </FormGroup>
                              </Col>
                            }

                            {/*
                              <Col className="d-flex align-items-center pt-4" sm={4}>
                                <span className="mr-2">A parcela possui data de pagamento específica?</span>
                                <input
                                  type="checkbox"
                                  name="data-fixa"
                                  id="data-fixa"
                                  checked={p.contrFornEvento_pgtoEspecifica === 1}
                                  onChange={(e) => {
                                    handleDetailChange(row.index, 'contrFornEvento_pgtoEspecifica', e.target.checked ? 1 : 0);
                                    if (!e.target.checked) {
                                      handleDetailChange(row.index, 'contrFornEvento_dtPgtoEspecifica', null);
                                    }
                                  }}
                                />
                              </Col>
                            <Col md={12}>
                              <FormGroup>
                                <div className='d-flex justify-content-between align-items-center'>
                                  <div className='d-flex'>
                                    <span className='mr-2'>Necessidade evidência de aprovação?</span>
                                    <input
                                      type="checkbox"
                                      placeholder="Necessidade evidência de aprovação?"
                                      checked={p.contrFornEvento_aprovNecessita === 1}
                                      onChange={e => {
                                        if (e.target.checked) {
                                          return handleDetailChange(row.index, 'contrFornEvento_aprovNecessita', 1);
                                        }
                                        return handleDetailChange(row.index, 'contrFornEvento_aprovNecessita', 0);
                                      }}
                                      style={{ padding: '0.5rem', borderRadius: '4px', border: '1px solid #ccc' }}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </Col>
                            */}
                          </Row>
                          </fieldset>
                        </Box>
                      );
                    }}
                  />
                </Col>
              )}
              </>
              )}
            </Row>
            </fieldset>

              {isSupplierInfoValidationMode && validationStep === 2 && (
                <FormGroup check className="mt-3">
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={validationChecks[2]}
                      onChange={(e) => setValidationCheck(2, e.target.checked)}
                    />
                    {' '}
                    Confirmo os entregáveis e informações contratuais
                  </Label>
                </FormGroup>
              )}
            </>
              )}
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => {
            //handleCloseModalProdutos();
            handleClickCloseModal();
            setContrFornData({contrForn_dtPgtoFixa: 0})
          }}>
            Fechar
          </Button>
          {isAguardandoInfoFornecedor ? (
            <Button
              color="primary"
              disabled={isCopyingFormLink}
              onClick={handleCopyFormularioFornecedorLink}
            >
              {isCopyingFormLink ? 'Copiando...' : 'Copiar link do formulário'}
            </Button>
          ) : loadingSubmit ? (
            <Spinner />
          ) : isSupplierInfoValidationMode ? (
            <>
              {validationStep > 1 && (
                <Button color="secondary" className="mr-2" onClick={handleValidationPrevious}>
                  Anterior
                </Button>
              )}
              {validationStep < 2 ? (
                step1ValidationAnswer === 'nao' ? (
                  <Button
                    color="danger"
                    disabled={!String(step1RejectionJustification || '').trim()}
                    onClick={handleRejectSupplierValidation}
                  >
                    Rejeitar
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    disabled={step1ValidationAnswer !== 'sim' || isUpsertingSupplierParte}
                    onClick={handleValidationNext}
                  >
                    {isUpsertingSupplierParte ? 'Salvando...' : 'Próximo'}
                  </Button>
                )
              ) : (
                <Button
                  color="primary"
                  disabled={
                    !allValidationChecksComplete
                    || (!isMinutaFornecedor && !Number(contrFornData.minutaMod_id))
                  }
                  onClick={() => handleSubmitContrForn()}
                >
                  Confirmar contratação
                </Button>
              )}
            </>
          ) : (
            <>
              {/* <Button
                color="secondary"
                style={{ marginRight: '10px' }}
                onClick={handleSaveDraft}
              >
                Salvar Rascunho
              </Button>
              <Button
                color="secondary"
                onClick={handleGeneratePdf}
              >
                Gerar PDF
              </Button>
              */}
              {!isReadOnlyMode && !contrFornData.contrForn_id && !isCompraCotacaoContratacao && (
              <Button
                color="secondary"
                className="mr-2"
                onClick={() => handleSubmitContrForn({ criarContratoParaAprovacao: true })}
              >
                Criar contrato
              </Button>
              )}
              {!isReadOnlyMode && (
              <Button
                color="primary"
                onClick={() => handleSubmitContrForn(
                  isFormularioSemContrato ? { criarContratoParaAprovacao: true } : undefined,
                )}
              >
                {primarySubmitLabel}
              </Button>
              )}
            </>
          )}
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={isSolicitarOrcItemOpen}
        toggle={handleCloseSolicitarOrcItem}
      >
        <ModalHeader toggle={handleCloseSolicitarOrcItem}>
          Solicitar criação de um item orçamentário
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="mensagem-solicitacao-orc-item">
              Mensagem do solicitante
            </Label>
            <TextareaAutosize
              id="mensagem-solicitacao-orc-item"
              minRows={4}
              placeholder="Descreva o item orçamentário que precisa ser criado..."
              value={mensagemSolicitacaoOrcItem}
              disabled={sendingSolicitacaoOrcItem}
              className="p-2"
              style={{ width: '100%' }}
              onChange={(event) => setMensagemSolicitacaoOrcItem(event.target.value)}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            disabled={sendingSolicitacaoOrcItem}
            onClick={handleCloseSolicitarOrcItem}
          >
            Cancelar
          </Button>
          <Button
            color="primary"
            disabled={sendingSolicitacaoOrcItem}
            onClick={handleEnviarSolicitacaoOrcItem}
          >
            {sendingSolicitacaoOrcItem ? 'Enviando...' : 'Enviar solicitação'}
          </Button>
        </ModalFooter>
      </Modal>

      <ModalConfirmacao
        openModal={isAvisoNfVaziaOpen}
        title="Aviso"
        text="Campo de Anexo de Nota Fiscal está vazio. Deseja prosseguir?"
        confirmButtonText="Sim"
        cancelButtonText="Não"
        onClosed={() => setIsAvisoNfVaziaOpen(false)}
        onConfirm={() => {
          setIsAvisoNfVaziaOpen(false);
          handleSubmitContrForn({
            ...submitOptionsRef.current,
            ignorarAvisoNfVazia: true,
          });
        }}
        isLoading={loadingSubmit}
      />

      <ModalConfirmacao
        openModal={isAvisoSaldoMensalOpen}
        title="Aviso"
        text="Alguma parcela está excedendo o valor referente ao seu mês correspondente. Deseja prosseguir com o cadastro?"
        onClosed={() => setIsAvisoSaldoMensalOpen(false)}
        onConfirm={() => {
          setIsAvisoSaldoMensalOpen(false);
          handleSubmitContrForn({
            ...submitOptionsRef.current,
            ignorarAvisoSaldoMensal: true,
          });
        }}
        confirmButtonText="Prosseguir"
        cancelButtonText="Fechar e corrigir"
        isLoading={loadingSubmit}
      />

      {props.standalone && (
        <>
          <Modal
            isOpen={isAvisoSemBdroOpen}
            toggle={() => setIsAvisoSemBdroOpen(false)}
          >
            <ModalHeader toggle={() => setIsAvisoSemBdroOpen(false)}>
              Aviso
            </ModalHeader>
            <ModalBody>
              Você não vinculou nenhum borderô nas parcelas do contrato. Deseja continuar com o cadastro?
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={() => setIsAvisoSemBdroOpen(false)}>
                Voltar
              </Button>
              <Button
                color="primary"
                onClick={() => {
                  setIsAvisoSemBdroOpen(false);
                  handleSubmitContrForn({
                    ...submitOptionsRef.current,
                    ignorarAvisoSemBdro: true,
                    ignorarAvisoSaldoMensal: true,
                  });
                }}
              >
                Continuar
              </Button>
            </ModalFooter>
          </Modal>
        </>
      )}
    </>
  )
}

export default ModalFormContrForn;
